/* Options:
Date: 2025-08-22 11:39:01
Version: 5.132
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:44353

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
ExcludeTypes: GetInstitutionPersonnelEmailAddresses,InstitutionPersonnelEmailAddressesResponse,SendRegistrationEmail,SendRandomisationEmail,SaeGetIncompleteFormCollection,SaeGetIncompleteFormCollectionResponse,GetEnrolmentStatusReport,EnrolmentStatusReportResponse,GetTrialCoordinatingGroupRegistrationEmailAddresses,GetTrialCoordinatingGroupRandomisationEmailAddresses,GetTrialCoordinatingGroupScreeningEmailAddresses,TrialCoordinatingGroupEmailAddressesResponse
//DefaultImports: 
*/


export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IGet
{
}

export interface IPost
{
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IPut
{
}

export interface IDelete
{
}

export interface ITemplateData
{
}

export interface IHasPatientId
{
    patientId?: number;
}

export enum ErrorType
{
    Warning = 1,
    Ineligible = 2,
    Normal = 3,
    StratificationFailure = 4,
    Critical = 5,
}

export class Error
{
    public id?: number;
    public type?: ErrorType;
    public message: string;
    // @References("typeof(Neon.ServiceModel.Types.Error)")
    public innerExceptionId?: number;

    public stackTrace: string;
    public dateAdded?: string;
    public url: string;
    public urlReferrer: string;
    public userAddress: string;
    public userAgent: string;
    public data: string;
    public username: string;
    public innerException: Error;

    public constructor(init?: Partial<Error>) { (Object as any).assign(this, init); }
}

export class MultipleRandomisationEmailData
{
    public institutionName: string;
    public randomisationDate: string;
    public participationNumber: string;

    public constructor(init?: Partial<MultipleRandomisationEmailData>) { (Object as any).assign(this, init); }
}

export interface IReportRequest
{
    token: string;
}

export class Drug
{
    public id?: number;
    public drugName: string;
    public unitsPerShippingContainer: number;
    public containerName: string;
    public unitConcentration: number;
    public unitVolume: number;
    public enableDrugShipmentGeneration: boolean;

    public constructor(init?: Partial<Drug>) { (Object as any).assign(this, init); }
}

export class Batch
{
    public id?: number;
    public drugId?: number;
    public batchNo: string;
    public dateExpiration?: string;
    public allocationCutOffDate?: string;
    public available: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drug: Drug;

    public constructor(init?: Partial<Batch>) { (Object as any).assign(this, init); }
}

export class DepotBatch
{
    public id?: number;
    public depotId: number;
    public batchId: number;
    public depotBatchNo?: number;
    public drugUnitsTotal: number;
    public drugUnitsAllocated: number;
    public drugUnitsDestroyed: number;
    public available: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public batch: Batch;

    public constructor(init?: Partial<DepotBatch>) { (Object as any).assign(this, init); }
}

export class OrderForm
{
    public id?: number;
    public orderFormName: string;

    public constructor(init?: Partial<OrderForm>) { (Object as any).assign(this, init); }
}

export class Depot
{
    public id?: number;
    public depotName: string;
    public address: string;
    public email: string;
    public contactName: string;
    public phoneNo: string;
    public orderFormId: number;
    public active?: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public orderForm: OrderForm;

    public constructor(init?: Partial<Depot>) { (Object as any).assign(this, init); }
}

export enum PharmacyStatus
{
    Inactive = 1,
    Open = 2,
    Closed = 3,
}

export class PharmacyDrug
{
    public id?: number;
    public pharmacyId: number;
    public drugId: number;
    public capacity: number;
    public minThreshold: number;
    public enabled: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drug: Drug;

    public constructor(init?: Partial<PharmacyDrug>) { (Object as any).assign(this, init); }
}

export class Pharmacy
{
    public id?: number;
    public depotId: number;
    public institutionCode: string;
    public eclipseSiteNo: string;
    public pharmacyName: string;
    public pharmacistPersonId?: number;
    public pharmacyStatus?: PharmacyStatus;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public pharmacyDrugs: PharmacyDrug[];

    public constructor(init?: Partial<Pharmacy>) { (Object as any).assign(this, init); }
}

export class Timepoint
{
    public id?: number;
    public value: string;
    public order?: number;
    public type?: number;

    public constructor(init?: Partial<Timepoint>) { (Object as any).assign(this, init); }
}

export class DrugDispensation
{
    public id?: number;
    public pharmacyId?: number;
    public patientId?: number;
    public depotBatchId?: number;
    public timepointId?: number;
    public dateDispensation?: string;
    public drugUnits?: number;
    public voided?: boolean;
    public notes: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public pharmacy: Pharmacy;
    public depotBatch: DepotBatch;
    public timepoint: Timepoint;

    public constructor(init?: Partial<DrugDispensation>) { (Object as any).assign(this, init); }
}

export enum ShipmentStatus
{
    New = 1,
    Ordered = 2,
    InTransit = 3,
    Available = 4,
    Lost = 5,
    QuarantinedFromTransit = 6,
    Destroyed = 7,
    QuarantinedAtSite = 8,
}

export class DrugShipmentDepotBatch
{
    public id?: number;
    public drugShipmentId?: number;
    public drugId?: number;
    public depotBatchId?: number;
    public drugUnits?: number;
    public drugUnitsUsed?: number;
    public drugUnitsDamaged?: number;
    public drugUnitsDestroyed?: number;
    public drugUnitsLost?: number;
    public drugUnitsQuarantined?: number;
    public notes: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drugShipment: DrugShipment;
    public depotBatch: DepotBatch;
    public drug: Drug;
    public drugAllocated?: number;
    public drugRemaining?: number;

    public constructor(init?: Partial<DrugShipmentDepotBatch>) { (Object as any).assign(this, init); }
}

export class DrugShipmentStatusHistory
{
    public id?: number;
    public drugShipmentId?: number;
    public shipmentStatus: ShipmentStatus;
    public statusDate: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<DrugShipmentStatusHistory>) { (Object as any).assign(this, init); }
}

export class DrugShipmentPharmacist
{
    public id?: number;
    public pharmacyId?: number;
    public pharmacistId?: number;
    public drugShipmentId?: number;

    public constructor(init?: Partial<DrugShipmentPharmacist>) { (Object as any).assign(this, init); }
}

export class DrugAmount
{
    public drugId?: number;
    public drugUnits?: number;

    public constructor(init?: Partial<DrugAmount>) { (Object as any).assign(this, init); }
}

export class DrugShipment
{
    public id?: number;
    public institutionCode: string;
    public pharmacyId?: number;
    public pharmacyShipmentNo?: number;
    public shipmentStatus?: ShipmentStatus;
    public consignmentNo: string;
    public scheduled?: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drugShipmentDepotBatches: DrugShipmentDepotBatch[];
    public drugShipmentStatusHistory: DrugShipmentStatusHistory[];
    public drugShipmentPharmacists: DrugShipmentPharmacist[];

    public constructor(init?: Partial<DrugShipment>) { (Object as any).assign(this, init); }
}

export class DrugShipmentDepotBatchVerify
{
    public id?: number;
    public drugShipmentId?: number;
    public drugId?: number;
    public depotBatchId?: number;
    public batchNo: string;
    public batchExpiryDate?: string;
    public drugUnits?: number;
    public drugUnitsReceived?: number;
    public drugUnitsDamaged?: number;
    public drugUnitsDestroyed?: number;
    public drugUnitsLost?: number;
    public drugUnitsQuarantined?: number;

    public constructor(init?: Partial<DrugShipmentDepotBatchVerify>) { (Object as any).assign(this, init); }
}

export class DrugShipmentVerify
{
    public id?: number;
    public consignmentNo: string;
    public drugShipmentDepotBatches: DrugShipmentDepotBatchVerify[];

    public constructor(init?: Partial<DrugShipmentVerify>) { (Object as any).assign(this, init); }
}

export enum PatientTreatmentStatus
{
    OnTreatment = 1,
    OffTreatment = 2,
}

export class PatientDrug
{
    public id?: number;
    public patientId?: number;
    public drugId?: number;
    public patientTreatmentStatus?: PatientTreatmentStatus;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drug: Drug;

    public constructor(init?: Partial<PatientDrug>) { (Object as any).assign(this, init); }
}

export enum QuarantinedStockAction
{
    ReturnStockToSiteSupply = 1,
    DestroyStock = 2,
}

export interface ISaeGetCollection extends IGet
{
}

export interface ISaeGetCollectionByInstitutionCode extends IGet
{
    institutionCode: string;
}

export interface ISaeGetSingleByPatientStudyNumber extends IGet
{
    patientStudyNumber: string;
    saeNumber?: number;
}

export interface IIncompleteSaeGetCollection extends IGet
{
    studyName: string;
    saeEventName: string;
}

export enum SaeStatus
{
    Added = 0,
    New = 1,
    AwaitingForReview = 2,
    Approved = 3,
    Rejected = 4,
    Incorrect = 5,
    Invalid = 6,
}

export enum SaeWebActionTypeEnum
{
    ApprovalNotRequired = 0,
    NotifiedSiteInvestigators = 1,
    Approved = 2,
    Rejected = 3,
    NotifiedSiteTc = 4,
    Reset = 5,
    NotifiedMedicalReviewers = 6,
    SubmittedMedicalReview = 7,
    NotifiedBctTeam = 8,
    SaeOverdue = 9,
    MarkAsInvalid = 10,
    NotifySponsor = 11,
}

export class SaeWebActionType
{
    public id?: number;
    public value: string;

    public constructor(init?: Partial<SaeWebActionType>) { (Object as any).assign(this, init); }
}

export enum SaeRejectedAsEnum
{
    SaeIsInvalid = 1,
    InformationIsIncorrect = 2,
}

export class WebAction
{
    public id?: number;
    public patientStudyNumber: string;
    public saeNumber?: number;
    public saeFollowUpNumber?: number;
    public actionType?: SaeWebActionTypeEnum;
    public actionDate?: string;
    public userName: string;
    public notes: string;
    public recipients: string;
    public saeWebActionType: SaeWebActionType;
    public rejectedAs?: SaeRejectedAsEnum;

    public constructor(init?: Partial<WebAction>) { (Object as any).assign(this, init); }
}

export class SourceDocument implements ISourceDocument
{
    public id?: number;
    public patientId?: number;
    public formTypeId?: number;
    public formId?: number;
    public fileTypeId?: number;
    public name: string;
    // @Ignore()
    public extension: string;

    // @Ignore()
    public guid: string;

    // @Ignore()
    public fileSize?: number;

    // @Ignore()
    public contentType: string;

    // @Ignore()
    public exists: boolean;

    // @Ignore()
    public image: boolean;

    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<SourceDocument>) { (Object as any).assign(this, init); }
}

export class SaeNotificationForm
{
    public recipients: number[];
    public ccRecipients: number[];
    public notes: string;
    public attachments: SourceDocument[];
    public investigator?: number;
    public sendBctEmailsToSharedMailbox?: boolean;
    public notifySponsor?: boolean;

    public constructor(init?: Partial<SaeNotificationForm>) { (Object as any).assign(this, init); }
}

export enum InvalidSaeReason
{
    CriteriaNotMet = 1,
    Other = 2,
}

export class TemporaryFile
{
    public id: string;
    public name: string;
    public contentType: string;
    public extension: string;
    public fileSize?: number;
    public image?: boolean;
    public dateUploaded?: string;

    public constructor(init?: Partial<TemporaryFile>) { (Object as any).assign(this, init); }
}

export class SaeFileUpload implements IHasId
{
    public id?: number;
    public extension: string;
    public fileSize?: number;
    public contentType: string;
    public image: boolean;
    public exists: boolean;
    public upload: TemporaryFile;

    public constructor(init?: Partial<SaeFileUpload>) { (Object as any).assign(this, init); }
}

export class InvalidSaeFile implements IHasId, IHasAudit
{
    public id?: number;
    public invalidSaeFormId?: number;
    public name: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    // @Ignore()
    public fileUpload: SaeFileUpload;

    // @Ignore()
    public guid: string;

    // @Ignore()
    public extension: string;

    // @Ignore()
    public fileSize?: number;

    // @Ignore()
    public contentType: string;

    // @Ignore()
    public exists: boolean;

    // @Ignore()
    public image: boolean;

    public constructor(init?: Partial<InvalidSaeFile>) { (Object as any).assign(this, init); }
}

export class InvalidSaeForm implements IHasId, IHasAudit
{
    public id?: number;
    public patientStudyNumber: string;
    public saeNumber?: number;
    public comments: string;
    public appliedToOpenClinica?: boolean;
    public dateDeterminedInvalid?: string;
    public reason?: InvalidSaeReason;
    public reasonSpecify: string;
    public decidedById?: number;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public files: InvalidSaeFile[];

    public constructor(init?: Partial<InvalidSaeForm>) { (Object as any).assign(this, init); }
}

export interface ISaeMedicalReviewGetSingleByPatientStudyNumber extends IGet
{
    patientStudyNumber: string;
    saeNumber?: number;
}

export enum SaeExpectedness
{
    Expected = 1,
    Unexpected = 2,
}

export class SaeMedicalReviewItem
{
    public id?: number;
    public saeMedicalReviewId?: number;
    public saeTreatmentCategoryId?: number;
    public typeId?: number;
    public dataEntered?: boolean;
    public latestRelatednessId?: number;
    public relatednessId?: number;
    public expected?: SaeExpectedness;
    public comments: string;
    public notApplicable?: boolean;

    public constructor(init?: Partial<SaeMedicalReviewItem>) { (Object as any).assign(this, init); }
}

export class SaeMedicalReview
{
    public id?: number;
    public patientStudyNumber: string;
    public saeNumber?: number;
    public saeFollowUpNumber?: number;
    public date?: string;
    public saeStatus?: SaeStatus;
    public narrativeSummary: string;
    // @Ignore()
    public items: SaeMedicalReviewItem[];

    public constructor(init?: Partial<SaeMedicalReview>) { (Object as any).assign(this, init); }
}

export interface ISaeMedicalReviewPostSave extends IPost
{
    saeMedicalReview: SaeMedicalReview;
}

export interface IEventGetSingleNewByContext extends IHasPatientId, IHasInstitutionId, IHasEventTypeId, IHasEventRepeat
{
}

export interface IHasInstitutionId
{
    institutionId?: number;
}

export interface IHasEventTypeId
{
    eventTypeId?: number;
}

export interface IHasEventRepeat
{
    eventRepeat?: number;
}

export interface IEventGetSingleById extends IIsEventId
{
}

export interface IIsEventId extends IHasId
{
}

export interface IHasId
{
    id?: number;
}

export interface IEventGetSingleByContext extends IHasPatientId, IHasInstitutionId, IHasEventTypeId, IHasEventRepeat
{
    createNonExisting?: boolean;
}

export interface IEventGetCollectionByContext extends IHasPatientId, IHasInstitutionId, IHasEventTypeId
{
}

export class Event implements IEvent
{
    public id?: number;
    public patientId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public name: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<Event>) { (Object as any).assign(this, init); }
}

export interface IEventDeleteSingleById extends IIsEventId
{
}

export interface IEventDeleteSingleByContext extends IHasPatientId, IHasInstitutionId, IHasEventTypeId, IHasEventRepeat
{
}

export interface IEventTypeGetSingleNew
{
}

export interface IEventTypeGetSingleById
{
}

export interface IEventTypeGetSingleByCode extends IHasEventTypeCode
{
}

export interface IHasEventTypeCode
{
    eventTypeCode: string;
}

export interface IEventTypeGetCollection
{
}

export class EventTypeFormTypeStateValidation implements IEventTypeFormTypeStateValidation
{
    public id?: number;
    public eventTypeFormTypeStateId?: number;
    public ruleSet: string;

    public constructor(init?: Partial<EventTypeFormTypeStateValidation>) { (Object as any).assign(this, init); }
}

export class EventTypeFormTypeState
{
    public id?: number;
    public eventTypeFormTypeId?: number;
    public patientStatus?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validations: EventTypeFormTypeStateValidation[];

    public constructor(init?: Partial<EventTypeFormTypeState>) { (Object as any).assign(this, init); }
}

export class EventTypeFormType
{
    public id?: number;
    public eventTypeId?: number;
    public formTypeId?: number;
    public repeating?: boolean;
    public minimumRepeat?: number;
    public maximumRepeat?: number;
    public order?: number;
    public states: EventTypeFormTypeState[];

    public constructor(init?: Partial<EventTypeFormType>) { (Object as any).assign(this, init); }
}

export class EventTypeState implements IEventTypeState
{
    public id?: number;
    public eventTypeId?: number;
    public patientStatus?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;

    public constructor(init?: Partial<EventTypeState>) { (Object as any).assign(this, init); }
}

export class EventType
{
    public id?: number;
    public name: string;
    public code: string;
    public repeating?: boolean;
    public minimumRepeat?: number;
    public maximumRepeat?: number;
    public order?: number;
    public formTypes: EventTypeFormType[];
    public states: EventTypeState[];

    public constructor(init?: Partial<EventType>) { (Object as any).assign(this, init); }
}

export interface IEventTypeDeleteSingleById
{
}

export interface IEventTypeDeleteSingleByCode extends IHasEventTypeCode
{
}

export interface IEventTypeStateGetSingleById
{
}

export interface IEventTypeStateGetCollectionByEventTypeId extends IHasEventTypeId
{
}

export interface IEventTypeStateDeleteSingleById
{
}

export interface IEventTypeFormTypeGetSingleById
{
}

export interface IEventTypeFormTypeGetCollectionByEventTypeId extends IHasEventTypeId
{
}

export interface IEventTypeFormTypeDeleteSingleById
{
}

export interface IEventTypeFormTypeStateGetSingleById
{
}

export interface IEventTypeFormTypeStateGetCollectionByEventTypeFormTypeId extends IHasEventTypeFormTypeId
{
}

export interface IHasEventTypeFormTypeId
{
    eventTypeFormTypeId?: number;
}

export interface IEventTypeFormTypeStateDeleteSingleById
{
}

export interface IEventTypeFormTypeStateValidationGetSingleById
{
}

export interface IEventTypeFormTypeStateValidationGetCollectionByEventTypeFormTypeStateId extends IHasEventTypeFormTypeStateId
{
}

export interface IHasEventTypeFormTypeStateId
{
    eventTypeFormTypeStateId?: number;
}

export interface IEventTypeFormTypeStateValidationDeleteSingleById
{
}

export interface IPatientGetSingleNew
{
}

export interface IPatientGetSingleById extends IIsPatientId
{
}

export interface IIsPatientId extends IHasId
{
}

export interface IPatientGetSingleByStudyNumber extends IHasPatientStudyNumber
{
}

export interface IHasPatientStudyNumber
{
    patientStudyNumber: string;
}

export interface IPatientGetCollectionByInstitutionId extends IHasInstitutionId
{
    patientStatus?: number;
    countryCode: string;
    treatmentId?: number;
}

export interface IPatientGetCollectionByInstitutionCode extends IHasInstitutionCode
{
    patientStatus?: number;
    countryCode: string;
    treatmentId?: number;
}

export interface IHasInstitutionCode
{
    institutionCode: string;
}

export interface IPatientGetCollection
{
    patientStatus?: number;
    countryCode: string;
    treatmentId?: number;
}

export class Patient implements IOpenClinicaPatient, IHasInstitutionCode
{
    public id?: number;
    public studyNumber: string;
    public institutionId?: number;
    public status?: number;
    public statusReason: string;
    public institutionCode: string;
    public randomisationNumber: string;
    public randomisationDate?: string;
    public registrationDate?: string;
    public ineligibleDate?: string;
    public initials: string;
    public age?: number;
    public treatmentId?: number;
    // @Ignore()
    public sex?: number;

    public exported?: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<Patient>) { (Object as any).assign(this, init); }
}

export interface IPatientDeleteSingleById extends IIsPatientId
{
}

export interface IPatientDeleteSingleByStudyNumber extends IHasPatientStudyNumber
{
}

export interface IInstitutionGetSingleNew
{
}

export interface IInstitutionGetSingleById extends IIsInstitutionId
{
}

export interface IIsInstitutionId extends IHasId
{
}

export interface IInstitutionGetSingleByCode extends IHasInstitutionCode
{
}

export interface IInstitutionGetCollection
{
}

export class Institution implements IInstitution
{
    public id?: number;
    public name: string;
    public code: string;
    public country: string;
    public countryCode: string;
    public enabled?: boolean;
    public activatedDate?: string;
    public recruitmentDisabled?: boolean;

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

export interface IInstitutionDeleteSingleById extends IIsInstitutionId
{
}

export interface IInstitutionDeleteSingleByCode extends IHasInstitutionCode
{
}

export interface IFormTypeGetLookupsById
{
}

export interface IFormTypeGetLookupsByCode extends IHasFormTypeCode
{
}

export interface IHasFormTypeCode
{
    formTypeCode: string;
}

export interface IFormTypeGetSingleNew
{
}

export interface IFormTypeGetSingleById
{
}

export interface IFormTypeGetSingleByCode extends IHasFormTypeCode
{
}

export interface IFormTypeGetCollection
{
}

export class FormTypePropertyErrorMessage implements IFormTypePropertyErrorMessage
{
    public id?: number;
    public formTypePropertyId?: number;
    public errorCode: string;
    public message: string;
    public detailedMessage: string;
    public errorType?: ErrorType;

    public constructor(init?: Partial<FormTypePropertyErrorMessage>) { (Object as any).assign(this, init); }
}

export class FormTypeProperty
{
    public id?: number;
    public formTypeId?: number;
    public propertyName: string;
    public label: string;
    public errorMessages: FormTypePropertyErrorMessage[];

    public constructor(init?: Partial<FormTypeProperty>) { (Object as any).assign(this, init); }
}

export class FormType
{
    public id?: number;
    public name: string;
    public code: string;
    public properties: FormTypeProperty[];

    public constructor(init?: Partial<FormType>) { (Object as any).assign(this, init); }
}

export interface IFormTypeDeleteSingleById
{
}

export interface IFormTypeDeleteSingleByCode extends IHasFormTypeCode
{
}

export interface IFormTypePropertyGetSingleById
{
}

export interface IFormTypePropertyGetCollectionByFormTypeId extends IHasFormTypeId
{
}

export interface IHasFormTypeId
{
    formTypeId?: number;
}

export interface IFormTypePropertyDeleteSingleById
{
}

export interface IFormTypePropertyErrorMessageGetSingleById
{
}

export interface IFormTypePropertyErrorMessageGetCollectionByFormTypePropertyId extends IHasFormTypePropertyId
{
}

export interface IHasFormTypePropertyId
{
    formTypePropertyId?: number;
}

export interface IFormTypePropertyErrorMessageDeleteSingleById
{
}

export interface IFormGetSingleNewByContext extends IHasPatientId, IHasInstitutionId, IHasEventId, IHasEventTypeId, IHasEventRepeat, IHasParentFormTypeId, IHasParentFormId, IHasFormRepeat
{
}

export interface IHasEventId
{
    eventId?: number;
}

export interface IHasParentFormTypeId
{
    parentFormTypeId?: number;
}

export interface IHasParentFormId
{
    parentFormId?: number;
}

export interface IHasFormRepeat
{
    formRepeat?: number;
}

export interface IFormGetSingleByContext extends IHasPatientId, IHasInstitutionId, IHasEventId, IHasEventTypeId, IHasEventRepeat, IHasParentFormTypeId, IHasParentFormId, IHasFormRepeat
{
    createNonExisting?: boolean;
}

export interface IFormGetCollectionByContext extends IHasPatientId, IHasInstitutionId, IHasEventId, IHasEventTypeId, IHasEventRepeat, IHasParentFormTypeId, IHasParentFormId
{
}

export interface IFormGetValidationByContext extends IHasPatientId, IHasInstitutionId, IHasEventId, IHasEventTypeId, IHasEventRepeat, IHasParentFormTypeId, IHasParentFormId, IHasFormRepeat
{
}

export class ConcomitantMedication implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public medicationName: string;
    public indicationId?: number;
    public startDate: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<ConcomitantMedication>) { (Object as any).assign(this, init); }
}

export interface IFormDeleteSingleByContext extends IHasPatientId, IHasInstitutionId, IHasEventId, IHasEventTypeId, IHasEventRepeat, IHasParentFormTypeId, IHasParentFormId, IHasFormRepeat
{
}

export class DiagnosticAndPathologyData implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public histopathologicDiagnosisDate?: string;
    public primaryTumourSiteId?: number;
    public tnmClinicalStagingTumourId?: number;
    public tnmClinicalStagingNodesId?: number;
    public tnmClinicalStagingDistantMetastasisId?: number;
    public histopathologyTypeId?: number;
    public histopathologyTypeSpecification: string;
    public histopathologicalGradeId?: number;
    public confirmClinicalStageDiagnosisId?: number;
    public oestrogenReceptorPercentageRangeId?: number;
    public oestrogenReceptorPercentageValue?: number;
    public progesteroneReceptorPercentageRangeId?: number;
    public progesteroneReceptorPercentageValue?: number;
    public her2ExpressionIhcScoreId?: number;
    public her2ExpressionIshScoreId?: number;
    public tumourInfiltratingLymphocytesRangeId?: number;
    public tumourInfiltratingLymphocytesValue?: number;
    public tumourInfiltratingLymphocytesNotDone?: boolean;
    public brcaGermlineStatusId?: number;
    public pdLTestingCompletedId?: number;
    public pdLAssayTypeId?: number;
    public pdLAssayTypeSpecification: string;
    public pdLResultsId?: number;
    public pdLValue?: number;
    public sourceDocuments: SourceDocument[];
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<DiagnosticAndPathologyData>) { (Object as any).assign(this, init); }
}

export class DiagnosticImagingAndTumourAssessment implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public breastUltrasoundDate?: string;
    public breastUltrasoundLesionSideId?: number;
    public breastUltrasoundLesionLocationId?: number;
    public breastUltrasoundLesionDimensionOne?: number;
    public breastUltrasoundLesionDimensionTwo?: number;
    public breastClipInsertedNotDone?: boolean;
    public breastClipInsertedDate?: string;
    public axillaUltrasoundNotDone?: boolean;
    public axillaUltrasoundDate?: string;
    public axillaUltrasoundNumberOfSuspiciousAxillaryNodes?: number;
    public mriIncludingAxillaNotDone?: boolean;
    public mriIncludingAxillaDate?: string;
    public mriSuspiciousAxillaryNodes?: number;
    public axillaClipInsertedNotDone?: boolean;
    public axillaClipInsertedDate?: string;
    public clinicalExaminationNotDone?: boolean;
    public clinicalExaminationDate?: string;
    public clinicalExaminationNumberOfSuspiciousAxillaryNodes?: number;
    public cytologicalAssessmentNotDone?: boolean;
    public cytologicalAssessmentDate?: string;
    public cytologicalAssessmentId?: number;
    public cytologicalAssessmentSpecification: string;
    public abdomenUltrasoundNotDone?: boolean;
    public abdomenUltrasoundNotApplicable?: boolean;
    public abdomenUltrasoundDate?: string;
    public abdomenUltrasoundId?: number;
    public abdomenUltrasoundSpecification: string;
    public mammogramTypeId?: number;
    public mammogramDate?: string;
    public mammogramLeftDate?: string;
    public mammogramRightDate?: string;
    public mammogramLesionSideId?: number;
    public mammogramLesionLocationId?: number;
    public mammogramLesionDimension?: number;
    public chestXrayNotDone?: boolean;
    public chestXrayId?: number;
    public chestXraySpecification: string;
    public chestXrayDate?: string;
    public ctScanNotDone?: boolean;
    public ctScanId?: number;
    public ctScanSpecification: string;
    public ctScanDate?: string;
    public petScanNotDone?: boolean;
    public petScanId?: number;
    public petScanSpecification: string;
    public petScanDate?: string;
    public boneScanNotDone?: boolean;
    public boneScanId?: number;
    public boneScanSpecification: string;
    public boneScanDate?: string;
    public sourceDocuments: SourceDocument[];
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessment>) { (Object as any).assign(this, init); }
}

export class EligibilityChecklist implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public tumourBlockOrRepresentativeAvailableId?: number;
    public previouslyUntreatedBreastCancerId?: number;
    public agreeToCoreNeedleBiopsiesId?: number;
    public commenceStudyTreatmentOnScheduleId?: number;
    public awareOfSurgeryScheduleId?: number;
    public informedAndAgreedToAvoidPregnancyId?: number;
    public evidenceOfBreastCancerId?: number;
    public receivedPriorTherapyId?: number;
    public undergoneLymphNodeBiopsyId?: number;
    public participatedOrParticipatingInStudyTherapyId?: number;
    public plannedOrReceivedLiveVaccineId?: number;
    public receivedAlternativeMedicinesId?: number;
    public diagnosedWithPreviousMalignanciesId?: number;
    public currentlyOnAnyConcurrentAntiNeoplasticTherapyId?: number;
    public diagnosedWithOtherActiveMalignanciesId?: number;
    public knownOrSuspectedAutoImmuneDiseaseId?: number;
    public requiresSystemicTreatmentId?: number;
    public interstitialLungDiseaseId?: number;
    public historyOfNonInfectiousPneumonitisId?: number;
    public knownSensitivityToStudyMedicationId?: number;
    public significantCardiovascularDiseaseId?: number;
    public testingPositiveToImmunodeficiencyVirusId?: number;
    public medicalConditionIncreasingRiskOfParticipationId?: number;
    public activeHepatitisBOrCId?: number;
    public activeHepatitisB?: number;
    public participantOnHbvAntiviral?: number;
    public positiveHepatitisC?: number;
    public participantOnHcvAntiviral?: number;
    public activeTuberculosisId?: number;
    public currentlyBreastfeedingId?: number;
    public consideredAPoorMedicalRiskId?: number;
    // @Ignore()
    public isPatientCohortC: boolean;

    public sourceDocuments: SourceDocument[];
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<EligibilityChecklist>) { (Object as any).assign(this, init); }
}

export class General implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public age?: number;
    public physicalExaminationDate?: string;
    public height?: number;
    public weight?: number;
    public ecogPerformanceStatusId?: number;
    public menopausalStatusId?: number;
    public postmenopausalSpecificationId?: number;
    public postmenopausalLevelsDate?: string;
    public postmenopausalLevelsLh?: number;
    public postmenopausalLevelsLhLln?: number;
    public postmenopausalLevelsLhLlnNotSpecified?: boolean;
    public postmenopausalLevelsLhUln?: number;
    public postmenopausalLevelsLhUlnNotSpecified?: boolean;
    public postmenopausalLevelsFsh?: number;
    public postmenopausalLevelsFshLln?: number;
    public postmenopausalLevelsFshLlnNotSpecified?: boolean;
    public postmenopausalLevelsFshUln?: number;
    public postmenopausalLevelsFshUlnNotSpecified?: boolean;
    public preOrPerimenopausalNegativePregnancyTestId?: number;
    public preOrPerimenopausalNegativePregnancyTestDate?: string;
    public lvefId?: number;
    public lvefDate?: string;
    public lvefValue?: number;
    public ecgDate?: string;
    public plannedStartDate?: string;
    public sourceDocuments: SourceDocument[];
    // @Ignore()
    public treatmentId?: number;

    // @Ignore()
    public randomisationDate?: string;

    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<General>) { (Object as any).assign(this, init); }
}

export class HaematologyAndBiochemistry implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public haematologyDate?: string;
    public haemoglobin?: number;
    public haemoglobinUnitId?: number;
    public redBloodCellCount?: number;
    public totalNeutrophils?: number;
    public lymphocytes?: number;
    public platelets?: number;
    public whiteBloodCellCount?: number;
    public biochemistryDate?: string;
    public gilbertSyndromeId?: number;
    public bilirubin?: number;
    public bilirubinUln?: number;
    public aspartateTransaminase?: number;
    public aspartateTransaminaseUln?: number;
    public alanineTransaminase?: number;
    public alanineTransaminaseUln?: number;
    public alkalinePhosphatase?: number;
    public alkalinePhosphataseUln?: number;
    public serumCreatinine?: number;
    public serumCreatinineLln?: number;
    public serumCreatinineUln?: number;
    public calculatedCreatinineClearance?: number;
    public calcium?: number;
    public lactateDehydrogenase?: number;
    public totalProtein?: number;
    public amylase?: number;
    public amylaseLln?: number;
    public amylaseUln?: number;
    public lipase?: number;
    public lipaseLln?: number;
    public lipaseUln?: number;
    public bloodUreaNitrogen?: number;
    public serumUrea?: number;
    public potassium?: number;
    public gammaGlutamylTransferase?: number;
    public sodium?: number;
    public uricAcid?: number;
    public cortisol?: number;
    public cortisolLln?: number;
    public cortisolUln?: number;
    public bloodGlucose?: number;
    public bloodGlucoseLln?: number;
    public bloodGlucoseUln?: number;
    public bloodGlucoseTypeId?: number;
    public thyroidFunctionDate?: string;
    public thyroidStimulatingHormone?: number;
    public tshLln?: number;
    public tshUln?: number;
    public triiodothyronine?: number;
    public t3Lln?: number;
    public t3Uln?: number;
    public t3NotDone?: boolean;
    public thyroxine?: number;
    public t4Lln?: number;
    public t4Uln?: number;
    public troponinDate?: string;
    public troponin?: number;
    public troponinLln?: number;
    public troponinUln?: number;
    public coagulationDate?: string;
    public prothombinTime?: number;
    public internationalNormalisedRatio?: number;
    public activatedPartialThromboplastinTime?: number;
    public partialThromboplastinTime?: number;
    public sourceDocuments: SourceDocument[];
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<HaematologyAndBiochemistry>) { (Object as any).assign(this, init); }
}

export class MedicalCondition implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public ctcaeTermId?: number;
    public ctcaeGradeId?: number;
    public ctcaeSpecification: string;
    public currentTimeRandomisationId?: number;
    public diagnosisDate: string;
    public treatmentOngoingId?: number;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<MedicalCondition>) { (Object as any).assign(this, init); }
}

export class OtherMedicalCondition implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public medicalCondition: string;
    public currentTimeRandomisationId?: number;
    public diagnosisDate: string;
    public treatmentOngoingId?: number;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<OtherMedicalCondition>) { (Object as any).assign(this, init); }
}

export class MedicalHistoryAndConcomitantMedications implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public relevantDataToBeAddedId?: number;
    public ageAtFirstMenstrualPeriod?: number;
    public ageAtLastMenstrualPeriod?: number;
    public lastMenstrualPeriodId?: number;
    public lastMenstrualPeriodDate?: string;
    public bilateralOophorectomy?: boolean;
    public bilateralSalpingectomy?: boolean;
    public hysterectomy?: boolean;
    public endometrialAblation?: boolean;
    public participantHasIud?: number;
    public iudHormonalNonHormonal?: number;
    public menopausalStatus?: number;
    // @Ignore()
    public age?: number;

    public postmenopausalLevelsDate?: string;
    public postmenopausalLevelsLh?: number;
    public postmenopausalLevelsLhLln?: number;
    public postmenopausalLevelsLhLlnNotSpecified?: boolean;
    public postmenopausalLevelsLhUln?: number;
    public postmenopausalLevelsLhUlnNotSpecified?: boolean;
    public postmenopausalLevelsFsh?: number;
    public postmenopausalLevelsFshLln?: number;
    public postmenopausalLevelsFshLlnNotSpecified?: boolean;
    public postmenopausalLevelsFshUln?: number;
    public postmenopausalLevelsFshUlnNotSpecified?: boolean;
    public preOrPerimenopausalNegativePregnancyTestId?: number;
    public preOrPerimenopausalNegativePregnancyTestDate?: string;
    public numberOfPreviousPregnancies?: number;
    public ageAtFirstPregnancy?: number;
    public numberOfLiveBirths?: number;
    public didParticipantBreastFeed?: number;
    public cumulativeMonthsBreastFeedingDuration?: number;
    public ageOfFirstChild?: number;
    public ageOfLastChild?: number;
    public medicalConditionNone?: boolean;
    public otherMedicalHistoryNone?: boolean;
    public concomitantMedicalNone?: boolean;
    // @Ignore()
    public sex?: number;

    public sourceDocuments: SourceDocument[];
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public medicalConditions: MedicalCondition[];
    public otherMedicalConditions: OtherMedicalCondition[];
    public concomitantMedications: ConcomitantMedication[];

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedications>) { (Object as any).assign(this, init); }
}

export class Preregistration implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public genderId?: number;
    public patientInitials: string;
    public postcodeOfUsualResidence: string;
    public indigenousStatusId?: number;
    public countryOfBirth: string;
    public mainLanguageForCommunication: string;
    public signedMainConsentId?: number;
    public dateSignedMainConsent?: string;
    public signedDatedOptionalConsentId?: number;
    public signedOptionalConsentId?: number;
    public dateSignedOptionalConsent?: string;
    public signedFutureConsentId?: number;
    public signedFutureContactConsentId?: number;
    public sourceDocuments: SourceDocument[];
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<Preregistration>) { (Object as any).assign(this, init); }
}

export enum Permission
{
    OpmsAccess = 1,
    OpmsInstitutionView = 2,
    OpmsAdminister = 3,
    OpmsPatientView = 4,
    SystemAdminister = 5,
    OpmsPatientUpdate = 6,
    OpmsMasterGroupAdminister = 7,
    OpmsCoordinatingGroupAdminister = 8,
    PathologyTestAdminister = 9,
    BlockShipmentDetailsView = 10,
    OpmsPatientRegister = 11,
    OpmsPatientRandomise = 12,
    SaeView = 13,
    SaeReview = 14,
    ScreeningLogView = 15,
    ScreeningLogUpdate = 16,
    TeleformView = 17,
    TeleformManage = 18,
    EcrfView = 19,
    SaeAdminister = 20,
    MedicalReviewAccess = 21,
    MedicalReviewPerform = 22,
    MedicalReviewAdminister = 23,
    HistopathologyAccess = 24,
    DrugManagementView = 25,
    DrugManagementAdminister = 26,
    DrugManagementDispenseDrug = 27,
    OpmsProView = 28,
    OpmsProUpdate = 29,
    OpmsProAdminister = 30,
    OpmsPatientImpersonate = 31,
    OpmsPatientAccountManagement = 32,
    OpmsCrfView = 33,
    OpmsCrfUpdate = 34,
    OpmsEventView = 35,
    OpmsEventUpdate = 36,
    OpmsConsentAdminister = 37,
    OpmsCoordinatingGroupContactView = 38,
    OpmsSaeInvestigatorNotify = 39,
    EConsentView = 40,
    EConsentAdminister = 41,
    EConsentManage = 42,
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export interface IPatient extends IHasId, IHasInstitutionId, IHasAudit
{
    status?: number;
    studyNumber: string;
    treatmentId?: number;
}

export class EmailAddress
{
    public displayName: string;
    public address: string;

    public constructor(init?: Partial<EmailAddress>) { (Object as any).assign(this, init); }
}

export enum PatientStatuses
{
    NewPatient = 0,
    Screened = 1,
    Registered = 2,
    Randomised = 3,
    Ineligible = 7,
    Waivered = 8,
    Removed = 9,
}

export enum FormTypes
{
    Preregistration = 1,
    EligibilityChecklist = 2,
    General = 3,
    DiagnosticImagingAndTumourAssessment = 4,
    BreastUltrasound = 5,
    Mammogram = 6,
    DiagnosticAndPathologyData = 7,
    HaematologyAndBiochemistry = 8,
    MedicalHistoryAndConcomitantMedications = 9,
    MedicalCondition = 10,
    ConcomitantMedication = 11,
    OtherMedicalCondition = 12,
}

export enum EventTypes
{
    Preregistration = 1,
    Baseline = 2,
    MedicalHistoryAndConcomitantMedications = 3,
}

export enum DrugTypes
{
    Nivolumab = 1,
    NivolumabRelatlimab = 2,
    AdjuvantNivolumab = 3,
}

export enum LookupCancerStageType
{
    StageOne = 1,
    StageTwoA = 2,
    StageTwoB = 3,
    StageThree = 4,
}

export enum LookupConditionalIneligibleType
{
    Ineligible = 1,
    Eligible = 2,
    ConditionalIneligible = 3,
}

export enum LookupGenderType
{
    Female = 1,
    Male = 2,
    Unknown = 3,
}

export enum LookupGreaterThanLessThanType
{
    GreaterThan = 1,
    LessThan = 2,
    Equal = 3,
}

export enum LookupIndigenousStatusType
{
    Indigenous = 1,
    NotIndigenous = 2,
    Unknown = 3,
}

export enum LookupIneligibleType
{
    Ineligible = 1,
    Eligible = 2,
}

export enum LookupMenopausalStatusType
{
    PreOrPeriMenopausal = 1,
    PostMenopausal = 2,
    SurgicalSterilisation = 3,
    NotApplicable = 4,
}

export enum LookupSpecificationType
{
    RequiresSpecification = 1,
    NoSpecification = 2,
}

export enum LookupTnmDistantMetastasisType
{
    M0 = 1,
    N1 = 2,
}

export enum LookupTnmNodesType
{
    Nx = 1,
    N0 = 2,
    N1 = 3,
    N1mi = 4,
    N2 = 5,
    N2a = 6,
    N2b = 7,
    N3 = 8,
    N3a = 9,
    N3b = 10,
    N3c = 11,
}

export enum LookupTnmTumourType
{
    Tx = 1,
    T0 = 2,
    TisDcis = 3,
    TisPaget = 4,
    T1 = 5,
    T1mi = 6,
    T1a = 7,
    T1b = 8,
    T1c = 9,
    T2 = 10,
    T3 = 11,
    T4 = 12,
    T4a = 13,
    T4b = 14,
    T4c = 15,
    T4d = 16,
}

export enum LookupUntyped
{
    NoType = 1,
}

export enum LookupYesNoNaType
{
    Yes = 1,
    No = 2,
    NotApplicableOrNotAnnounced = 3,
}

export enum LookupYesNoType
{
    Yes = 1,
    No = 2,
}

export enum LookupGramPerUnitType
{
    GL = 1,
    GdL = 2,
}

export enum LookupMammogramType
{
    Bilateral = 1,
    Unilateral = 2,
}

export enum LookupHistopathologicalGradeType
{
    G1 = 1,
    G2 = 2,
    G3 = 3,
}

export enum LookupLastMenstrualPeriodType
{
    MoreThan12Months = 1,
    LessThan12Months = 2,
}

export class Personnel
{
    public id?: number;
    public name: string;
    public email: string;
    public address: string;

    public constructor(init?: Partial<Personnel>) { (Object as any).assign(this, init); }
}

export class EnrolmentStatus
{
    public studyNumber: string;
    public institutionCode: string;
    public institutionName: string;
    public status: string;
    public dateRegistered: string;
    public dateScreeningFailed: string;
    public reasonIneligible: string;
    public dateRandomised: string;
    public treatmentArm: string;

    public constructor(init?: Partial<EnrolmentStatus>) { (Object as any).assign(this, init); }
}

export class FormsDueSummary
{
    public initials: string;
    public studyNumber: string;
    public institutionCode: string;
    public institutionName: string;
    public eventName: string;
    public eventRepeat: number;
    public formsDueForEvent: string;
    public visitDate?: string;
    public dueDate?: string;

    public constructor(init?: Partial<FormsDueSummary>) { (Object as any).assign(this, init); }
}

export class FormsDueSchedule
{
    public studyNumber: string;
    public initials: string;
    public registrationDate?: string;
    public treatmentStartDate?: string;
    public institutionCode: string;
    public institutionName: string;
    public leadInDate?: string;
    public leadInDueDate?: string;
    public cycle1Date?: string;
    public cycle1DueDate?: string;
    public cycle2Date?: string;
    public cycle2DueDate?: string;
    public cycle3Date?: string;
    public cycle3DueDate?: string;
    public cycle4Date?: string;
    public cycle4DueDate?: string;
    public survivalFollowUp1Date?: string;
    public survivalFollowUp1DueDate?: string;
    public survivalFollowUp2Date?: string;
    public survivalFollowUp2DueDate?: string;
    public survivalFollowUp3Date?: string;
    public survivalFollowUp3DueDate?: string;
    public survivalFollowUp4Date?: string;
    public survivalFollowUp4DueDate?: string;
    public survivalFollowUp5Date?: string;
    public survivalFollowUp5DueDate?: string;
    public survivalFollowUp6Date?: string;
    public survivalFollowUp6DueDate?: string;

    public constructor(init?: Partial<FormsDueSchedule>) { (Object as any).assign(this, init); }
}

export class PatientAction
{
    public institutionCode: string;
    public institutionName: string;
    public randNo: string;
    public visit: string;
    public eventDate: string;
    public event: string;
    public user: string;
    public batch: string;
    public drug: string;
    public vials?: number;
    public patientStatus: string;
    public notes: string;

    public constructor(init?: Partial<PatientAction>) { (Object as any).assign(this, init); }
}

export class SiteStatus
{
    public institution: string;
    public code: string;
    public activationStatus: string;
    public dateActivated: string;
    public screened?: number;
    public randomised?: number;
    public dateLastScreened: string;
    public submissionProcess: string;
    public registered?: number;
    public armCDateLastScreened: string;

    public constructor(init?: Partial<SiteStatus>) { (Object as any).assign(this, init); }
}

export class DrugManagementLog
{
    public institutionName: string;
    public date?: string;
    public user: string;
    public participant: string;
    public action: string;

    public constructor(init?: Partial<DrugManagementLog>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export class PharmacyBatchDrugRemaining
{
    public pharmacy: Pharmacy;
    public batch: Batch;
    public drugRemaining?: number;

    public constructor(init?: Partial<PharmacyBatchDrugRemaining>) { (Object as any).assign(this, init); }
}

export enum SaeMedicalReviewStatus
{
    NotNotified = 0,
    Pending = 1,
    Reviewed = 3,
}

export class LookupItem implements ILookupItem
{
    public id?: number;
    public value: string;
    public order?: number;
    public type?: number;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
}

export class Lookup
{
    public propertyName: string;
    public items: LookupItem[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export class Sae<TSaeForm, TPatient>
{
    public patient: TPatient;
    public form: TSaeForm;
    public status: SaeStatus;
    public medicalReview: SaeMedicalReview;
    public medicalReviewStatus: SaeMedicalReviewStatus;
    public ecrfs: TSaeForm[];
    public saeFormItems: { [index: string]: string; };
    public lookups: Lookup[];
    public actionHistory: WebAction[];
    public invalidForm: InvalidSaeForm;

    public constructor(init?: Partial<Sae<TSaeForm, TPatient>>) { (Object as any).assign(this, init); }
}

export class LastDoseConcomitantDrug implements ISaeSubform, ILastDoseConcomitantDrug
{
    public ordinal: number;
    public medicationName: string;
    public medicationDose: string;
    public medicationDateCommenced?: string;
    public medicationDateLastAdmin?: string;
    public medicationNameRelatedEvent: string;

    public constructor(init?: Partial<LastDoseConcomitantDrug>) { (Object as any).assign(this, init); }
}

export class LastDoseStudyDrug implements ISaeSubform, ILastDoseStudyDrug
{
    public ordinal: number;
    public drugName: string;
    public drugDose: string;
    public drugRoute: string;
    public drugDateInitiallyCommenced?: string;
    public drugDateLastAdmin?: string;
    public drugRelatedEvent: string;
    public drugActionTaken: string;

    public constructor(init?: Partial<LastDoseStudyDrug>) { (Object as any).assign(this, init); }
}

export class Treatment implements ISaeSubform, ITreatment
{
    public ordinal: number;
    public treatmentName: string;
    public treatmentDateCommenced?: string;
    public treatmentDateCeased?: string;
    public treatmentOngoing?: boolean;
    public treatmentDose: string;
    public treatmentUnits: string;

    public constructor(init?: Partial<Treatment>) { (Object as any).assign(this, init); }
}

export class SourceDocuments implements ISaeSubform, ISourceDocument1
{
    public ordinal: number;
    public type: string;
    public name: string;
    public document: string;

    public constructor(init?: Partial<SourceDocuments>) { (Object as any).assign(this, init); }
}

export class SaeForm implements ISaeForm
{
    public id?: number;
    public patientId?: number;
    public saeNumber?: number;
    public followUpNumber?: number;
    public dateOfSAE?: string;
    public mainEvent: string;
    public eventGrade?: number;
    public ctcaeTerm: string;
    public descriptionOfEvent: string;
    public reportingCriteria: string;
    public reportingResultsInDeath?: boolean;
    public reportingLifeThreatening?: boolean;
    public requiresHospitalisation?: boolean;
    public reportingDisability?: boolean;
    public reportingDefect?: boolean;
    public reportingSignificant?: boolean;
    public reportingInfectious?: boolean;
    public eventStatus: string;
    public eventStatusResolvedDate?: string;
    public additionalInfo: string;
    public investigatorsName: string;
    public investigatorsPhoneNo: string;
    public dateCreated?: string;
    public dateUpdated?: string;
    public lastDoseConcomitant: LastDoseConcomitantDrug[];
    public lastDoseStudy: LastDoseStudyDrug[];
    public treatment: Treatment[];
    public sourceDocuments: SourceDocuments[];
    public unassignedProperties: { [index: string]: Object; };
    public inconvertableProperties: { [index: string]: string; };

    public constructor(init?: Partial<SaeForm>) { (Object as any).assign(this, init); }
}

export enum ResultType
{
    Valid = 1,
    Ineligible = 2,
    Error = 3,
    StratificationFailure = 4,
    Critical = 5,
}

export class SaeFormValidationError implements IValidationError
{
    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ErrorType;

    public constructor(init?: Partial<SaeFormValidationError>) { (Object as any).assign(this, init); }
}

export class SaeFormValidationResult
{
    public result: ResultType;
    public errors: SaeFormValidationError[];

    public constructor(init?: Partial<SaeFormValidationResult>) { (Object as any).assign(this, init); }
}

export interface ISaeMedicalReviewSingleResponse
{
    saeMedicalReview: SaeMedicalReview;
}

export interface IEventSingleDeleteResponse
{
    deleted: boolean;
}

export interface IEventTypeSingleDeleteResponse
{
    deleted: boolean;
}

export interface IEventTypeStateSingleDeleteResponse
{
    deleted: boolean;
}

export interface IEventTypeFormTypeSingleDeleteResponse
{
    deleted: boolean;
}

export interface IEventTypeFormTypeStateSingleDeleteResponse
{
    deleted: boolean;
}

export interface IEventTypeFormTypeStateValidationSingleDeleteResponse
{
    deleted: boolean;
}

export interface IPatientSingleDeleteResponse
{
    deleted: boolean;
}

export interface IInstitutionSingleDeleteResponse
{
    deleted: boolean;
}

export interface IFormTypeSingleDeleteResponse
{
    deleted: boolean;
}

export interface IFormTypePropertySingleDeleteResponse
{
    deleted: boolean;
}

export interface IFormTypePropertyErrorMessageSingleDeleteResponse
{
    deleted: boolean;
}

export class OpmsTypeMapping
{
    public id?: number;
    public name: string;
    public propertyName: string;

    public constructor(init?: Partial<OpmsTypeMapping>) { (Object as any).assign(this, init); }
}

export class ValidationError implements IValidationError
{
    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ErrorType;

    public constructor(init?: Partial<ValidationError>) { (Object as any).assign(this, init); }
}

export class ValidationResult
{
    public result: ResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public errors: ValidationError[];

    public constructor(init?: Partial<ValidationResult>) { (Object as any).assign(this, init); }
}

export interface IFormSingleDeleteResponse
{
    deleted: boolean;
}

export enum ErrorType
{
    Server = 1,
    Client = 2,
}

export interface IHasAudit extends IHasEntryAudit, IHasModificationAudit
{
}

export interface IHasEntryAudit
{
    enteredDate?: string;
    enteredByUserId: string;
}

export interface IHasModificationAudit
{
    modifiedDate?: string;
    modifiedByUserId: string;
}

export interface IEvent extends IHasId, IHasPatientId, IHasEventTypeId, IHasEventRepeat, IHasAudit
{
    name: string;
}

export interface IEventTypeFormTypeStateValidation extends IHasId, IHasEventTypeFormTypeStateId, IHasValidationMetadata
{
}

export interface IEventTypeFormTypeState extends IHasId, IHasEventTypeFormTypeId, IHasPatientStatus
{
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validations: IEventTypeFormTypeStateValidation[];
}

export interface IEventTypeFormType extends IHasId, IHasEventTypeId, IHasFormTypeId
{
    repeating?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    order?: number;
    states: IEventTypeFormTypeState[];
}

export interface IEventTypeState extends IHasId, IHasEventTypeId, IHasPatientStatus
{
    visible?: boolean;
    read?: boolean;
    write?: boolean;
}

export interface IEventType extends IHasId
{
    name: string;
    code: string;
    repeating?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    order?: number;
    formTypes: IEventTypeFormType[];
    states: IEventTypeState[];
}

export interface IHasPatientStatus
{
    patientStatus?: number;
}

export interface IHasValidationMetadata
{
    ruleSet: string;
}

export interface IOpenClinicaPatient extends IPatient
{
    exported?: string;
}

export interface IInstitution extends IHasId
{
    name: string;
    code: string;
    country: string;
    countryCode: string;
    activatedDate?: string;
    enabled?: boolean;
    recruitmentDisabled?: boolean;
}

export interface IFormTypePropertyErrorMessage extends IHasId, IHasFormTypePropertyId, IHasErrorMessageMetadata
{
}

export interface IFormTypeProperty extends IHasId, IHasFormTypeId, IHasPropertyMetadata
{
    errorMessages: IFormTypePropertyErrorMessage[];
}

export interface IFormType extends IHasId
{
    name: string;
    code: string;
    properties: IFormTypeProperty[];
}

export interface IHasPropertyMetadata
{
    propertyName: string;
    label: string;
}

export interface IHasErrorMessageMetadata
{
    errorCode: string;
    message: string;
    detailedMessage: string;
    errorType?: ErrorType;
}

export interface IForm extends IHasId, IHasPatientId, IHasEventId, IHasParentFormTypeId, IHasParentFormId, IHasFormRepeat, IHasAudit
{
}

export interface ISaeForm
{
    id?: number;
    patientId?: number;
    saeNumber?: number;
    followUpNumber?: number;
    eventStatus: string;
    dateCreated?: string;
    dateUpdated?: string;
    unassignedProperties: { [index: string]: Object; };
    inconvertableProperties: { [index: string]: string; };
}

export interface ILookupItem extends IHasId
{
    value: string;
    order?: number;
    type?: number;
}

export interface ILookup
{
    propertyName: string;
    items: ILookupItem[];
}

export interface IValidationError
{
    property: string;
    message: string;
    detailedMessage: string;
    code: string;
    ruleSet: string;
    type?: ErrorType;
}

export interface IValidationResult
{
    result: ResultType;
    answeredQuestions?: number;
    totalQuestions?: number;
    errors: IValidationError[];
}

export interface ISourceDocument extends IHasId, IHasPatientId, IHasFormTypeId, IHasFormId, IHasAudit
{
    fileTypeId?: number;
    name: string;
    extension: string;
    guid: string;
    fileSize?: number;
    contentType: string;
    exists: boolean;
    image: boolean;
}

export interface IHasFormId
{
    formId?: number;
}

export interface ISaeSubform
{
    ordinal: number;
}

export interface ILastDoseConcomitantDrug
{
}

export interface ILastDoseStudyDrug
{
}

export interface ITreatment
{
}

export interface ISourceDocument1
{
    type: string;
    name: string;
    document: string;
}

export class GetAccrualCountsResponse
{
    public data: { [index: string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetAccrualCountsResponse>) { (Object as any).assign(this, init); }
}

export class CompleteScreeningResponse
{
    public responseStatus: ResponseStatus;
    public patient: IPatient;

    public constructor(init?: Partial<CompleteScreeningResponse>) { (Object as any).assign(this, init); }
}

export class RegisterPatientResponse
{
    public responseStatus: ResponseStatus;
    public patient: IPatient;

    public constructor(init?: Partial<RegisterPatientResponse>) { (Object as any).assign(this, init); }
}

export class SendScreeningEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendScreeningEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendFormsDueSummaryEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendFormsDueSummaryEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendDrugShipmentGenerationEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDrugShipmentGenerationEmailResponse>) { (Object as any).assign(this, init); }
}

export class GenerateDrugShipmentsResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GenerateDrugShipmentsResponse>) { (Object as any).assign(this, init); }
}

export class SendDrugShipmentNotCreatedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDrugShipmentNotCreatedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendDrugShipmentOrderedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDrugShipmentOrderedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendStagnantNewDrugOrdersEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendStagnantNewDrugOrdersEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendStagnantDrugOrdersEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendStagnantDrugOrdersEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendStagnantDrugShipmentsEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendStagnantDrugShipmentsEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendExpiringStockEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendExpiringStockEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendLowStockEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendLowStockEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendPharmacyLowStockEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendPharmacyLowStockEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendLateDispensationEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendLateDispensationEmailResponse>) { (Object as any).assign(this, init); }
}

export class QueuePatientOcTransferResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueuePatientOcTransferResponse>) { (Object as any).assign(this, init); }
}

export class QueuePatientsOcTransferResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueuePatientsOcTransferResponse>) { (Object as any).assign(this, init); }
}

export class QueueCreatePatientStaffEventInOcResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueueCreatePatientStaffEventInOcResponse>) { (Object as any).assign(this, init); }
}

export class SendNewSaeEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendNewSaeEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeNotifyInvestigatorEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeNotifyInvestigatorEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeNotifySponsorEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeNotifySponsorEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeNotifyMedicalReviewerEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeNotifyMedicalReviewerEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeInvestigatorReviewEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeInvestigatorReviewEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeTrialTeamReviewEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeTrialTeamReviewEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeMedicalReviewEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeMedicalReviewEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeBlueCardNotificationEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeBlueCardNotificationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeDeathNotificationEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeDeathNotificationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendUnapprovedSaeEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendUnapprovedSaeEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendUnresolvedSaeEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendUnresolvedSaeEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendIncompleteSaesEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;
    public incompleteSaesCount: number;

    public constructor(init?: Partial<SendIncompleteSaesEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendPendingSaeMedicalReviewEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendPendingSaeMedicalReviewEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendDrugShipmentQuarantinedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDrugShipmentQuarantinedEmailResponse>) { (Object as any).assign(this, init); }
}

export class MarkPatientsOffTreatmentResponse
{
    public patientsMarkedOffTreatment: string[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MarkPatientsOffTreatmentResponse>) { (Object as any).assign(this, init); }
}

export class SendDataCleaningReportsEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDataCleaningReportsEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendErrorEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendErrorEmailResponse>) { (Object as any).assign(this, init); }
}

export class GetEnumerationTypesResponse
{
    public patientStatus?: PatientStatuses;
    public formType?: FormTypes;
    public eventType?: EventTypes;
    public drugType?: DrugTypes;
    public lookupCancerStageType?: LookupCancerStageType;
    public lookupConditionalIneligibleType?: LookupConditionalIneligibleType;
    public lookupGenderType?: LookupGenderType;
    public lookupGreaterThanLessThanType?: LookupGreaterThanLessThanType;
    public lookupIndigenousStatusType?: LookupIndigenousStatusType;
    public lookupIneligibleType?: LookupIneligibleType;
    public lookupMenopausalStatusType?: LookupMenopausalStatusType;
    public lookupSpecificationType?: LookupSpecificationType;
    public lookupTnmDistantMetastasisType?: LookupTnmDistantMetastasisType;
    public lookupTnmNodesType?: LookupTnmNodesType;
    public lookupTnmTumourType?: LookupTnmTumourType;
    public lookupUntyped?: LookupUntyped;
    public lookupYesNoNaType?: LookupYesNoNaType;
    public lookupYesNoType?: LookupYesNoType;
    public lookupGramPerUnitType?: LookupGramPerUnitType;
    public lookupMammogramType?: LookupMammogramType;
    public lookupHistopathologicalGradeType?: LookupHistopathologicalGradeType;
    public lookupLastMenstrualPeriodType?: LookupLastMenstrualPeriodType;

    public constructor(init?: Partial<GetEnumerationTypesResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public personnel: { [index: number]: Personnel; };

    public constructor(init?: Partial<InstitutionPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class QueueMultipleRandomisationEmailsResponse
{
    public count: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueueMultipleRandomisationEmailsResponse>) { (Object as any).assign(this, init); }
}

export class SendMultipleRandomisationEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendMultipleRandomisationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendScreeningFailEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendScreeningFailEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendInvalidSaeEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendInvalidSaeEmailResponse>) { (Object as any).assign(this, init); }
}

export class MarkAsIneligiblePatientResponse
{
    public responseStatus: ResponseStatus;
    public patient: IPatient;

    public constructor(init?: Partial<MarkAsIneligiblePatientResponse>) { (Object as any).assign(this, init); }
}

export class FormsDueSummaryReportDataResponse
{
    public responseStatus: ResponseStatus;
    public formsDueSummary: FormsDueSummary[];

    public constructor(init?: Partial<FormsDueSummaryReportDataResponse>) { (Object as any).assign(this, init); }
}

export class GetFormsDueScheduleDataResponse
{
    public responseStatus: ResponseStatus;
    public formsDueSchedule: FormsDueSchedule[];

    public constructor(init?: Partial<GetFormsDueScheduleDataResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentReportDataResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentReportDataResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientActionReportDataResponse
{
    public responseStatus: ResponseStatus;
    public patientActions: PatientAction[];

    public constructor(init?: Partial<GetPatientActionReportDataResponse>) { (Object as any).assign(this, init); }
}

export class GetSitetStatusReportResponse
{
    public responseStatus: ResponseStatus;
    public siteStatus: SiteStatus[];

    public constructor(init?: Partial<GetSitetStatusReportResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugManagementLogDataResponse
{
    public responseStatus: ResponseStatus;
    public drugManagementLogs: DrugManagementLog[];

    public constructor(init?: Partial<GetDrugManagementLogDataResponse>) { (Object as any).assign(this, init); }
}

export class GetTpRegistrationByInstitutionIdResponse
{
    public data: { [index: string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTpRegistrationByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTpDrugManagementByInstitutionIdResponse
{
    public data: { [index: string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTpDrugManagementByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTpSaeByInstitutionIdResponse
{
    public data: { [index: string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTpSaeByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public profileUrl: string;

    // @DataMember(Order=9)
    public roles: string[];

    // @DataMember(Order=10)
    public permissions: string[];

    // @DataMember(Order=11)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=12)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchesResponse
{
    public responseStatus: ResponseStatus;
    public batches: Batch[];

    public constructor(init?: Partial<GetBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchByIdResponse
{
    public responseStatus: ResponseStatus;
    public batch: Batch;

    public constructor(init?: Partial<GetBatchByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchesByIdsResponse
{
    public responseStatus: ResponseStatus;
    public batches: Batch[];

    public constructor(init?: Partial<GetBatchesByIdsResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchesExpiringAtSpecifiedDateResponse
{
    public responseStatus: ResponseStatus;
    public batches: Batch[];

    public constructor(init?: Partial<GetBatchesExpiringAtSpecifiedDateResponse>) { (Object as any).assign(this, init); }
}

export class SetBatchResponse
{
    public responseStatus: ResponseStatus;
    public batch: Batch;

    public constructor(init?: Partial<SetBatchResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchByIdResponse
{
    public responseStatus: ResponseStatus;
    public depotBatch: DepotBatch;

    public constructor(init?: Partial<GetDepotBatchByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByDepotIdResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByDepotIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByPharmacyIdResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByPharmacyIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByDrugShipmentIdResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByDrugShipmentIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByBatchIdsResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByBatchIdsResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesWithLowStockByDepotIdsResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesWithLowStockByDepotIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetDepotBatchResponse
{
    public responseStatus: ResponseStatus;
    public depotBatch: DepotBatch;

    public constructor(init?: Partial<SetDepotBatchResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotsResponse
{
    public responseStatus: ResponseStatus;
    public depots: Depot[];

    public constructor(init?: Partial<GetDepotsResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotByIdResponse
{
    public responseStatus: ResponseStatus;
    public depot: Depot;

    public constructor(init?: Partial<GetDepotByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotsByDrugUnderThresholdResponse
{
    public responseStatus: ResponseStatus;
    public depotIds: number[];

    public constructor(init?: Partial<GetDepotsByDrugUnderThresholdResponse>) { (Object as any).assign(this, init); }
}

export class SetDepotResponse
{
    public responseStatus: ResponseStatus;
    public depot: Depot;

    public constructor(init?: Partial<SetDepotResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationsResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensations: DrugDispensation[];

    public constructor(init?: Partial<GetDrugDispensationsResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationByIdResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<GetDrugDispensationByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationByPatientIdResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensations: DrugDispensation[];

    public constructor(init?: Partial<GetDrugDispensationByPatientIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientsWithLateDispensationsResponse
{
    public responseStatus: ResponseStatus;
    public patientIds: number[];

    public constructor(init?: Partial<GetPatientsWithLateDispensationsResponse>) { (Object as any).assign(this, init); }
}

export class GetLastDispensationForPatientIdResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<GetLastDispensationForPatientIdResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugDispensationResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<SetDrugDispensationResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugsResponse
{
    public responseStatus: ResponseStatus;
    public drugs: Drug[];

    public constructor(init?: Partial<GetDrugsResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugByIdResponse
{
    public responseStatus: ResponseStatus;
    public drug: Drug;

    public constructor(init?: Partial<GetDrugByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugsByTimepointAndTreatmentResponse
{
    public responseStatus: ResponseStatus;
    public drugs: Drug[];

    public constructor(init?: Partial<GetDrugsByTimepointAndTreatmentResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentDepotBatchesResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatches: DrugShipmentDepotBatch[];

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentDepotBatchByIdResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatch: DrugShipmentDepotBatch;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentDepotBatchesByPharmacyIdResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatches: DrugShipmentDepotBatch[];

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesByPharmacyIdResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugShipmentDepotBatchResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatch: DrugShipmentDepotBatch;

    public constructor(init?: Partial<SetDrugShipmentDepotBatchResponse>) { (Object as any).assign(this, init); }
}

export class StartDrugShipmentGenerationResponse
{
    public responseStatus: ResponseStatus;
    public messages: string[];
    public createdDrugShipments: DrugShipment[];

    public constructor(init?: Partial<StartDrugShipmentGenerationResponse>) { (Object as any).assign(this, init); }
}

export class CreateDrugShipmentFromPatientResponse
{
    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<CreateDrugShipmentFromPatientResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsByInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsByInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentByIdResponse
{
    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<GetDrugShipmentByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsByIdsResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsByIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugShipmentResponse
{
    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipmentResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugShipmentStatusResponse
{
    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipmentStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteDrugShipmentResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteDrugShipmentResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugShipmentVerifyResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentVerify: DrugShipmentVerify;

    public constructor(init?: Partial<SetDrugShipmentVerifyResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsNotOrderedByExpectedDateResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsNotOrderedByExpectedDateResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsNotShippedByExpectedDateResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsNotShippedByExpectedDateResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsNotReceivedByExpectedDateResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsNotReceivedByExpectedDateResponse>) { (Object as any).assign(this, init); }
}

export class GetOrderFormsResponse
{
    public responseStatus: ResponseStatus;
    public orderForms: OrderForm[];

    public constructor(init?: Partial<GetOrderFormsResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientDrugsResponse
{
    public responseStatus: ResponseStatus;
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<GetPatientDrugsResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientDrugsByPatientIdResponse
{
    public responseStatus: ResponseStatus;
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<GetPatientDrugsByPatientIdResponse>) { (Object as any).assign(this, init); }
}

export class SetPatientDrugsResponse
{
    public responseStatus: ResponseStatus;
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<SetPatientDrugsResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmaciesResponse
{
    public responseStatus: ResponseStatus;
    public pharmacies: Pharmacy[];

    public constructor(init?: Partial<GetPharmaciesResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyByIdResponse
{
    public responseStatus: ResponseStatus;
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<GetPharmacyByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyByInstitutionCodeResponse
{
    public responseStatus: ResponseStatus;
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<GetPharmacyByInstitutionCodeResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyBatchesDrugRemainingByBatchIdsResponse
{
    public responseStatus: ResponseStatus;
    public pharmacyBatchesDrugRemaining: PharmacyBatchDrugRemaining[];

    public constructor(init?: Partial<GetPharmacyBatchesDrugRemainingByBatchIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetPharmacyResponse
{
    public responseStatus: ResponseStatus;
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<SetPharmacyResponse>) { (Object as any).assign(this, init); }
}

export class QuarantinePharmacyStockResponse
{
    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<QuarantinePharmacyStockResponse>) { (Object as any).assign(this, init); }
}

export class ActionQuarantinedStockResponse
{
    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<ActionQuarantinedStockResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmaciesByDrugUnderThresholdResponse
{
    public responseStatus: ResponseStatus;
    public pharmacyIds: number[];
    public drugIds: number[];
    public drugUnits: number[];

    public constructor(init?: Partial<GetPharmaciesByDrugUnderThresholdResponse>) { (Object as any).assign(this, init); }
}

export class GetTimepointsResponse
{
    public responseStatus: ResponseStatus;
    public timepoints: Timepoint[];

    public constructor(init?: Partial<GetTimepointsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SaeCollectionResponse
{
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /**
    * The retrieved saes.
    */
    // @DataMember(Order=2)
    public saes: Sae<SaeForm,Patient>[];

    public constructor(init?: Partial<SaeCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SaeSingleResponse
{
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /**
    * The retrieved sae.
    */
    // @DataMember(Order=2)
    public sae: Sae<SaeForm, Patient>;

    public constructor(init?: Partial<SaeSingleResponse>) { (Object as any).assign(this, init); }
}

export class SaeGetCollectionByStatusResponse
{
    public responseStatus: ResponseStatus;
    public saes: Sae<ISaeForm,IPatient>[];

    public constructor(init?: Partial<SaeGetCollectionByStatusResponse>) { (Object as any).assign(this, init); }
}

export class SaeWebActionSaveResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaeWebActionSaveResponse>) { (Object as any).assign(this, init); }
}

export class SaeSendNotificationResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaeSendNotificationResponse>) { (Object as any).assign(this, init); }
}

export class SaveInvalidSaeFormResponse
{
    public responseStatus: ResponseStatus;
    public invalidSaeForm: InvalidSaeForm;

    public constructor(init?: Partial<SaveInvalidSaeFormResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInvalidSaeFormResponse
{
    public responseStatus: ResponseStatus;
    public validationResult: SaeFormValidationResult;

    public constructor(init?: Partial<ValidateInvalidSaeFormResponse>) { (Object as any).assign(this, init); }
}

export class SaeMedicalReviewSingleResponse implements ISaeMedicalReviewSingleResponse
{
    public saeMedicalReview: SaeMedicalReview;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaeMedicalReviewSingleResponse>) { (Object as any).assign(this, init); }
}

export class SaeMedicalReviewNarrativeSummaryPostSaveResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaeMedicalReviewNarrativeSummaryPostSaveResponse>) { (Object as any).assign(this, init); }
}

export class EventSingleResponse
{
    public responseStatus: ResponseStatus;
    public event: Event;

    public constructor(init?: Partial<EventSingleResponse>) { (Object as any).assign(this, init); }
}

export class EventCollectionResponse
{
    public responseStatus: ResponseStatus;
    public events: Event[];

    public constructor(init?: Partial<EventCollectionResponse>) { (Object as any).assign(this, init); }
}

export class EventSingleDeleteResponse implements IEventSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<EventSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeSingleResponse
{
    public responseStatus: ResponseStatus;
    public eventType: EventType;

    public constructor(init?: Partial<EventTypeSingleResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeCollectionResponse
{
    public responseStatus: ResponseStatus;
    public eventTypes: EventType[];

    public constructor(init?: Partial<EventTypeCollectionResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeSingleDeleteResponse implements IEventTypeSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<EventTypeSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeStateSingleResponse
{
    public responseStatus: ResponseStatus;
    public eventTypeState: EventTypeState;

    public constructor(init?: Partial<EventTypeStateSingleResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeStateCollectionResponse
{
    public responseStatus: ResponseStatus;
    public eventTypeStates: EventTypeState[];

    public constructor(init?: Partial<EventTypeStateCollectionResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeStateSingleDeleteResponse implements IEventTypeStateSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<EventTypeStateSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeFormTypeSingleResponse
{
    public responseStatus: ResponseStatus;
    public eventTypeFormType: EventTypeFormType;

    public constructor(init?: Partial<EventTypeFormTypeSingleResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeFormTypeCollectionResponse
{
    public responseStatus: ResponseStatus;
    public eventTypeFormTypes: EventTypeFormType[];

    public constructor(init?: Partial<EventTypeFormTypeCollectionResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeFormTypeSingleDeleteResponse implements IEventTypeFormTypeSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<EventTypeFormTypeSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeFormTypeStateSingleResponse
{
    public responseStatus: ResponseStatus;
    public eventTypeFormTypeState: EventTypeFormTypeState;

    public constructor(init?: Partial<EventTypeFormTypeStateSingleResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeFormTypeStateCollectionResponse
{
    public responseStatus: ResponseStatus;
    public eventTypeFormTypeStates: EventTypeFormTypeState[];

    public constructor(init?: Partial<EventTypeFormTypeStateCollectionResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeFormTypeStateSingleDeleteResponse implements IEventTypeFormTypeStateSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<EventTypeFormTypeStateSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeFormTypeStateValidationSingleResponse
{
    public responseStatus: ResponseStatus;
    public eventTypeFormTypeStateValidation: EventTypeFormTypeStateValidation;

    public constructor(init?: Partial<EventTypeFormTypeStateValidationSingleResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeFormTypeStateValidationCollectionResponse
{
    public responseStatus: ResponseStatus;
    public eventTypeFormTypeStateValidations: EventTypeFormTypeStateValidation[];

    public constructor(init?: Partial<EventTypeFormTypeStateValidationCollectionResponse>) { (Object as any).assign(this, init); }
}

export class EventTypeFormTypeStateValidationSingleDeleteResponse implements IEventTypeFormTypeStateValidationSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<EventTypeFormTypeStateValidationSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class PatientSingleResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<PatientSingleResponse>) { (Object as any).assign(this, init); }
}

export class PatientCollectionResponse
{
    public responseStatus: ResponseStatus;
    public patients: Patient[];

    public constructor(init?: Partial<PatientCollectionResponse>) { (Object as any).assign(this, init); }
}

export class PatientSingleDeleteResponse implements IPatientSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<PatientSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionSingleResponse
{
    public responseStatus: ResponseStatus;
    public institution: Institution;

    public constructor(init?: Partial<InstitutionSingleResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionCollectionResponse
{
    public responseStatus: ResponseStatus;
    public institutions: Institution[];

    public constructor(init?: Partial<InstitutionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionSingleDeleteResponse implements IInstitutionSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<InstitutionSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class FormTypeLookupCollectionResponse
{
    public responseStatus: ResponseStatus;
    public lookups: Lookup[];

    public constructor(init?: Partial<FormTypeLookupCollectionResponse>) { (Object as any).assign(this, init); }
}

export class FormTypeSingleResponse
{
    public responseStatus: ResponseStatus;
    public formType: FormType;

    public constructor(init?: Partial<FormTypeSingleResponse>) { (Object as any).assign(this, init); }
}

export class FormTypeCollectionResponse
{
    public responseStatus: ResponseStatus;
    public formTypes: FormType[];

    public constructor(init?: Partial<FormTypeCollectionResponse>) { (Object as any).assign(this, init); }
}

export class FormTypeSingleDeleteResponse implements IFormTypeSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<FormTypeSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class FormTypePropertySingleResponse
{
    public responseStatus: ResponseStatus;
    public formTypeProperty: FormTypeProperty;

    public constructor(init?: Partial<FormTypePropertySingleResponse>) { (Object as any).assign(this, init); }
}

export class FormTypePropertyCollectionResponse
{
    public responseStatus: ResponseStatus;
    public formTypeProperties: FormTypeProperty[];

    public constructor(init?: Partial<FormTypePropertyCollectionResponse>) { (Object as any).assign(this, init); }
}

export class FormTypePropertySingleDeleteResponse implements IFormTypePropertySingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<FormTypePropertySingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class FormTypePropertyErrorMessageSingleResponse
{
    public responseStatus: ResponseStatus;
    public formTypePropertyErrorMessage: FormTypePropertyErrorMessage;

    public constructor(init?: Partial<FormTypePropertyErrorMessageSingleResponse>) { (Object as any).assign(this, init); }
}

export class FormTypePropertyErrorMessageCollectionResponse
{
    public responseStatus: ResponseStatus;
    public formTypePropertyErrorMessages: FormTypePropertyErrorMessage[];

    public constructor(init?: Partial<FormTypePropertyErrorMessageCollectionResponse>) { (Object as any).assign(this, init); }
}

export class FormTypePropertyErrorMessageSingleDeleteResponse implements IFormTypePropertyErrorMessageSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<FormTypePropertyErrorMessageSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class GetOpmsTypeMappingResponse
{
    public responseStatus: ResponseStatus;
    public forms: OpmsTypeMapping[];
    public event: string;
    public eventType: string;
    public eventTypeFormType: string;
    public eventTypeFormTypeState: string;
    public eventTypeFormTypeStateValidation: string;
    public formType: string;
    public formTypeProperty: string;
    public formTypePropertyErrorMessage: string;
    public patient: string;
    public institution: string;
    public validationResult: string;
    public validationError: string;
    public lookup: string;
    public lookupItem: string;

    public constructor(init?: Partial<GetOpmsTypeMappingResponse>) { (Object as any).assign(this, init); }
}

export class UploadTempFileResponse
{
    public responseStatus: ResponseStatus;
    public guid: string;

    public constructor(init?: Partial<UploadTempFileResponse>) { (Object as any).assign(this, init); }
}

export class GetTempFileInfoResponse
{
    public responseStatus: ResponseStatus;
    public temporaryFile: TemporaryFile;

    public constructor(init?: Partial<GetTempFileInfoResponse>) { (Object as any).assign(this, init); }
}

export class ConcomitantMedicationSingleResponse
{
    public responseStatus: ResponseStatus;
    public form: ConcomitantMedication;

    public constructor(init?: Partial<ConcomitantMedicationSingleResponse>) { (Object as any).assign(this, init); }
}

export class ConcomitantMedicationCollectionResponse
{
    public responseStatus: ResponseStatus;
    public forms: ConcomitantMedication[];

    public constructor(init?: Partial<ConcomitantMedicationCollectionResponse>) { (Object as any).assign(this, init); }
}

export class ConcomitantMedicationSingleValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ValidationResult;

    public constructor(init?: Partial<ConcomitantMedicationSingleValidationResponse>) { (Object as any).assign(this, init); }
}

export class ConcomitantMedicationSingleDeleteResponse implements IFormSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<ConcomitantMedicationSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class DiagnosticAndPathologyDataSingleResponse
{
    public responseStatus: ResponseStatus;
    public form: DiagnosticAndPathologyData;

    public constructor(init?: Partial<DiagnosticAndPathologyDataSingleResponse>) { (Object as any).assign(this, init); }
}

export class DiagnosticAndPathologyDataCollectionResponse
{
    public responseStatus: ResponseStatus;
    public forms: DiagnosticAndPathologyData[];

    public constructor(init?: Partial<DiagnosticAndPathologyDataCollectionResponse>) { (Object as any).assign(this, init); }
}

export class DiagnosticAndPathologyDataSingleValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ValidationResult;

    public constructor(init?: Partial<DiagnosticAndPathologyDataSingleValidationResponse>) { (Object as any).assign(this, init); }
}

export class DiagnosticAndPathologyDataSingleDeleteResponse implements IFormSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<DiagnosticAndPathologyDataSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class DiagnosticImagingAndTumourAssessmentSingleResponse
{
    public responseStatus: ResponseStatus;
    public form: DiagnosticImagingAndTumourAssessment;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentSingleResponse>) { (Object as any).assign(this, init); }
}

export class DiagnosticImagingAndTumourAssessmentCollectionResponse
{
    public responseStatus: ResponseStatus;
    public forms: DiagnosticImagingAndTumourAssessment[];

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentCollectionResponse>) { (Object as any).assign(this, init); }
}

export class DiagnosticImagingAndTumourAssessmentSingleValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ValidationResult;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentSingleValidationResponse>) { (Object as any).assign(this, init); }
}

export class DiagnosticImagingAndTumourAssessmentSingleDeleteResponse implements IFormSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class EligibilityChecklistSingleResponse
{
    public responseStatus: ResponseStatus;
    public form: EligibilityChecklist;

    public constructor(init?: Partial<EligibilityChecklistSingleResponse>) { (Object as any).assign(this, init); }
}

export class EligibilityChecklistCollectionResponse
{
    public responseStatus: ResponseStatus;
    public forms: EligibilityChecklist[];

    public constructor(init?: Partial<EligibilityChecklistCollectionResponse>) { (Object as any).assign(this, init); }
}

export class EligibilityChecklistSingleValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ValidationResult;

    public constructor(init?: Partial<EligibilityChecklistSingleValidationResponse>) { (Object as any).assign(this, init); }
}

export class EligibilityChecklistSingleDeleteResponse implements IFormSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<EligibilityChecklistSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class GeneralSingleResponse
{
    public responseStatus: ResponseStatus;
    public form: General;

    public constructor(init?: Partial<GeneralSingleResponse>) { (Object as any).assign(this, init); }
}

export class GeneralCollectionResponse
{
    public responseStatus: ResponseStatus;
    public forms: General[];

    public constructor(init?: Partial<GeneralCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GeneralSingleValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ValidationResult;

    public constructor(init?: Partial<GeneralSingleValidationResponse>) { (Object as any).assign(this, init); }
}

export class GeneralSingleDeleteResponse implements IFormSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<GeneralSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class HaematologyAndBiochemistrySingleResponse
{
    public responseStatus: ResponseStatus;
    public form: HaematologyAndBiochemistry;

    public constructor(init?: Partial<HaematologyAndBiochemistrySingleResponse>) { (Object as any).assign(this, init); }
}

export class HaematologyAndBiochemistryCollectionResponse
{
    public responseStatus: ResponseStatus;
    public forms: HaematologyAndBiochemistry[];

    public constructor(init?: Partial<HaematologyAndBiochemistryCollectionResponse>) { (Object as any).assign(this, init); }
}

export class HaematologyAndBiochemistrySingleValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ValidationResult;

    public constructor(init?: Partial<HaematologyAndBiochemistrySingleValidationResponse>) { (Object as any).assign(this, init); }
}

export class HaematologyAndBiochemistrySingleDeleteResponse implements IFormSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<HaematologyAndBiochemistrySingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class MedicalConditionSingleResponse
{
    public responseStatus: ResponseStatus;
    public form: MedicalCondition;

    public constructor(init?: Partial<MedicalConditionSingleResponse>) { (Object as any).assign(this, init); }
}

export class MedicalConditionCollectionResponse
{
    public responseStatus: ResponseStatus;
    public forms: MedicalCondition[];

    public constructor(init?: Partial<MedicalConditionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class MedicalConditionSingleValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ValidationResult;

    public constructor(init?: Partial<MedicalConditionSingleValidationResponse>) { (Object as any).assign(this, init); }
}

export class MedicalConditionSingleDeleteResponse implements IFormSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<MedicalConditionSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class MedicalHistoryAndConcomitantMedicationsSingleResponse
{
    public responseStatus: ResponseStatus;
    public form: MedicalHistoryAndConcomitantMedications;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsSingleResponse>) { (Object as any).assign(this, init); }
}

export class MedicalHistoryAndConcomitantMedicationsCollectionResponse
{
    public responseStatus: ResponseStatus;
    public forms: MedicalHistoryAndConcomitantMedications[];

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsCollectionResponse>) { (Object as any).assign(this, init); }
}

export class MedicalHistoryAndConcomitantMedicationsSingleValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ValidationResult;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsSingleValidationResponse>) { (Object as any).assign(this, init); }
}

export class MedicalHistoryAndConcomitantMedicationsSingleDeleteResponse implements IFormSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class OtherMedicalConditionSingleResponse
{
    public responseStatus: ResponseStatus;
    public form: OtherMedicalCondition;

    public constructor(init?: Partial<OtherMedicalConditionSingleResponse>) { (Object as any).assign(this, init); }
}

export class OtherMedicalConditionCollectionResponse
{
    public responseStatus: ResponseStatus;
    public forms: OtherMedicalCondition[];

    public constructor(init?: Partial<OtherMedicalConditionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class OtherMedicalConditionSingleValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ValidationResult;

    public constructor(init?: Partial<OtherMedicalConditionSingleValidationResponse>) { (Object as any).assign(this, init); }
}

export class OtherMedicalConditionSingleDeleteResponse implements IFormSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<OtherMedicalConditionSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class PreregistrationSingleResponse
{
    public responseStatus: ResponseStatus;
    public form: Preregistration;

    public constructor(init?: Partial<PreregistrationSingleResponse>) { (Object as any).assign(this, init); }
}

export class PreregistrationCollectionResponse
{
    public responseStatus: ResponseStatus;
    public forms: Preregistration[];

    public constructor(init?: Partial<PreregistrationCollectionResponse>) { (Object as any).assign(this, init); }
}

export class PreregistrationSingleValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ValidationResult;

    public constructor(init?: Partial<PreregistrationSingleValidationResponse>) { (Object as any).assign(this, init); }
}

export class PreregistrationSingleDeleteResponse implements IFormSingleDeleteResponse
{
    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<PreregistrationSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class HasOpmsPermissionCollectionResponse
{
    public responseStatus: ResponseStatus;
    public hasPermission: { [index: number]: boolean; };

    public constructor(init?: Partial<HasOpmsPermissionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelNamesResponse
{
    public responseStatus: ResponseStatus;
    public personnelNames: { [index: number]: string; };

    public constructor(init?: Partial<InstitutionPersonnelNamesResponse>) { (Object as any).assign(this, init); }
}

export class TrialPersonnelActiveRoleResponse
{
    public responseStatus: ResponseStatus;
    public hasRole: { [index: number]: boolean; };

    public constructor(init?: Partial<TrialPersonnelActiveRoleResponse>) { (Object as any).assign(this, init); }
}

export class SaeAwaitingInvestigatorNotifyEmail
{
    public saeIdentifier?: number;
    public patientIdentifier: string;

    public constructor(init?: Partial<SaeAwaitingInvestigatorNotifyEmail>) { (Object as any).assign(this, init); }
}

export class SaeAwaitingMedicalReviewerNotifyEmail
{
    public saeIdentifier?: number;
    public patientIdentifier: string;

    public constructor(init?: Partial<SaeAwaitingMedicalReviewerNotifyEmail>) { (Object as any).assign(this, init); }
}

// @Route("/get/accrual-counts/", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetAccrualCounts implements IReturn<GetAccrualCountsResponse>
{

    public constructor(init?: Partial<GetAccrualCounts>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAccrualCountsResponse(); }
    public getTypeName() { return 'GetAccrualCounts'; }
}

export class CompleteScreening implements IReturn<CompleteScreeningResponse>
{
    public patientId?: number;

    public constructor(init?: Partial<CompleteScreening>) { (Object as any).assign(this, init); }
    public createResponse() { return new CompleteScreeningResponse(); }
    public getTypeName() { return 'CompleteScreening'; }
}

export class RegisterPatient implements IReturn<RegisterPatientResponse>
{
    public patientId?: number;

    public constructor(init?: Partial<RegisterPatient>) { (Object as any).assign(this, init); }
    public createResponse() { return new RegisterPatientResponse(); }
    public getTypeName() { return 'RegisterPatient'; }
}

export class RandomisePatient implements IReturn<RegisterPatientResponse>
{
    public patientId?: number;

    public constructor(init?: Partial<RandomisePatient>) { (Object as any).assign(this, init); }
    public createResponse() { return new RegisterPatientResponse(); }
    public getTypeName() { return 'RandomisePatient'; }
}

export class SendScreeningEmail implements IReturn<SendScreeningEmailResponse>
{
    public patientId?: number;

    public constructor(init?: Partial<SendScreeningEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendScreeningEmailResponse(); }
    public getTypeName() { return 'SendScreeningEmail'; }
}

export class SendFormsDueSummaryEmail implements IReturn<SendFormsDueSummaryEmailResponse>
{
    public instCode: string;

    public constructor(init?: Partial<SendFormsDueSummaryEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendFormsDueSummaryEmailResponse(); }
    public getTypeName() { return 'SendFormsDueSummaryEmail'; }
}

export class SendDrugShipmentGenerationEmail implements IReturn<SendDrugShipmentGenerationEmailResponse>
{
    public drugShipmentIds: number[];

    public constructor(init?: Partial<SendDrugShipmentGenerationEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendDrugShipmentGenerationEmailResponse(); }
    public getTypeName() { return 'SendDrugShipmentGenerationEmail'; }
}

// @Route("/api/drug-shipment/generate", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GenerateDrugShipments implements IReturn<GenerateDrugShipmentsResponse>, IPost
{

    public constructor(init?: Partial<GenerateDrugShipments>) { (Object as any).assign(this, init); }
    public createResponse() { return new GenerateDrugShipmentsResponse(); }
    public getTypeName() { return 'GenerateDrugShipments'; }
}

export class SendDrugShipmentNotCreatedEmail implements IReturn<SendDrugShipmentNotCreatedEmailResponse>
{
    public drugId?: number;
    public drugUnits?: number;
    public institutionCode: string;
    public patientId?: number;

    public constructor(init?: Partial<SendDrugShipmentNotCreatedEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendDrugShipmentNotCreatedEmailResponse(); }
    public getTypeName() { return 'SendDrugShipmentNotCreatedEmail'; }
}

export class SendDrugShipmentOrderedEmail implements IReturn<SendDrugShipmentOrderedEmailResponse>
{
    public drugShipmentId: number;

    public constructor(init?: Partial<SendDrugShipmentOrderedEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendDrugShipmentOrderedEmailResponse(); }
    public getTypeName() { return 'SendDrugShipmentOrderedEmail'; }
}

export class SendStagnantNewDrugOrdersEmail implements IReturn<SendStagnantNewDrugOrdersEmailResponse>
{
    public drugShipmentIds: number[];

    public constructor(init?: Partial<SendStagnantNewDrugOrdersEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendStagnantNewDrugOrdersEmailResponse(); }
    public getTypeName() { return 'SendStagnantNewDrugOrdersEmail'; }
}

export class SendStagnantDrugOrdersEmail implements IReturn<SendStagnantDrugOrdersEmailResponse>
{
    public drugShipmentIds: number[];

    public constructor(init?: Partial<SendStagnantDrugOrdersEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendStagnantDrugOrdersEmailResponse(); }
    public getTypeName() { return 'SendStagnantDrugOrdersEmail'; }
}

export class SendStagnantDrugShipmentsEmail implements IReturn<SendStagnantDrugShipmentsEmailResponse>
{
    public drugShipmentIds: number[];

    public constructor(init?: Partial<SendStagnantDrugShipmentsEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendStagnantDrugShipmentsEmailResponse(); }
    public getTypeName() { return 'SendStagnantDrugShipmentsEmail'; }
}

export class SendExpiringStockEmail implements IReturn<SendExpiringStockEmailResponse>
{
    public batchIds: number[];

    public constructor(init?: Partial<SendExpiringStockEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendExpiringStockEmailResponse(); }
    public getTypeName() { return 'SendExpiringStockEmail'; }
}

export class SendLowStockEmail implements IReturn<SendLowStockEmailResponse>
{
    public depotIds: number[];
    public drugThreshold: number;

    public constructor(init?: Partial<SendLowStockEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendLowStockEmailResponse(); }
    public getTypeName() { return 'SendLowStockEmail'; }
}

export class SendPharmacyLowStockEmail implements IReturn<SendPharmacyLowStockEmailResponse>
{
    public pharmacyIds: number[];
    public drugIds: number[];
    public drugUnits: number[];
    public drugThreshold: number;

    public constructor(init?: Partial<SendPharmacyLowStockEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendPharmacyLowStockEmailResponse(); }
    public getTypeName() { return 'SendPharmacyLowStockEmail'; }
}

export class SendLateDispensationEmail implements IReturn<SendLateDispensationEmailResponse>
{
    public patientId: number;

    public constructor(init?: Partial<SendLateDispensationEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendLateDispensationEmailResponse(); }
    public getTypeName() { return 'SendLateDispensationEmail'; }
}

// @Route("/api/oc/patient-transfer", "POST")
export class QueuePatientOcTransfer implements IReturn<QueuePatientOcTransferResponse>
{
    public patientId?: number;

    public constructor(init?: Partial<QueuePatientOcTransfer>) { (Object as any).assign(this, init); }
    public createResponse() { return new QueuePatientOcTransferResponse(); }
    public getTypeName() { return 'QueuePatientOcTransfer'; }
}

export class QueuePatientsOcTransfer implements IReturn<QueuePatientsOcTransferResponse>
{

    public constructor(init?: Partial<QueuePatientsOcTransfer>) { (Object as any).assign(this, init); }
    public createResponse() { return new QueuePatientsOcTransferResponse(); }
    public getTypeName() { return 'QueuePatientsOcTransfer'; }
}

export class QueueCreatePatientStaffEventInOc implements IReturn<QueueCreatePatientStaffEventInOcResponse>
{
    public patientId?: number;

    public constructor(init?: Partial<QueueCreatePatientStaffEventInOc>) { (Object as any).assign(this, init); }
    public createResponse() { return new QueueCreatePatientStaffEventInOcResponse(); }
    public getTypeName() { return 'QueueCreatePatientStaffEventInOc'; }
}

export class SendNewSaeEmail implements IReturn<SendNewSaeEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;
    public initialEmail: boolean;

    public constructor(init?: Partial<SendNewSaeEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendNewSaeEmailResponse(); }
    public getTypeName() { return 'SendNewSaeEmail'; }
}

export class SendSaeNotifyInvestigatorEmail implements IReturn<SendSaeNotifyInvestigatorEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;
    public initialEmail: boolean;
    public recipientIds: number[];
    public ccRecipientIds: number[];
    public attachmentNames: string[];
    public attachmentGuids: string[];
    public includedNotes: string;

    public constructor(init?: Partial<SendSaeNotifyInvestigatorEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendSaeNotifyInvestigatorEmailResponse(); }
    public getTypeName() { return 'SendSaeNotifyInvestigatorEmail'; }
}

export class SendSaeNotifySponsorEmail implements IReturn<SendSaeNotifySponsorEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;
    public initialEmail: boolean;
    public attachmentNames: string[];
    public attachmentGuids: string[];
    public includedNotes: string;

    public constructor(init?: Partial<SendSaeNotifySponsorEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendSaeNotifySponsorEmailResponse(); }
    public getTypeName() { return 'SendSaeNotifySponsorEmail'; }
}

export class SendSaeNotifyMedicalReviewerEmail implements IReturn<SendSaeNotifyMedicalReviewerEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;
    public initialEmail: boolean;
    public recipientIds: number[];
    public ccRecipientIds: number[];
    public attachmentNames: string[];
    public attachmentGuids: string[];
    public includedNotes: string;
    public sendBctEmailsToSharedMailbox: boolean;

    public constructor(init?: Partial<SendSaeNotifyMedicalReviewerEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendSaeNotifyMedicalReviewerEmailResponse(); }
    public getTypeName() { return 'SendSaeNotifyMedicalReviewerEmail'; }
}

export class SendSaeInvestigatorReviewEmail implements IReturn<SendSaeInvestigatorReviewEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;
    public approved: boolean;
    public reasonForRejection: string;

    public constructor(init?: Partial<SendSaeInvestigatorReviewEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendSaeInvestigatorReviewEmailResponse(); }
    public getTypeName() { return 'SendSaeInvestigatorReviewEmail'; }
}

export class SendSaeTrialTeamReviewEmail implements IReturn<SendSaeTrialTeamReviewEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;
    public approved: boolean;
    public reasonForRejection: string;
    public rejectedAs: boolean;

    public constructor(init?: Partial<SendSaeTrialTeamReviewEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendSaeTrialTeamReviewEmailResponse(); }
    public getTypeName() { return 'SendSaeTrialTeamReviewEmail'; }
}

export class SendSaeMedicalReviewEmail implements IReturn<SendSaeMedicalReviewEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;
    public medicalReviewDetails: string;

    public constructor(init?: Partial<SendSaeMedicalReviewEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendSaeMedicalReviewEmailResponse(); }
    public getTypeName() { return 'SendSaeMedicalReviewEmail'; }
}

export class SendSaeBlueCardNotificationEmail implements IReturn<SendSaeBlueCardNotificationEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;
    public medicalReviewDetails: string;

    public constructor(init?: Partial<SendSaeBlueCardNotificationEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendSaeBlueCardNotificationEmailResponse(); }
    public getTypeName() { return 'SendSaeBlueCardNotificationEmail'; }
}

export class SendSaeDeathNotificationEmail implements IReturn<SendSaeDeathNotificationEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;
    public medicalReviewDetails: string;

    public constructor(init?: Partial<SendSaeDeathNotificationEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendSaeDeathNotificationEmailResponse(); }
    public getTypeName() { return 'SendSaeDeathNotificationEmail'; }
}

export class SendUnapprovedSaeEmail implements IReturn<SendUnapprovedSaeEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;

    public constructor(init?: Partial<SendUnapprovedSaeEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendUnapprovedSaeEmailResponse(); }
    public getTypeName() { return 'SendUnapprovedSaeEmail'; }
}

export class SendUnresolvedSaeEmail implements IReturn<SendUnresolvedSaeEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;

    public constructor(init?: Partial<SendUnresolvedSaeEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendUnresolvedSaeEmailResponse(); }
    public getTypeName() { return 'SendUnresolvedSaeEmail'; }
}

export class SendIncompleteSaesEmail implements IReturn<SendIncompleteSaesEmailResponse>
{

    public constructor(init?: Partial<SendIncompleteSaesEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendIncompleteSaesEmailResponse(); }
    public getTypeName() { return 'SendIncompleteSaesEmail'; }
}

export class SendPendingSaeMedicalReviewEmail implements IReturn<SendPendingSaeMedicalReviewEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;

    public constructor(init?: Partial<SendPendingSaeMedicalReviewEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendPendingSaeMedicalReviewEmailResponse(); }
    public getTypeName() { return 'SendPendingSaeMedicalReviewEmail'; }
}

export class SendDrugShipmentQuarantinedEmail implements IReturn<SendDrugShipmentQuarantinedEmailResponse>
{
    public drugShipmentId: number;

    public constructor(init?: Partial<SendDrugShipmentQuarantinedEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendDrugShipmentQuarantinedEmailResponse(); }
    public getTypeName() { return 'SendDrugShipmentQuarantinedEmail'; }
}

export class MarkPatientsOffTreatment implements IReturn<MarkPatientsOffTreatmentResponse>, IPost
{

    public constructor(init?: Partial<MarkPatientsOffTreatment>) { (Object as any).assign(this, init); }
    public createResponse() { return new MarkPatientsOffTreatmentResponse(); }
    public getTypeName() { return 'MarkPatientsOffTreatment'; }
}

// @Route("/{PatientId}/forms-due-schedule", "GET")
export class GetFormsDueSchedule implements IHasPatientId
{
    public patientId?: number;

    public constructor(init?: Partial<GetFormsDueSchedule>) { (Object as any).assign(this, init); }
}

// @Route("/{CountryCode}/{InstitutionCode}/enrollment-status-report", "GET")
export class GetEnrollmentStatusReport
{
    public countryCode: string;
    public institutionCode: string;

    public constructor(init?: Partial<GetEnrollmentStatusReport>) { (Object as any).assign(this, init); }
}

export class SendDataCleaningReportsEmail implements IReturn<SendDataCleaningReportsEmailResponse>
{

    public constructor(init?: Partial<SendDataCleaningReportsEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendDataCleaningReportsEmailResponse(); }
    public getTypeName() { return 'SendDataCleaningReportsEmail'; }
}

export class SendErrorEmail implements IReturn<SendErrorEmailResponse>
{
    public error: Error;
    public errorEnvironment: string;

    public constructor(init?: Partial<SendErrorEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendErrorEmailResponse(); }
    public getTypeName() { return 'SendErrorEmail'; }
}

export class GetEnumerationTypes implements IReturn<GetEnumerationTypesResponse>
{

    public constructor(init?: Partial<GetEnumerationTypes>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetEnumerationTypesResponse(); }
    public getTypeName() { return 'GetEnumerationTypes'; }
}

export class GetInstitutionPersonnel implements IReturn<InstitutionPersonnelResponse>, IGet
{
    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetInstitutionPersonnel>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionPersonnelResponse(); }
    public getTypeName() { return 'GetInstitutionPersonnel'; }
}

export class QueueMultipleRandomisationEmail implements IReturn<QueueMultipleRandomisationEmailsResponse>
{
    // @Validate(Validator="NotEmpty")
    public checkDate: string;

    public constructor(init?: Partial<QueueMultipleRandomisationEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new QueueMultipleRandomisationEmailsResponse(); }
    public getTypeName() { return 'QueueMultipleRandomisationEmail'; }
}

export class SendMultipleRandomisationEmail implements IReturn<SendMultipleRandomisationEmailResponse>
{
    public instName: string;
    public randomisationEmailData: MultipleRandomisationEmailData[];

    public constructor(init?: Partial<SendMultipleRandomisationEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendMultipleRandomisationEmailResponse(); }
    public getTypeName() { return 'SendMultipleRandomisationEmail'; }
}

export class SendScreeningFailEmail implements IReturn<SendScreeningFailEmailResponse>
{
    public instName: string;
    public instCode: string;
    public participantId: string;
    public reason: string;

    public constructor(init?: Partial<SendScreeningFailEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendScreeningFailEmailResponse(); }
    public getTypeName() { return 'SendScreeningFailEmail'; }
}

export class SendInvalidSaeEmail implements IReturn<SendInvalidSaeEmailResponse>
{
    public patientStudyNumber: string;
    public saeNumber: number;

    public constructor(init?: Partial<SendInvalidSaeEmail>) { (Object as any).assign(this, init); }
    public createResponse() { return new SendInvalidSaeEmailResponse(); }
    public getTypeName() { return 'SendInvalidSaeEmail'; }
}

export class MarkAsIneligiblePatient implements IReturn<MarkAsIneligiblePatientResponse>
{
    public id?: number;
    public status: number;
    public statusReason: string;
    public ineligibleDate: string;

    public constructor(init?: Partial<MarkAsIneligiblePatient>) { (Object as any).assign(this, init); }
    public createResponse() { return new MarkAsIneligiblePatientResponse(); }
    public getTypeName() { return 'MarkAsIneligiblePatient'; }
}

// @Route("/api/reports/forms-due-summary", "GET,POST")
export class GetFormsDueSummaryReportData implements IReturn<FormsDueSummaryReportDataResponse>, IReportRequest
{
    public token: string;
    public randNo: string;
    public institutionCode: string;
    public cutOffDate?: string;

    public constructor(init?: Partial<GetFormsDueSummaryReportData>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormsDueSummaryReportDataResponse(); }
    public getTypeName() { return 'GetFormsDueSummaryReportData'; }
}

// @Route("/api/reports/forms-due-schedule", "GET,POST")
export class GetFormsDueScheduleData implements IReturn<GetFormsDueScheduleDataResponse>, IReportRequest
{
    public token: string;
    public studyNumber: string;

    public constructor(init?: Partial<GetFormsDueScheduleData>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormsDueScheduleDataResponse(); }
    public getTypeName() { return 'GetFormsDueScheduleData'; }
}

// @Route("/api/reports/drug-shipment", "GET,POST")
export class GetDrugShipmentReportData implements IReturn<GetDrugShipmentReportDataResponse>, IReportRequest
{
    public token: string;
    public institutionCode: string;

    public constructor(init?: Partial<GetDrugShipmentReportData>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentReportDataResponse(); }
    public getTypeName() { return 'GetDrugShipmentReportData'; }
}

// @Route("/api/reports/patient-action", "GET,POST")
export class GetPatientActionReportData implements IReturn<GetPatientActionReportDataResponse>, IReportRequest
{
    public token: string;
    public institutionCode: string;
    public startDate?: string;
    public stopDate?: string;

    public constructor(init?: Partial<GetPatientActionReportData>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientActionReportDataResponse(); }
    public getTypeName() { return 'GetPatientActionReportData'; }
}

// @Route("/api/reports/site-status", "GET,POST")
export class GetSitetStatusReport implements IReturn<GetSitetStatusReportResponse>, IReportRequest
{
    public token: string;

    public constructor(init?: Partial<GetSitetStatusReport>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSitetStatusReportResponse(); }
    public getTypeName() { return 'GetSitetStatusReport'; }
}

// @Route("/api/reports/drug-management-log", "GET,POST")
export class GetDrugManagementLogData implements IReturn<GetDrugManagementLogDataResponse>, IReportRequest
{
    public token: string;
    public institutionCode: string;

    public constructor(init?: Partial<GetDrugManagementLogData>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugManagementLogDataResponse(); }
    public getTypeName() { return 'GetDrugManagementLogData'; }
}

// @Route("/get/tp-registration/", "GET")
// @Route("/get/tp-registration/{InstitutionId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetTpRegistrationByInstitutionId implements IReturn<GetTpRegistrationByInstitutionIdResponse>
{
    public institutionId?: number;

    public constructor(init?: Partial<GetTpRegistrationByInstitutionId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTpRegistrationByInstitutionIdResponse(); }
    public getTypeName() { return 'GetTpRegistrationByInstitutionId'; }
}

// @Route("/get/tp-drug-management/", "GET")
// @Route("/get/tp-drug-management/{InstitutionId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetTpDrugManagementByInstitutionId implements IReturn<GetTpDrugManagementByInstitutionIdResponse>
{
    public institutionId?: number;

    public constructor(init?: Partial<GetTpDrugManagementByInstitutionId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTpDrugManagementByInstitutionIdResponse(); }
    public getTypeName() { return 'GetTpDrugManagementByInstitutionId'; }
}

// @Route("/get/tp-sae/", "GET")
// @Route("/get/tp-sae/{InstitutionId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetTpSaeByInstitutionId implements IReturn<GetTpSaeByInstitutionIdResponse>
{
    public institutionId?: number;

    public constructor(init?: Partial<GetTpSaeByInstitutionId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTpSaeByInstitutionIdResponse(); }
    public getTypeName() { return 'GetTpSaeByInstitutionId'; }
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=16)
    public useTokenCookie?: boolean;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public scope: string;

    // @DataMember(Order=20)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public createResponse() { return new AuthenticateResponse(); }
    public getTypeName() { return 'Authenticate'; }
}

// @Route("/assignroles")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public createResponse() { return new AssignRolesResponse(); }
    public getTypeName() { return 'AssignRoles'; }
}

// @Route("/unassignroles")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public createResponse() { return new UnAssignRolesResponse(); }
    public getTypeName() { return 'UnAssignRoles'; }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetApiKeysResponse(); }
    public getTypeName() { return 'GetApiKeys'; }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public createResponse() { return new RegenerateApiKeysResponse(); }
    public getTypeName() { return 'RegenerateApiKeys'; }
}

// @Route("/api/batches", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatches implements IReturn<GetBatchesResponse>
{

    public constructor(init?: Partial<GetBatches>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetBatchesResponse(); }
    public getTypeName() { return 'GetBatches'; }
}

// @Route("/api/batch/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchById implements IReturn<GetBatchByIdResponse>
{
    /**
    * The id of the drug batch
    */
    // @ApiMember(DataType="int", Description="The id of the drug batch", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetBatchById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetBatchByIdResponse(); }
    public getTypeName() { return 'GetBatchById'; }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchesByIds implements IReturn<GetBatchesByIdsResponse>, IGet
{
    public ids: number[];

    public constructor(init?: Partial<GetBatchesByIds>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetBatchesByIdsResponse(); }
    public getTypeName() { return 'GetBatchesByIds'; }
}

// @Route("/api/batches/expiring-at-specified-date", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchesExpiringAtSpecifiedDate implements IReturn<GetBatchesExpiringAtSpecifiedDateResponse>, IGet
{
    /**
    * The date of expiry
    */
    // @ApiMember(DataType="DateTime", Description="The date of expiry", IsRequired=true, Name="ExpiryDate", ParameterType="query")
    public expiryDate: string;

    public constructor(init?: Partial<GetBatchesExpiringAtSpecifiedDate>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetBatchesExpiringAtSpecifiedDateResponse(); }
    public getTypeName() { return 'GetBatchesExpiringAtSpecifiedDate'; }
}

// @Route("/api/batch/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetBatch implements IReturn<SetBatchResponse>
{
    /**
    * The drug batch form data to save
    */
    // @ApiMember(DataType="BatchForm", Description="The drug batch form data to save", IsRequired=true, Name="BatchForm", ParameterType="body")
    public batch: Batch;

    public constructor(init?: Partial<SetBatch>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetBatchResponse(); }
    public getTypeName() { return 'SetBatch'; }
}

// @Route("/api/depot-batches", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatches implements IReturn<GetDepotBatchesResponse>
{

    public constructor(init?: Partial<GetDepotBatches>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotBatchesResponse(); }
    public getTypeName() { return 'GetDepotBatches'; }
}

// @Route("/api/depot-batch/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchById implements IReturn<GetDepotBatchByIdResponse>
{
    /**
    * The id of the depot batch
    */
    // @ApiMember(DataType="int", Description="The id of the depot batch", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDepotBatchById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotBatchByIdResponse(); }
    public getTypeName() { return 'GetDepotBatchById'; }
}

// @Route("/api/depot-batches/depotId/{DepotId}", "GET")
// @ApiResponse(Description="Depot Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByDepotId implements IReturn<GetDepotBatchesByDepotIdResponse>
{
    /**
    * The id of the depot
    */
    // @ApiMember(DataType="int", Description="The id of the depot", IsRequired=true, Name="DepotId", ParameterType="path")
    public depotId: number;

    public constructor(init?: Partial<GetDepotBatchesByDepotId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotBatchesByDepotIdResponse(); }
    public getTypeName() { return 'GetDepotBatchesByDepotId'; }
}

// @Route("/api/depot-batches/pharmacyId/{PharmacyId}", "GET")
// @ApiResponse(Description="Pharmacy Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByPharmacyId implements IReturn<GetDepotBatchesByPharmacyIdResponse>
{
    /**
    * The id of the pharmacy
    */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="PharmacyId", ParameterType="path")
    public pharmacyId: number;

    public constructor(init?: Partial<GetDepotBatchesByPharmacyId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotBatchesByPharmacyIdResponse(); }
    public getTypeName() { return 'GetDepotBatchesByPharmacyId'; }
}

// @Route("/api/depot-batches/drugShipmentId/{DrugShipmentId}", "GET")
// @ApiResponse(Description="Drug Shipment Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByDrugShipmentId implements IReturn<GetDepotBatchesByDrugShipmentIdResponse>
{
    /**
    * The id of the drug shipment
    */
    // @ApiMember(DataType="int", Description="The id of the drug shipment", IsRequired=true, Name="DrugShipmentId", ParameterType="path")
    public drugShipmentId: number;

    public constructor(init?: Partial<GetDepotBatchesByDrugShipmentId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotBatchesByDrugShipmentIdResponse(); }
    public getTypeName() { return 'GetDepotBatchesByDrugShipmentId'; }
}

// @Route("/api/depot-batches/institution/{InstCode}", "GET")
// @ApiResponse(Description="Institution code invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByInstitutionCode implements IReturn<GetDepotBatchesByPharmacyIdResponse>
{
    /**
    * The institution code
    */
    // @ApiMember(DataType="string", Description="The institution code", IsRequired=true, Name="InstCode", ParameterType="path")
    public instCode: string;

    public constructor(init?: Partial<GetDepotBatchesByInstitutionCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotBatchesByPharmacyIdResponse(); }
    public getTypeName() { return 'GetDepotBatchesByInstitutionCode'; }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByBatchIds implements IReturn<GetDepotBatchesByBatchIdsResponse>, IGet
{
    public batchIds: number[];

    public constructor(init?: Partial<GetDepotBatchesByBatchIds>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotBatchesByBatchIdsResponse(); }
    public getTypeName() { return 'GetDepotBatchesByBatchIds'; }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesWithLowStockByDepotIds implements IReturn<GetDepotBatchesWithLowStockByDepotIdsResponse>, IGet
{
    public depotIds: number[];
    public drugThreshold?: number;

    public constructor(init?: Partial<GetDepotBatchesWithLowStockByDepotIds>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotBatchesWithLowStockByDepotIdsResponse(); }
    public getTypeName() { return 'GetDepotBatchesWithLowStockByDepotIds'; }
}

// @Route("/api/depot-batch/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDepotBatch implements IReturn<SetDepotBatchResponse>
{
    /**
    * The depot batch form data to save
    */
    // @ApiMember(DataType="DepotBatch", Description="The depot batch form data to save", IsRequired=true, Name="DepotBatch", ParameterType="body")
    public depotBatch: DepotBatch;

    public constructor(init?: Partial<SetDepotBatch>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetDepotBatchResponse(); }
    public getTypeName() { return 'SetDepotBatch'; }
}

// @Route("/api/depots", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepots implements IReturn<GetDepotsResponse>, IGet
{

    public constructor(init?: Partial<GetDepots>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotsResponse(); }
    public getTypeName() { return 'GetDepots'; }
}

// @Route("/api/depot/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotById implements IReturn<GetDepotByIdResponse>, IGet
{
    /**
    * The id of the drug depot
    */
    // @ApiMember(DataType="int", Description="The id of the drug depot", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDepotById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotByIdResponse(); }
    public getTypeName() { return 'GetDepotById'; }
}

// @Route("/api/depots/by-drug-under-threshold", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotsByDrugUnderThreshold implements IReturn<GetDepotsByDrugUnderThresholdResponse>, IGet
{
    /**
    * The threshold to check
    */
    // @ApiMember(DataType="int", Description="The threshold to check", IsRequired=true, Name="DrugThreshold", ParameterType="query")
    public drugThreshold: number;

    public constructor(init?: Partial<GetDepotsByDrugUnderThreshold>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepotsByDrugUnderThresholdResponse(); }
    public getTypeName() { return 'GetDepotsByDrugUnderThreshold'; }
}

// @Route("/api/depot/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDepot implements IReturn<SetDepotResponse>
{
    /**
    * The drug depot form data to save
    */
    // @ApiMember(DataType="DepotForm", Description="The drug depot form data to save", IsRequired=true, Name="DepotForm", ParameterType="body")
    public depot: Depot;

    public constructor(init?: Partial<SetDepot>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetDepotResponse(); }
    public getTypeName() { return 'SetDepot'; }
}

// @Route("/api/drug-dispensations", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensations implements IReturn<GetDrugDispensationsResponse>, IGet
{

    public constructor(init?: Partial<GetDrugDispensations>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugDispensationsResponse(); }
    public getTypeName() { return 'GetDrugDispensations'; }
}

// @Route("/api/drug-dispensation/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensationById implements IReturn<GetDrugDispensationByIdResponse>, IGet
{
    /**
    * The id of the drug dispensation
    */
    // @ApiMember(DataType="int", Description="The id of the drug dispensation", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugDispensationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugDispensationByIdResponse(); }
    public getTypeName() { return 'GetDrugDispensationById'; }
}

// @Route("/api/drug-dispensations/patient-id/{PatientId}", "GET")
// @ApiResponse(Description="Patient id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensationByPatientId implements IReturn<GetDrugDispensationByPatientIdResponse>, IGet
{
    /**
    * The id of the patient to retrieve drug dispensations for
    */
    // @ApiMember(DataType="int", Description="The id of the patient to retrieve drug dispensations for", IsRequired=true, Name="PatientId", ParameterType="path")
    public patientId: number;

    public constructor(init?: Partial<GetDrugDispensationByPatientId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugDispensationByPatientIdResponse(); }
    public getTypeName() { return 'GetDrugDispensationByPatientId'; }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPatientsWithLateDispensations implements IReturn<GetPatientsWithLateDispensationsResponse>, IGet
{
    public expectedDate?: string;

    public constructor(init?: Partial<GetPatientsWithLateDispensations>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientsWithLateDispensationsResponse(); }
    public getTypeName() { return 'GetPatientsWithLateDispensations'; }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLastDispensationForPatientId implements IReturn<GetLastDispensationForPatientIdResponse>, IGet
{
    public patientId?: number;

    public constructor(init?: Partial<GetLastDispensationForPatientId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetLastDispensationForPatientIdResponse(); }
    public getTypeName() { return 'GetLastDispensationForPatientId'; }
}

// @Route("/api/drug-dispensation/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugDispensation implements IReturn<SetDrugDispensationResponse>, IPost
{
    /**
    * The patient dispensation form data to save
    */
    // @ApiMember(DataType="DrugDispensation", Description="The patient dispensation form data to save", IsRequired=true, Name="DrugDispensation", ParameterType="body")
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<SetDrugDispensation>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetDrugDispensationResponse(); }
    public getTypeName() { return 'SetDrugDispensation'; }
}

// @Route("/api/drugs", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugs implements IReturn<GetDrugsResponse>
{

    public constructor(init?: Partial<GetDrugs>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugsResponse(); }
    public getTypeName() { return 'GetDrugs'; }
}

// @Route("/api/drug/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugById implements IReturn<GetDrugByIdResponse>, IGet
{
    /**
    * The id of the drug
    */
    // @ApiMember(DataType="int", Description="The id of the drug", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugByIdResponse(); }
    public getTypeName() { return 'GetDrugById'; }
}

// @Route("/api/drug/timepoint/{TimepointId}/treatment/{TreatmentId}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugsByTimepointAndTreatment implements IReturn<GetDrugsByTimepointAndTreatmentResponse>
{
    /**
    * The timepoint id to get drugs for
    */
    // @ApiMember(DataType="int", Description="The timepoint id to get drugs for", IsRequired=true, Name="TimepointId", ParameterType="path")
    public timepointId: number;

    /**
    * The treatment id to get drugs for
    */
    // @ApiMember(DataType="int", Description="The treatment id to get drugs for", IsRequired=true, Name="TreatmentId", ParameterType="path")
    public treatmentId: number;

    public constructor(init?: Partial<GetDrugsByTimepointAndTreatment>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugsByTimepointAndTreatmentResponse(); }
    public getTypeName() { return 'GetDrugsByTimepointAndTreatment'; }
}

// @Route("/api/drug-shipment-depot-batches", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatches implements IReturn<GetDrugShipmentDepotBatchesResponse>
{

    public constructor(init?: Partial<GetDrugShipmentDepotBatches>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentDepotBatchesResponse(); }
    public getTypeName() { return 'GetDrugShipmentDepotBatches'; }
}

// @Route("/api/drug-shipment-depot-batch/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatchById implements IReturn<GetDrugShipmentDepotBatchByIdResponse>
{
    /**
    * The id of the drug shipment depot batch
    */
    // @ApiMember(DataType="int", Description="The id of the drug shipment depot batch", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentDepotBatchByIdResponse(); }
    public getTypeName() { return 'GetDrugShipmentDepotBatchById'; }
}

// @Route("/api/drug-shipment-depot-batches/pharmacyId/{PharmacyId}", "GET")
// @ApiResponse(Description="Pharmacy Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatchesByPharmacyId implements IReturn<GetDrugShipmentDepotBatchesByPharmacyIdResponse>
{
    /**
    * The id of the pharmacy
    */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="PharmacyId", ParameterType="path")
    public pharmacyId: number;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesByPharmacyId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentDepotBatchesByPharmacyIdResponse(); }
    public getTypeName() { return 'GetDrugShipmentDepotBatchesByPharmacyId'; }
}

// @Route("/api/drug-shipment-depot-batches/institution/{InstCode}", "GET")
// @ApiResponse(Description="Institution code invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatchesByInstitutionCode implements IReturn<GetDrugShipmentDepotBatchesByPharmacyIdResponse>
{
    /**
    * The institution code
    */
    // @ApiMember(DataType="string", Description="The institution code", IsRequired=true, Name="InstCode", ParameterType="path")
    public instCode: string;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesByInstitutionCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentDepotBatchesByPharmacyIdResponse(); }
    public getTypeName() { return 'GetDrugShipmentDepotBatchesByInstitutionCode'; }
}

// @Route("/api/drug-shipment-depot-batch/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipmentDepotBatch implements IReturn<SetDrugShipmentDepotBatchResponse>
{
    /**
    * The drug shipment depot batch form data to save
    */
    // @ApiMember(DataType="DrugShipmentDepotBatch", Description="The drug shipment depot batch form data to save", IsRequired=true, Name="DrugShipmentDepotBatch", ParameterType="body")
    public drugShipmentDepotBatch: DrugShipmentDepotBatch;

    public constructor(init?: Partial<SetDrugShipmentDepotBatch>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetDrugShipmentDepotBatchResponse(); }
    public getTypeName() { return 'SetDrugShipmentDepotBatch'; }
}

// @Route("/api/drug-shipment-generation/queue", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class StartDrugShipmentGeneration implements IReturn<StartDrugShipmentGenerationResponse>
{
    public scheduled?: boolean;
    public cutOffDate?: string;
    public pharmacyId?: number;

    public constructor(init?: Partial<StartDrugShipmentGeneration>) { (Object as any).assign(this, init); }
    public createResponse() { return new StartDrugShipmentGenerationResponse(); }
    public getTypeName() { return 'StartDrugShipmentGeneration'; }
}

// @Route("/api/drug-shipment-generation/create-from-patient", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateDrugShipmentFromPatient implements IReturn<CreateDrugShipmentFromPatientResponse>, IPost
{
    /**
    * The id of the patient
    */
    // @ApiMember(DataType="int", Description="The id of the patient", IsRequired=true, Name="PatientId", ParameterType="body")
    public patientId: number;

    /**
    * The drugs to order for the patient
    */
    // @ApiMember(DataType="model", Description="The drugs to order for the patient", IsRequired=true, Name="Drugs", ParameterType="body")
    public drugs: DrugAmount[];

    public constructor(init?: Partial<CreateDrugShipmentFromPatient>) { (Object as any).assign(this, init); }
    public createResponse() { return new CreateDrugShipmentFromPatientResponse(); }
    public getTypeName() { return 'CreateDrugShipmentFromPatient'; }
}

// @Route("/api/drug-shipments", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipments implements IReturn<GetDrugShipmentsResponse>, IGet
{

    public constructor(init?: Partial<GetDrugShipments>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentsResponse(); }
    public getTypeName() { return 'GetDrugShipments'; }
}

// @Route("/api/drug-shipments/institution/{InstitutionCode}", "GET")
// @ApiResponse(Description="Institution code invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsByInstitution implements IReturn<GetDrugShipmentsByInstitutionResponse>, IGet
{
    /**
    * The institution of the pharmacies
    */
    // @ApiMember(DataType="string", Description="The institution of the pharmacies", IsRequired=true, Name="InstitutionCode", ParameterType="path")
    public institutionCode: string;

    public constructor(init?: Partial<GetDrugShipmentsByInstitution>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentsByInstitutionResponse(); }
    public getTypeName() { return 'GetDrugShipmentsByInstitution'; }
}

// @Route("/api/drug-shipment/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentById implements IReturn<GetDrugShipmentByIdResponse>, IGet
{
    /**
    * The id of the drug shipment
    */
    // @ApiMember(DataType="int", Description="The id of the drug shipment", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugShipmentById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentByIdResponse(); }
    public getTypeName() { return 'GetDrugShipmentById'; }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsByIds implements IReturn<GetDrugShipmentsByIdsResponse>, IGet
{
    public ids: number[];

    public constructor(init?: Partial<GetDrugShipmentsByIds>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentsByIdsResponse(); }
    public getTypeName() { return 'GetDrugShipmentsByIds'; }
}

// @Route("/api/drug-shipment/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipment implements IReturn<SetDrugShipmentResponse>, IPost
{
    /**
    * The drug shipment form data to save
    */
    // @ApiMember(DataType="DrugShipmentForm", Description="The drug shipment form data to save", IsRequired=true, Name="DrugShipmentForm", ParameterType="body")
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipment>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetDrugShipmentResponse(); }
    public getTypeName() { return 'SetDrugShipment'; }
}

// @Route("/api/drug-shipment/set-status", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipmentStatus implements IReturn<SetDrugShipmentStatusResponse>, IPost
{
    /**
    * The drug shipment form data to save
    */
    // @ApiMember(DataType="DrugShipmentForm", Description="The drug shipment form data to save", IsRequired=true, Name="DrugShipmentForm", ParameterType="body")
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipmentStatus>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetDrugShipmentStatusResponse(); }
    public getTypeName() { return 'SetDrugShipmentStatus'; }
}

// @Route("/api/drug-shipment/delete", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteDrugShipment implements IReturn<DeleteDrugShipmentResponse>, IPost
{
    /**
    * The drug shipment id to delete
    */
    // @ApiMember(DataType="int", Description="The drug shipment id to delete", IsRequired=true, Name="DrugShipmentId", ParameterType="body")
    public drugShipmentId: number;

    public constructor(init?: Partial<DeleteDrugShipment>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteDrugShipmentResponse(); }
    public getTypeName() { return 'DeleteDrugShipment'; }
}

// @Route("/api/drug-shipment/verify", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipmentVerify implements IReturn<SetDrugShipmentVerifyResponse>, IPost
{
    /**
    * The drug shipment form data to verify
    */
    // @ApiMember(DataType="model", Description="The drug shipment form data to verify", IsRequired=true, Name="DrugShipmentVerify", ParameterType="body")
    public drugShipmentVerify: DrugShipmentVerify;

    public constructor(init?: Partial<SetDrugShipmentVerify>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetDrugShipmentVerifyResponse(); }
    public getTypeName() { return 'SetDrugShipmentVerify'; }
}

// @Route("/api/drug-shipments/not-ordered-by-expected-date", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsNotOrderedByExpectedDate implements IReturn<GetDrugShipmentsNotOrderedByExpectedDateResponse>, IGet
{
    /**
    * The date to check from
    */
    // @ApiMember(DataType="DateTime", Description="The date to check from", IsRequired=true, Name="ExpectedShippingDate", ParameterType="query")
    public expectedShippingDate: string;

    public constructor(init?: Partial<GetDrugShipmentsNotOrderedByExpectedDate>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentsNotOrderedByExpectedDateResponse(); }
    public getTypeName() { return 'GetDrugShipmentsNotOrderedByExpectedDate'; }
}

// @Route("/api/drug-shipments/not-shipped-by-expected-date", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsNotShippedByExpectedDate implements IReturn<GetDrugShipmentsNotShippedByExpectedDateResponse>, IGet
{
    /**
    * The date to check from
    */
    // @ApiMember(DataType="DateTime", Description="The date to check from", IsRequired=true, Name="ExpectedShippingDate", ParameterType="query")
    public expectedShippingDate: string;

    public constructor(init?: Partial<GetDrugShipmentsNotShippedByExpectedDate>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentsNotShippedByExpectedDateResponse(); }
    public getTypeName() { return 'GetDrugShipmentsNotShippedByExpectedDate'; }
}

// @Route("/api/drug-shipments/not-received-by-expected-date", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsNotReceivedByExpectedDate implements IReturn<GetDrugShipmentsNotReceivedByExpectedDateResponse>, IGet
{
    /**
    * The date to check from
    */
    // @ApiMember(DataType="DateTime", Description="The date to check from", IsRequired=true, Name="ExpectedReceptionDate", ParameterType="query")
    public expectedReceptionDate: string;

    public constructor(init?: Partial<GetDrugShipmentsNotReceivedByExpectedDate>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDrugShipmentsNotReceivedByExpectedDateResponse(); }
    public getTypeName() { return 'GetDrugShipmentsNotReceivedByExpectedDate'; }
}

// @Route("/api/order-forms", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetOrderForms implements IReturn<GetOrderFormsResponse>
{

    public constructor(init?: Partial<GetOrderForms>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetOrderFormsResponse(); }
    public getTypeName() { return 'GetOrderForms'; }
}

// @Route("/api/patient-drugs", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPatientDrugs implements IReturn<GetPatientDrugsResponse>, IGet
{

    public constructor(init?: Partial<GetPatientDrugs>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientDrugsResponse(); }
    public getTypeName() { return 'GetPatientDrugs'; }
}

// @Route("/api/patient-drugs/patient-id/{PatientId}", "GET")
// @ApiResponse(Description="Patient id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPatientDrugsByPatientId implements IReturn<GetPatientDrugsByPatientIdResponse>, IGet
{
    /**
    * The id of the patient to retrieve patient drugs for
    */
    // @ApiMember(DataType="int", Description="The id of the patient to retrieve patient drugs for", IsRequired=true, Name="PatientId", ParameterType="path")
    public patientId: number;

    public constructor(init?: Partial<GetPatientDrugsByPatientId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientDrugsByPatientIdResponse(); }
    public getTypeName() { return 'GetPatientDrugsByPatientId'; }
}

// @Route("/api/patient-drugs/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetPatientDrugs implements IReturn<SetPatientDrugsResponse>, IPost
{
    /**
    * The patient drug form data to save
    */
    // @ApiMember(DataType="model", Description="The patient drug form data to save", IsRequired=true, Name="PatientDrugs", ParameterType="body")
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<SetPatientDrugs>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetPatientDrugsResponse(); }
    public getTypeName() { return 'SetPatientDrugs'; }
}

// @Route("/api/pharmacies", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacies implements IReturn<GetPharmaciesResponse>, IGet
{

    public constructor(init?: Partial<GetPharmacies>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPharmaciesResponse(); }
    public getTypeName() { return 'GetPharmacies'; }
}

// @Route("/api/pharmacy/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyById implements IReturn<GetPharmacyByIdResponse>, IGet
{
    /**
    * The id of the pharmacy
    */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetPharmacyById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPharmacyByIdResponse(); }
    public getTypeName() { return 'GetPharmacyById'; }
}

// @Route("/api/pharmacy/institution/{InstitutionCode}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyByInstitutionCode implements IReturn<GetPharmacyByInstitutionCodeResponse>, IGet
{
    /**
    * The institution code of the pharmacy
    */
    // @ApiMember(DataType="string", Description="The institution code of the pharmacy", IsRequired=true, Name="InstitutionCode", ParameterType="path")
    public institutionCode: string;

    public constructor(init?: Partial<GetPharmacyByInstitutionCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPharmacyByInstitutionCodeResponse(); }
    public getTypeName() { return 'GetPharmacyByInstitutionCode'; }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyBatchesDrugRemainingByBatchIds implements IReturn<GetPharmacyBatchesDrugRemainingByBatchIdsResponse>, IGet
{
    public batchIds: number[];

    public constructor(init?: Partial<GetPharmacyBatchesDrugRemainingByBatchIds>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPharmacyBatchesDrugRemainingByBatchIdsResponse(); }
    public getTypeName() { return 'GetPharmacyBatchesDrugRemainingByBatchIds'; }
}

// @Route("/api/pharmacy/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetPharmacy implements IReturn<SetPharmacyResponse>, IPost
{
    /**
    * The pharmacy form data to save
    */
    // @ApiMember(DataType="model", Description="The pharmacy form data to save", IsRequired=true, Name="PharmacyForm", ParameterType="body")
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<SetPharmacy>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetPharmacyResponse(); }
    public getTypeName() { return 'SetPharmacy'; }
}

// @Route("/api/pharmacy/quarantine-stock", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class QuarantinePharmacyStock implements IReturn<QuarantinePharmacyStockResponse>, IPost
{
    /**
    * The pharmacy id to quarantine
    */
    // @ApiMember(DataType="integer", Description="The pharmacy id to quarantine", IsRequired=true, Name="Id", ParameterType="body")
    public id: number;

    public constructor(init?: Partial<QuarantinePharmacyStock>) { (Object as any).assign(this, init); }
    public createResponse() { return new QuarantinePharmacyStockResponse(); }
    public getTypeName() { return 'QuarantinePharmacyStock'; }
}

// @Route("/api/pharmacy/action-quarantined-stock", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ActionQuarantinedStock implements IReturn<ActionQuarantinedStockResponse>, IPost
{
    /**
    * The pharmacy id to quarantine
    */
    // @ApiMember(DataType="integer", Description="The pharmacy id to quarantine", IsRequired=true, Name="Id", ParameterType="body")
    public id: number;

    /**
    * The action to take on the pharmacy's stock
    */
    // @ApiMember(DataType="integer", Description="The action to take on the pharmacy's stock", IsRequired=true, Name="QuarantinedStockAction", ParameterType="body")
    public quarantinedStockAction: QuarantinedStockAction;

    public constructor(init?: Partial<ActionQuarantinedStock>) { (Object as any).assign(this, init); }
    public createResponse() { return new ActionQuarantinedStockResponse(); }
    public getTypeName() { return 'ActionQuarantinedStock'; }
}

// @Route("/api/pharmacy/by-drug-under-threshold", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmaciesByDrugUnderThreshold implements IReturn<GetPharmaciesByDrugUnderThresholdResponse>, IGet
{
    /**
    * The threshold to check
    */
    // @ApiMember(DataType="int", Description="The threshold to check", IsRequired=true, Name="DrugThreshold", ParameterType="query")
    public drugThreshold: number;

    public constructor(init?: Partial<GetPharmaciesByDrugUnderThreshold>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPharmaciesByDrugUnderThresholdResponse(); }
    public getTypeName() { return 'GetPharmaciesByDrugUnderThreshold'; }
}

// @Route("/api/timepoints", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTimepoints implements IReturn<GetTimepointsResponse>
{

    public constructor(init?: Partial<GetTimepoints>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTimepointsResponse(); }
    public getTypeName() { return 'GetTimepoints'; }
}

// @Route("/api/timepoints/treatment/{TreatmentId}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTimepointsByTreatmentId implements IReturn<GetTimepointsResponse>
{
    /**
    * The treatment id to get timepoints for
    */
    // @ApiMember(DataType="int", Description="The treatment id to get timepoints for", IsRequired=true, Name="TreatmentId", ParameterType="path")
    public treatmentId: number;

    public constructor(init?: Partial<GetTimepointsByTreatmentId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTimepointsResponse(); }
    public getTypeName() { return 'GetTimepointsByTreatmentId'; }
}

/**
* Sae
*/
// @Route("/api/sae/collection", "GET")
// @Api(Description="Sae")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=500)
// @DataContract
export class SaeGetCollection implements IReturn<SaeCollectionResponse>, ISaeGetCollection
{

    public constructor(init?: Partial<SaeGetCollection>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaeCollectionResponse(); }
    public getTypeName() { return 'SaeGetCollection'; }
}

/**
* Sae
*/
// @Route("/api/sae/collection/institution/{InstitutionCode}", "GET")
// @Api(Description="Sae")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=500)
// @DataContract
export class SaeGetCollectionByInstitutionCode implements IReturn<SaeCollectionResponse>, ISaeGetCollectionByInstitutionCode
{
    /**
    * The code of the Institution associated with the sae to retrieve.
    */
    // @DataMember(Order=1)
    public institutionCode: string;

    public constructor(init?: Partial<SaeGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaeCollectionResponse(); }
    public getTypeName() { return 'SaeGetCollectionByInstitutionCode'; }
}

/**
* Sae
*/
// @Route("/api/sae/single/patient-study-number/{PatientStudyNumber}/sae-number/{SaeNumber}", "GET")
// @Api(Description="Sae")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Sae.Sae.SaeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Sae.Sae.SaeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Sae.Sae.SaeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Sae.Sae.SaeSingleResponse)", StatusCode=500)
// @DataContract
export class SaeGetSingleByPatientStudyNumber implements IReturn<SaeSingleResponse>, ISaeGetSingleByPatientStudyNumber
{
    /**
    * The study number of the Patient associated with the sae to retrieve.
    */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /**
    * The sae number of the Sae associated with the sae to retrieve.
    */
    // @DataMember(Order=2)
    public saeNumber: number;

    public constructor(init?: Partial<SaeGetSingleByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaeSingleResponse(); }
    public getTypeName() { return 'SaeGetSingleByPatientStudyNumber'; }
}

// @Route("/api/sae/collection/status", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeGetCollectionByStatus implements IReturn<SaeGetCollectionByStatusResponse>
{
    /**
    * The status of the saes
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The status of the saes", IsRequired=true, Name="Status", ParameterType="body")
    public status: SaeStatus;

    public constructor(init?: Partial<SaeGetCollectionByStatus>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaeGetCollectionByStatusResponse(); }
    public getTypeName() { return 'SaeGetCollectionByStatus'; }
}

// @Route("/api/sae/webaction", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeWebActionSave implements IReturn<SaeWebActionSaveResponse>
{
    /**
    * The sae web action
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The sae web action", IsRequired=true, Name="WebAction", ParameterType="model")
    public webAction: WebAction;

    public constructor(init?: Partial<SaeWebActionSave>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaeWebActionSaveResponse(); }
    public getTypeName() { return 'SaeWebActionSave'; }
}

// @Route("/api/sae/send-notification", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeSendNotification implements IReturn<SaeSendNotificationResponse>
{
    /**
    * The patient study number of the sae
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The patient study number of the sae", IsRequired=true, Name="PatientStudyNumber", ParameterType="body")
    public patientStudyNumber: string;

    /**
    * The sae number of the sae
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The sae number of the sae", IsRequired=true, Name="SaeNumber", ParameterType="body")
    public saeNumber: number;

    /**
    * The notification form
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="SaeNotificationForm", Description="The notification form", IsRequired=true, Name="NotificationForm", ParameterType="body")
    public notificationForm: SaeNotificationForm;

    public constructor(init?: Partial<SaeSendNotification>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaeSendNotificationResponse(); }
    public getTypeName() { return 'SaeSendNotification'; }
}

// @Route("/api/sae/open-clinica/document", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeGetOpenClinicaDocument implements IReturn<Blob>, IGet
{
    /**
    * The file name of the document in openclinica
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The file name of the document in openclinica", IsRequired=true, Name="FileName", ParameterType="body")
    public fileName: string;

    public constructor(init?: Partial<SaeGetOpenClinicaDocument>) { (Object as any).assign(this, init); }
    public createResponse() { return new Blob(); }
    public getTypeName() { return 'SaeGetOpenClinicaDocument'; }
}

// @Route("/api/sae/invalid-sae-file/download/{Id}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class DownloadInvalidSaeFile implements IReturn<Blob>, IGet
{
    /**
    * The id of the invalid sae file
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The id of the invalid sae file", IsRequired=true, Name="Id", ParameterType="body")
    public id: number;

    public constructor(init?: Partial<DownloadInvalidSaeFile>) { (Object as any).assign(this, init); }
    public createResponse() { return new Blob(); }
    public getTypeName() { return 'DownloadInvalidSaeFile'; }
}

// @Route("/api/sae/invalid-sae-file/view/{Id}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class GetInvalidSaeFile implements IReturn<Blob>, IGet
{
    /**
    * The id of the invalid sae file
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The id of the invalid sae file", IsRequired=true, Name="Id", ParameterType="body")
    public id: number;

    public constructor(init?: Partial<GetInvalidSaeFile>) { (Object as any).assign(this, init); }
    public createResponse() { return new Blob(); }
    public getTypeName() { return 'GetInvalidSaeFile'; }
}

// @Route("/api/sae/invalid-sae-form/save", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaveInvalidSaeForm implements IReturn<SaveInvalidSaeFormResponse>, IPost
{
    /**
    * The invalid sae form to save
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="model", Description="The invalid sae form to save", IsRequired=true, Name="InvalidSaeForm", ParameterType="body")
    public invalidSaeForm: InvalidSaeForm;

    public constructor(init?: Partial<SaveInvalidSaeForm>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveInvalidSaeFormResponse(); }
    public getTypeName() { return 'SaveInvalidSaeForm'; }
}

// @Route("/api/sae/invalid-sae-form/validate", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class ValidateInvalidSaeForm implements IReturn<ValidateInvalidSaeFormResponse>, IPost
{
    /**
    * The invalid sae form to validate
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="model", Description="The invalid sae form to validate", IsRequired=true, Name="InvalidSaeForm", ParameterType="body")
    public invalidSaeForm: InvalidSaeForm;

    public constructor(init?: Partial<ValidateInvalidSaeForm>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateInvalidSaeFormResponse(); }
    public getTypeName() { return 'ValidateInvalidSaeForm'; }
}

export class SaeMedicalReviewSingleByPatientStudyNumber implements IReturn<SaeMedicalReviewSingleResponse>, ISaeMedicalReviewGetSingleByPatientStudyNumber
{
    public patientStudyNumber: string;
    public saeNumber?: number;

    public constructor(init?: Partial<SaeMedicalReviewSingleByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaeMedicalReviewSingleResponse(); }
    public getTypeName() { return 'SaeMedicalReviewSingleByPatientStudyNumber'; }
}

// @Route("/api/sae/medicalreview/save-narrative-summary", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeMedicalReviewNarrativeSummaryPostSave implements IReturn<SaeMedicalReviewNarrativeSummaryPostSaveResponse>
{
    /**
    * The medical review id of the narrative to save
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The medical review id of the narrative to save", IsRequired=true, Name="MedicalReviewId", ParameterType="body")
    public medicalReviewId: number;

    /**
    * The narrative to save
    */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The narrative to save", IsRequired=true, Name="NarrativeSummary", ParameterType="body")
    public narrativeSummary: string;

    public constructor(init?: Partial<SaeMedicalReviewNarrativeSummaryPostSave>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaeMedicalReviewNarrativeSummaryPostSaveResponse(); }
    public getTypeName() { return 'SaeMedicalReviewNarrativeSummaryPostSave'; }
}

export class SaeMedicalReviewPostSave implements IReturn<SaeMedicalReviewSingleResponse>, ISaeMedicalReviewPostSave
{
    public saeMedicalReview: SaeMedicalReview;

    public constructor(init?: Partial<SaeMedicalReviewPostSave>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaeMedicalReviewSingleResponse(); }
    public getTypeName() { return 'SaeMedicalReviewPostSave'; }
}

/**
* Event (Event)
*/
// @Route("/opms/event/create/{PatientId}/{InstitutionId}/{EventTypeId}/{EventRepeat}", "GET")
// @Route("/opms/event/create/{PatientId}/{InstitutionId}/{EventTypeId}", "GET")
// @Api(Description="Event (Event)")
export class EventCreateSingleByContext implements IReturn<EventSingleResponse>, IEventGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;

    public constructor(init?: Partial<EventCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventSingleResponse(); }
    public getTypeName() { return 'EventCreateSingleByContext'; }
}

/**
* Event (Event)
*/
// @Route("/opms/event/{Id}", "GET")
// @Api(Description="Event (Event)")
// @ApiResponse(Description="Event (Event) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event (Event) Get Single By ID: Event Id was not provided.", StatusCode=400)
export class EventGetSingleById implements IReturn<EventSingleResponse>, IEventGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<EventGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventSingleResponse(); }
    public getTypeName() { return 'EventGetSingleById'; }
}

/**
* Event (Event)
*/
// @Route("/opms/event/{PatientId}/{InstitutionId}/{EventTypeId}/{EventRepeat}", "GET")
// @Route("/opms/event/{PatientId}/{InstitutionId}/{EventTypeId}", "GET")
// @Api(Description="Event (Event)")
export class EventGetSingleByContext implements IReturn<EventSingleResponse>, IEventGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<EventGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventSingleResponse(); }
    public getTypeName() { return 'EventGetSingleByContext'; }
}

/**
* Event (Event)
*/
// @Route("/opms/event/{PatientId}/{InstitutionId}/{EventTypeId}", "GET")
// @Route("/opms/event/{PatientId}/{InstitutionId}", "GET")
// @Api(Description="Event (Event)")
export class EventGetCollectionByContext implements IReturn<EventCollectionResponse>, IEventGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventTypeId?: number;

    public constructor(init?: Partial<EventGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventCollectionResponse(); }
    public getTypeName() { return 'EventGetCollectionByContext'; }
}

/**
* Event (Event)
*/
// @Route("/opms/event/{PatientId}/{InstitutionId}/{EventTypeId}/{EventRepeat}", "POST")
// @Route("/opms/event/{PatientId}/{InstitutionId}/{EventTypeId}", "POST")
// @Api(Description="Event (Event)")
// @ApiResponse(Description="Event (Event) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event (Event) Post Insert: Event was not provided.", StatusCode=400)
export class EventPostInsert implements IReturn<EventSingleResponse>, IPost
{
    public event: Event;
    public patientId?: number;
    public institutionId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;

    public constructor(init?: Partial<EventPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventSingleResponse(); }
    public getTypeName() { return 'EventPostInsert'; }
}

/**
* Event (Event)
*/
// @Route("/opms/event/{Id}", "PUT")
// @Api(Description="Event (Event)")
// @ApiResponse(Description="Event (Event) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event (Event) Put Update: Event ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Event (Event) Put Update: Event was not provided.", StatusCode=400)
// @ApiResponse(Description="Event (Event) Put Update: Event ID does not match location.", StatusCode=400)
export class EventPutUpdate implements IReturn<EventSingleResponse>, IPut
{
    public id?: number;
    public event: Event;

    public constructor(init?: Partial<EventPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventSingleResponse(); }
    public getTypeName() { return 'EventPutUpdate'; }
}

/**
* Event (Event)
*/
// @Route("/opms/event/{Id}", "DELETE")
// @Api(Description="Event (Event)")
// @ApiResponse(Description="Event (Event) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event (Event) Delete Single By ID: Event Id was not provided.", StatusCode=400)
export class EventDeleteSingleById implements IReturn<EventSingleDeleteResponse>, IEventDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<EventDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventSingleDeleteResponse(); }
    public getTypeName() { return 'EventDeleteSingleById'; }
}

/**
* Event (Event)
*/
// @Route("/opms/event/{PatientId}/{InstitutionId}/{EventTypeId}/{EventRepeat}", "DELETE")
// @Route("/opms/event/{PatientId}/{InstitutionId}/{EventTypeId}", "DELETE")
// @Api(Description="Event (Event)")
export class EventDeleteSingleByContext implements IReturn<EventSingleDeleteResponse>, IEventDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;

    public constructor(init?: Partial<EventDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventSingleDeleteResponse(); }
    public getTypeName() { return 'EventDeleteSingleByContext'; }
}

/**
* EventType (EventType)
*/
// @Route("/opms/event-type/create", "GET")
// @Api(Description="EventType (EventType)")
// @ApiResponse(Description="Event Type (EventType) Get Single New: Request not provided.", StatusCode=400)
export class EventTypeGetSingleNew implements IReturn<EventTypeSingleResponse>, IEventTypeGetSingleNew, IGet
{

    public constructor(init?: Partial<EventTypeGetSingleNew>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeSingleResponse(); }
    public getTypeName() { return 'EventTypeGetSingleNew'; }
}

/**
* Event Type (EventType)
*/
// @Route("/opms/event-type/{Id}", "GET")
// @Api(Description="Event Type (EventType)")
// @ApiResponse(Description="Event Type (EventType) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type (EventType) Get Single By ID: Event Type Id was not provided.", StatusCode=400)
export class EventTypeGetSingleById implements IReturn<EventTypeSingleResponse>, IEventTypeGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<EventTypeGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeSingleResponse(); }
    public getTypeName() { return 'EventTypeGetSingleById'; }
}

/**
* Event Type (EventType)
*/
// @Route("/opms/event-type/by-code/{Code}", "GET")
// @Api(Description="Event Type (EventType)")
// @ApiResponse(Description="Event Type (EventType) Get Single By Code: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type (EventType) Get Single By Code: Event Type Code was not provided.", StatusCode=400)
export class EventTypeGetSingleByCode implements IReturn<EventTypeSingleResponse>, IEventTypeGetSingleByCode, IGet
{
    public eventTypeCode: string;

    public constructor(init?: Partial<EventTypeGetSingleByCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeSingleResponse(); }
    public getTypeName() { return 'EventTypeGetSingleByCode'; }
}

/**
* Event Type (EventType)
*/
// @Route("/opms/event-types", "GET")
// @Api(Description="Event Type (EventType)")
export class EventTypeGetCollection implements IReturn<EventTypeCollectionResponse>, IEventTypeGetCollection, IGet
{

    public constructor(init?: Partial<EventTypeGetCollection>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeCollectionResponse(); }
    public getTypeName() { return 'EventTypeGetCollection'; }
}

/**
* Event Type (EventType)
*/
// @Route("/opms/event-type", "POST")
// @Api(Description="Event Type (EventType)")
// @ApiResponse(Description="Event Type (EventType) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type (EventType) Post Insert: Event Type was not provided.", StatusCode=400)
export class EventTypePostInsert implements IReturn<EventTypeSingleResponse>, IPost
{
    public eventType: EventType;

    public constructor(init?: Partial<EventTypePostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeSingleResponse(); }
    public getTypeName() { return 'EventTypePostInsert'; }
}

/**
* Event Type (EventType)
*/
// @Route("/opms/event-type/{Id}", "PUT")
// @Api(Description="Event Type (EventType)")
// @ApiResponse(Description="Event Type (EventType) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type (EventType) Put Update: Event Type ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type (EventType) Put Update: Event Type was not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type (EventType) Put Update: Event Type ID does not match location.", StatusCode=400)
export class EventTypePutUpdate implements IReturn<EventTypeSingleResponse>, IPut
{
    public id?: number;
    public eventType: EventType;

    public constructor(init?: Partial<EventTypePutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeSingleResponse(); }
    public getTypeName() { return 'EventTypePutUpdate'; }
}

/**
* Event Type (EventType)
*/
// @Route("/opms/event-type/{Id}", "DELETE")
// @Api(Description="Event Type (EventType)")
// @ApiResponse(Description="Event Type (EventType) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type (EventType) Delete Single By ID: Event Type Id was not provided.", StatusCode=400)
export class EventTypeDeleteSingleById implements IReturn<EventTypeSingleDeleteResponse>, IEventTypeDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<EventTypeDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeSingleDeleteResponse(); }
    public getTypeName() { return 'EventTypeDeleteSingleById'; }
}

/**
* Event Type (EventType)
*/
// @Route("/opms/eventType/by-code/{EventTypeCode}", "DELETE")
// @Api(Description="Event Type (EventType)")
// @ApiResponse(Description="Event Type (EventType) Delete Single By Code: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type (EventType) Delete Single By Code: Event Type Code was not provided.", StatusCode=400)
export class EventTypeDeleteSingleByCode implements IReturn<EventTypeSingleDeleteResponse>, IEventTypeDeleteSingleByCode, IDelete
{
    public eventTypeCode: string;

    public constructor(init?: Partial<EventTypeDeleteSingleByCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeSingleDeleteResponse(); }
    public getTypeName() { return 'EventTypeDeleteSingleByCode'; }
}

/**
* Event Type (EventType)
*/
// @Route("/opms/event-type", "DELETE")
// @Api(Description="Event Type (EventType)")
// @ApiResponse(Description="Event Type (EventType) Delete Single: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type (EventType) Delete Single: Event Type was not provided.", StatusCode=400)
export class EventTypeDeleteSingle implements IReturn<EventTypeSingleDeleteResponse>, IDelete
{
    public eventType: EventType;

    public constructor(init?: Partial<EventTypeDeleteSingle>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeSingleDeleteResponse(); }
    public getTypeName() { return 'EventTypeDeleteSingle'; }
}

/**
* Event Type State (EventTypeState)
*/
// @Route("/opms/event-type-state/{Id}", "GET")
// @Api(Description="Event Type State (EventTypeState)")
// @ApiResponse(Description="Event Type State (EventTypeState) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type State (EventTypeState) Get Single By ID: Event Type State Id was not provided.", StatusCode=400)
export class EventTypeStateGetSingleById implements IReturn<EventTypeStateSingleResponse>, IEventTypeStateGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<EventTypeStateGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeStateSingleResponse(); }
    public getTypeName() { return 'EventTypeStateGetSingleById'; }
}

/**
* Event Type State (EventTypeState)
*/
// @Route("/opms/event-type-state/by-event-type/{EventTypeId}", "GET")
// @Api(Description="Event Type State (EventTypeState)")
export class EventTypeStateGetCollectionByEventTypeId implements IReturn<EventTypeStateCollectionResponse>, IEventTypeStateGetCollectionByEventTypeId, IGet
{
    public eventTypeId?: number;

    public constructor(init?: Partial<EventTypeStateGetCollectionByEventTypeId>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeStateCollectionResponse(); }
    public getTypeName() { return 'EventTypeStateGetCollectionByEventTypeId'; }
}

/**
* Event Type State (EventTypeState)
*/
// @Route("/opms/event-type-state", "POST")
// @Api(Description="Event Type State (EventTypeState)")
// @ApiResponse(Description="Event Type State (EventTypeState) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type State (EventTypeState) Post Insert: Event Type State was not provided.", StatusCode=400)
export class EventTypeStatePostInsert implements IReturn<EventTypeStateSingleResponse>, IPost
{
    public eventTypeState: EventTypeState;

    public constructor(init?: Partial<EventTypeStatePostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeStateSingleResponse(); }
    public getTypeName() { return 'EventTypeStatePostInsert'; }
}

/**
* Event Type State (EventTypeState)
*/
// @Route("/opms/event-type-state/{Id}", "PUT")
// @Api(Description="Event Type State (EventTypeState)")
// @ApiResponse(Description="Event Type State (EventTypeState) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type State (EventTypeState) Put Update: Event Type State ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type State (EventTypeState) Put Update: Event Type State was not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type State (EventTypeState) Put Update: Event Type State ID does not match location.", StatusCode=400)
export class EventTypeStatePutUpdate implements IReturn<EventTypeStateSingleResponse>, IPut
{
    public id?: number;
    public eventTypeState: EventTypeState;

    public constructor(init?: Partial<EventTypeStatePutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeStateSingleResponse(); }
    public getTypeName() { return 'EventTypeStatePutUpdate'; }
}

/**
* Event Type State (EventTypeState)
*/
// @Route("/opms/event-type-state/{Id}", "DELETE")
// @Api(Description="Event Type State (EventTypeState)")
// @ApiResponse(Description="Event Type State (EventTypeState) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type State (EventTypeState) Delete Single By ID: Event Type State Id was not provided.", StatusCode=400)
export class EventTypeStateDeleteSingleById implements IReturn<EventTypeStateSingleDeleteResponse>, IEventTypeStateDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<EventTypeStateDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeStateSingleDeleteResponse(); }
    public getTypeName() { return 'EventTypeStateDeleteSingleById'; }
}

/**
* Event Type Form Type (EventTypeFormType)
*/
// @Route("/opms/event-type-form-type/{Id}", "GET")
// @Api(Description="Event Type Form Type (EventTypeFormType)")
// @ApiResponse(Description="Event Type Form Type (EventTypeFormType) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type (EventTypeFormType) Get Single By ID: Event Type Form Type Id was not provided.", StatusCode=400)
export class EventTypeFormTypeGetSingleById implements IReturn<EventTypeFormTypeSingleResponse>, IEventTypeFormTypeGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<EventTypeFormTypeGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeSingleResponse(); }
    public getTypeName() { return 'EventTypeFormTypeGetSingleById'; }
}

/**
* Event Type Form Type (EventTypeFormType)
*/
// @Route("/opms/event-type-form-type/by-event-type/{EventTypeId}", "GET")
// @Api(Description="Event Type Form Type (EventTypeFormType)")
export class EventTypeFormTypeGetCollectionByEventTypeId implements IReturn<EventTypeFormTypeCollectionResponse>, IEventTypeFormTypeGetCollectionByEventTypeId, IGet
{
    public eventTypeId?: number;

    public constructor(init?: Partial<EventTypeFormTypeGetCollectionByEventTypeId>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeCollectionResponse(); }
    public getTypeName() { return 'EventTypeFormTypeGetCollectionByEventTypeId'; }
}

/**
* Event Type Form Type (EventTypeFormType)
*/
// @Route("/opms/event-type-form-type", "POST")
// @Api(Description="Event Type Form Type (EventTypeFormType)")
// @ApiResponse(Description="Event Type Form Type (EventTypeFormType) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type (EventTypeFormType) Post Insert: Event Type Form Type was not provided.", StatusCode=400)
export class EventTypeFormTypePostInsert implements IReturn<EventTypeFormTypeSingleResponse>, IPost
{
    public eventTypeFormType: EventTypeFormType;

    public constructor(init?: Partial<EventTypeFormTypePostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeSingleResponse(); }
    public getTypeName() { return 'EventTypeFormTypePostInsert'; }
}

/**
* Event Type Form Type (EventTypeFormType)
*/
// @Route("/opms/event-type-form-type/{Id}", "PUT")
// @Api(Description="Event Type Form Type (EventTypeFormType)")
// @ApiResponse(Description="Event Type Form Type (EventTypeFormType) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type (EventTypeFormType) Put Update: Event Type Form Type ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type (EventTypeFormType) Put Update: Event Type Form Type was not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type (EventTypeFormType) Put Update: Event Type Form Type ID does not match location.", StatusCode=400)
export class EventTypeFormTypePutUpdate implements IReturn<EventTypeFormTypeSingleResponse>, IPut
{
    public id?: number;
    public eventTypeFormType: EventTypeFormType;

    public constructor(init?: Partial<EventTypeFormTypePutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeSingleResponse(); }
    public getTypeName() { return 'EventTypeFormTypePutUpdate'; }
}

/**
* Event Type Form Type (EventTypeFormType)
*/
// @Route("/opms/event-type-form-type/{Id}", "DELETE")
// @Api(Description="Event Type Form Type (EventTypeFormType)")
// @ApiResponse(Description="Event Type Form Type (EventTypeFormType) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type (EventTypeFormType) Delete Single By ID: Event Type Form Type Id was not provided.", StatusCode=400)
export class EventTypeFormTypeDeleteSingleById implements IReturn<EventTypeFormTypeSingleDeleteResponse>, IEventTypeFormTypeDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<EventTypeFormTypeDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeSingleDeleteResponse(); }
    public getTypeName() { return 'EventTypeFormTypeDeleteSingleById'; }
}

/**
* Event Type Form Type State (EventTypeFormTypeState)
*/
// @Route("/opms/event-type-form-type-state/{Id}", "GET")
// @Api(Description="Event Type Form Type State (EventTypeFormTypeState)")
// @ApiResponse(Description="Event Type Form Type State (EventTypeFormTypeState) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State (EventTypeFormTypeState) Get Single By ID: Event Type Form Type State Id was not provided.", StatusCode=400)
export class EventTypeFormTypeStateGetSingleById implements IReturn<EventTypeFormTypeStateSingleResponse>, IEventTypeFormTypeStateGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<EventTypeFormTypeStateGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeStateSingleResponse(); }
    public getTypeName() { return 'EventTypeFormTypeStateGetSingleById'; }
}

/**
* Event Type Form Type State (EventTypeFormTypeState)
*/
// @Route("/opms/event-type-form-type-state/by-event-type-form-type/{EventTypeFormTypeId}", "GET")
// @Api(Description="Event Type Form Type State (EventTypeFormTypeState)")
export class EventTypeFormTypeStateGetCollectionByEventTypeFormTypeId implements IReturn<EventTypeFormTypeStateCollectionResponse>, IEventTypeFormTypeStateGetCollectionByEventTypeFormTypeId, IGet
{
    public eventTypeFormTypeId?: number;

    public constructor(init?: Partial<EventTypeFormTypeStateGetCollectionByEventTypeFormTypeId>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeStateCollectionResponse(); }
    public getTypeName() { return 'EventTypeFormTypeStateGetCollectionByEventTypeFormTypeId'; }
}

/**
* Event Type Form Type State (EventTypeFormTypeState)
*/
// @Route("/opms/event-type-form-type-state", "POST")
// @Api(Description="Event Type Form Type State (EventTypeFormTypeState)")
// @ApiResponse(Description="Event Type Form Type State (EventTypeFormTypeState) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State (EventTypeFormTypeState) Post Insert: Event Type Form Type State was not provided.", StatusCode=400)
export class EventTypeFormTypeStatePostInsert implements IReturn<EventTypeFormTypeStateSingleResponse>, IPost
{
    public eventTypeFormTypeState: EventTypeFormTypeState;

    public constructor(init?: Partial<EventTypeFormTypeStatePostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeStateSingleResponse(); }
    public getTypeName() { return 'EventTypeFormTypeStatePostInsert'; }
}

/**
* Event Type Form Type State (EventTypeFormTypeState)
*/
// @Route("/opms/event-type-form-type-state/{Id}", "PUT")
// @Api(Description="Event Type Form Type State (EventTypeFormTypeState)")
// @ApiResponse(Description="Event Type Form Type State (EventTypeFormTypeState) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State (EventTypeFormTypeState) Put Update: Event Type Form Type State ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State (EventTypeFormTypeState) Put Update: Event Type Form Type State was not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State (EventTypeFormTypeState) Put Update: Event Type Form Type State ID does not match location.", StatusCode=400)
export class EventTypeFormTypeStatePutUpdate implements IReturn<EventTypeFormTypeStateSingleResponse>, IPut
{
    public id?: number;
    public eventTypeFormTypeState: EventTypeFormTypeState;

    public constructor(init?: Partial<EventTypeFormTypeStatePutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeStateSingleResponse(); }
    public getTypeName() { return 'EventTypeFormTypeStatePutUpdate'; }
}

/**
* Event Type Form Type State (EventTypeFormTypeState)
*/
// @Route("/opms/event-type-form-type-state/{Id}", "DELETE")
// @Api(Description="Event Type Form Type State (EventTypeFormTypeState)")
// @ApiResponse(Description="Event Type Form Type State (EventTypeFormTypeState) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State (EventTypeFormTypeState) Delete Single By ID: Event Type Form Type State Id was not provided.", StatusCode=400)
export class EventTypeFormTypeStateDeleteSingleById implements IReturn<EventTypeFormTypeStateSingleDeleteResponse>, IEventTypeFormTypeStateDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<EventTypeFormTypeStateDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeStateSingleDeleteResponse(); }
    public getTypeName() { return 'EventTypeFormTypeStateDeleteSingleById'; }
}

/**
* Event Type Form Type State Validation (EventTypeFormTypeStateValidation)
*/
// @Route("/opms/event-type-form-type-state-validation/{Id}", "GET")
// @Api(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation)")
// @ApiResponse(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation) Get Single By ID: Event Type Form Type State Validation Id was not provided.", StatusCode=400)
export class EventTypeFormTypeStateValidationGetSingleById implements IReturn<EventTypeFormTypeStateValidationSingleResponse>, IEventTypeFormTypeStateValidationGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<EventTypeFormTypeStateValidationGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeStateValidationSingleResponse(); }
    public getTypeName() { return 'EventTypeFormTypeStateValidationGetSingleById'; }
}

/**
* Event Type Form Type State Validation (EventTypeFormTypeStateValidation)
*/
// @Route("/opms/event-type-form-type-state-validation/by-event-type-form-type-state/{EventTypeFormTypeStateId}", "GET")
// @Api(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation)")
export class EventTypeFormTypeStateValidationGetCollectionByEventTypeFormTypeStateId implements IReturn<EventTypeFormTypeStateValidationCollectionResponse>, IEventTypeFormTypeStateValidationGetCollectionByEventTypeFormTypeStateId, IGet
{
    public eventTypeFormTypeStateId?: number;

    public constructor(init?: Partial<EventTypeFormTypeStateValidationGetCollectionByEventTypeFormTypeStateId>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeStateValidationCollectionResponse(); }
    public getTypeName() { return 'EventTypeFormTypeStateValidationGetCollectionByEventTypeFormTypeStateId'; }
}

/**
* Event Type Form Type State Validation (EventTypeFormTypeStateValidation)
*/
// @Route("/opms/event-type-form-type-state-validation", "POST")
// @Api(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation)")
// @ApiResponse(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation) Post Insert: Event Type Form Type State Validation was not provided.", StatusCode=400)
export class EventTypeFormTypeStateValidationPostInsert implements IReturn<EventTypeFormTypeStateValidationSingleResponse>, IPost
{
    public eventTypeFormTypeStateValidation: EventTypeFormTypeStateValidation;

    public constructor(init?: Partial<EventTypeFormTypeStateValidationPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeStateValidationSingleResponse(); }
    public getTypeName() { return 'EventTypeFormTypeStateValidationPostInsert'; }
}

/**
* Event Type Form Type State Validation (EventTypeFormTypeStateValidation)
*/
// @Route("/opms/event-type-form-type-state-validation/{Id}", "PUT")
// @Api(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation)")
// @ApiResponse(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation) Put Update: Event Type Form Type State Validation ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation) Put Update: Event Type Form Type State Validation was not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation) Put Update: Event Type Form Type State Validation ID does not match location.", StatusCode=400)
export class EventTypeFormTypeStateValidationPutUpdate implements IReturn<EventTypeFormTypeStateValidationSingleResponse>, IPut
{
    public id?: number;
    public eventTypeFormTypeStateValidation: EventTypeFormTypeStateValidation;

    public constructor(init?: Partial<EventTypeFormTypeStateValidationPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeStateValidationSingleResponse(); }
    public getTypeName() { return 'EventTypeFormTypeStateValidationPutUpdate'; }
}

/**
* Event Type Form Type State Validation (EventTypeFormTypeStateValidation)
*/
// @Route("/opms/event-type-form-type-state-validation/{Id}", "DELETE")
// @Api(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation)")
// @ApiResponse(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Event Type Form Type State Validation (EventTypeFormTypeStateValidation) Delete Single By ID: Event Type Form Type State Validation Id was not provided.", StatusCode=400)
export class EventTypeFormTypeStateValidationDeleteSingleById implements IReturn<EventTypeFormTypeStateValidationSingleDeleteResponse>, IEventTypeFormTypeStateValidationDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<EventTypeFormTypeStateValidationDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EventTypeFormTypeStateValidationSingleDeleteResponse(); }
    public getTypeName() { return 'EventTypeFormTypeStateValidationDeleteSingleById'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patient/create", "GET")
// @Api(Description="Patient (Patient)")
// @ApiResponse(Description="Patient (Patient) Get Single New: Request not provided.", StatusCode=400)
export class PatientGetSingleNew implements IReturn<PatientSingleResponse>, IPatientGetSingleNew, IGet
{

    public constructor(init?: Partial<PatientGetSingleNew>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientSingleResponse(); }
    public getTypeName() { return 'PatientGetSingleNew'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patient/{Id}", "GET")
// @Api(Description="Patient (Patient)")
// @ApiResponse(Description="Patient (Patient) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Patient (Patient) Get Single By ID: Patient Id was not provided.", StatusCode=400)
export class PatientGetSingleById implements IReturn<PatientSingleResponse>, IPatientGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<PatientGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientSingleResponse(); }
    public getTypeName() { return 'PatientGetSingleById'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patient/by-study-number/{PatientStudyNumber}", "GET")
// @Api(Description="Patient (Patient)")
// @ApiResponse(Description="Patient (Patient) Get Single By Study Number: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Patient (Patient) Get Single By Study Number: Patient Study Number was not provided.", StatusCode=400)
export class PatientGetSingleByStudyNumber implements IReturn<PatientSingleResponse>, IPatientGetSingleByStudyNumber, IGet
{
    public patientStudyNumber: string;

    public constructor(init?: Partial<PatientGetSingleByStudyNumber>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientSingleResponse(); }
    public getTypeName() { return 'PatientGetSingleByStudyNumber'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patients/{InstitutionId}", "GET")
// @Api(Description="Patient (Patient)")
export class PatientGetCollectionByInstitutionId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByInstitutionId, IGet
{
    public institutionId?: number;
    public patientStatus?: number;
    public countryCode: string;
    public treatmentId?: number;

    public constructor(init?: Partial<PatientGetCollectionByInstitutionId>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientCollectionResponse(); }
    public getTypeName() { return 'PatientGetCollectionByInstitutionId'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patients/by-institution-code/{InstitutionCode}", "GET")
// @Api(Description="Patient (Patient)")
export class PatientGetCollectionByInstitutionCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByInstitutionCode, IGet
{
    public institutionCode: string;
    public patientStatus?: number;
    public countryCode: string;
    public treatmentId?: number;

    public constructor(init?: Partial<PatientGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientCollectionResponse(); }
    public getTypeName() { return 'PatientGetCollectionByInstitutionCode'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patients", "GET")
// @Api(Description="Patient (Patient)")
export class PatientGetCollection implements IReturn<PatientCollectionResponse>, IPatientGetCollection, IGet
{
    public patientStatus?: number;
    public countryCode: string;
    public treatmentId?: number;

    public constructor(init?: Partial<PatientGetCollection>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientCollectionResponse(); }
    public getTypeName() { return 'PatientGetCollection'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patient", "POST")
// @Api(Description="Patient (Patient)")
// @ApiResponse(Description="Patient (Patient) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Patient (Patient) Post Insert: Patient was not provided.", StatusCode=400)
export class PatientPostInsert implements IReturn<PatientSingleResponse>, IPost
{
    public patient: Patient;

    public constructor(init?: Partial<PatientPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientSingleResponse(); }
    public getTypeName() { return 'PatientPostInsert'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patient/{Id}", "PUT")
// @Api(Description="Patient (Patient)")
// @ApiResponse(Description="Patient (Patient) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Patient (Patient) Put Update: Patient ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Patient (Patient) Put Update: Patient was not provided.", StatusCode=400)
// @ApiResponse(Description="Patient (Patient) Put Update: Patient ID does not match location.", StatusCode=400)
export class PatientPutUpdate implements IReturn<PatientSingleResponse>, IPut
{
    public id?: number;
    public patient: Patient;

    public constructor(init?: Partial<PatientPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientSingleResponse(); }
    public getTypeName() { return 'PatientPutUpdate'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patient/{Id}", "DELETE")
// @Api(Description="Patient (Patient)")
// @ApiResponse(Description="Patient (Patient) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Patient (Patient) Delete Single By ID: Patient Id was not provided.", StatusCode=400)
export class PatientDeleteSingleById implements IReturn<PatientSingleDeleteResponse>, IPatientDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<PatientDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientSingleDeleteResponse(); }
    public getTypeName() { return 'PatientDeleteSingleById'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patient/by-study-number/{PatientStudyNumber}", "DELETE")
// @Api(Description="Patient (Patient)")
// @ApiResponse(Description="Patient (Patient) Delete Single By StudyNumber: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Patient (Patient) Delete Single By StudyNumber: Patient Study Number was not provided.", StatusCode=400)
export class PatientDeleteSingleByStudyNumber implements IReturn<PatientSingleDeleteResponse>, IPatientDeleteSingleByStudyNumber, IDelete
{
    public patientStudyNumber: string;

    public constructor(init?: Partial<PatientDeleteSingleByStudyNumber>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientSingleDeleteResponse(); }
    public getTypeName() { return 'PatientDeleteSingleByStudyNumber'; }
}

/**
* Patient (Patient)
*/
// @Route("/opms/patient", "DELETE")
// @Api(Description="Patient (Patient)")
// @ApiResponse(Description="Patient (Patient) Delete Single: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Patient (Patient) Delete Single: Patient was not provided.", StatusCode=400)
export class PatientDeleteSingle implements IReturn<PatientSingleDeleteResponse>, IDelete
{
    public patient: Patient;

    public constructor(init?: Partial<PatientDeleteSingle>) { (Object as any).assign(this, init); }
    public createResponse() { return new PatientSingleDeleteResponse(); }
    public getTypeName() { return 'PatientDeleteSingle'; }
}

/**
* Institution (Institution)
*/
// @Route("/opms/institution/create", "GET")
// @Api(Description="Institution (Institution)")
// @ApiResponse(Description="Institution (Institution) Get Single New: Request not provided.", StatusCode=400)
export class InstitutionGetSingleNew implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleNew, IGet
{

    public constructor(init?: Partial<InstitutionGetSingleNew>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionSingleResponse(); }
    public getTypeName() { return 'InstitutionGetSingleNew'; }
}

/**
* Institution (Institution)
*/
// @Route("/opms/institution/{Id}", "GET")
// @Api(Description="Institution (Institution)")
// @ApiResponse(Description="Institution (Institution) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Institution (Institution) Get Single By ID: Institution Id was not provided.", StatusCode=400)
export class InstitutionGetSingleById implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<InstitutionGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionSingleResponse(); }
    public getTypeName() { return 'InstitutionGetSingleById'; }
}

/**
* Institution (Institution)
*/
// @Route("/opms/institution/by-code/{InstitutionCode}", "GET")
// @Api(Description="Institution (Institution)")
// @ApiResponse(Description="Institution (Institution) Get Single By Code: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Institution (Institution) Get Single By Code: Institution Code was not provided.", StatusCode=400)
export class InstitutionGetSingleByCode implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleByCode, IGet
{
    public institutionCode: string;

    public constructor(init?: Partial<InstitutionGetSingleByCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionSingleResponse(); }
    public getTypeName() { return 'InstitutionGetSingleByCode'; }
}

/**
* Institution (Institution)
*/
// @Route("/opms/institutions", "GET")
// @Api(Description="Institution (Institution)")
export class InstitutionGetCollection implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollection, IGet
{

    public constructor(init?: Partial<InstitutionGetCollection>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionCollectionResponse(); }
    public getTypeName() { return 'InstitutionGetCollection'; }
}

/**
* Institution (Institution)
*/
// @Route("/opms/institution", "POST")
// @Api(Description="Institution (Institution)")
// @ApiResponse(Description="Institution (Institution) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Institution (Institution) Post Insert: Institution was not provided.", StatusCode=400)
export class InstitutionPostInsert implements IReturn<InstitutionSingleResponse>, IPost
{
    public institution: Institution;

    public constructor(init?: Partial<InstitutionPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionSingleResponse(); }
    public getTypeName() { return 'InstitutionPostInsert'; }
}

/**
* Institution (Institution)
*/
// @Route("/opms/institution/{Id}", "PUT")
// @Api(Description="Institution (Institution)")
// @ApiResponse(Description="Institution (Institution) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Institution (Institution) Put Update: Institution ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Institution (Institution) Put Update: Institution was not provided.", StatusCode=400)
// @ApiResponse(Description="Institution (Institution) Put Update: Institution ID does not match location.", StatusCode=400)
export class InstitutionPutUpdate implements IReturn<InstitutionSingleResponse>, IPut
{
    public id?: number;
    public institution: Institution;

    public constructor(init?: Partial<InstitutionPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionSingleResponse(); }
    public getTypeName() { return 'InstitutionPutUpdate'; }
}

/**
* Institution (Institution)
*/
// @Route("/opms/institution/{Id}", "DELETE")
// @Api(Description="Institution (Institution)")
// @ApiResponse(Description="Institution (Institution) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Institution (Institution) Delete Single By ID: Institution Id was not provided.", StatusCode=400)
export class InstitutionDeleteSingleById implements IReturn<InstitutionSingleDeleteResponse>, IInstitutionDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<InstitutionDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionSingleDeleteResponse(); }
    public getTypeName() { return 'InstitutionDeleteSingleById'; }
}

/**
* Institution (Institution)
*/
// @Route("/opms/institution/by-code/{InstitutionCode}", "DELETE")
// @Api(Description="Institution (Institution)")
// @ApiResponse(Description="Institution (Institution) Delete Single By Code: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Institution (Institution) Delete Single By Code: Institution Code was not provided.", StatusCode=400)
export class InstitutionDeleteSingleByCode implements IReturn<InstitutionSingleDeleteResponse>, IInstitutionDeleteSingleByCode, IDelete
{
    public institutionCode: string;

    public constructor(init?: Partial<InstitutionDeleteSingleByCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionSingleDeleteResponse(); }
    public getTypeName() { return 'InstitutionDeleteSingleByCode'; }
}

/**
* Institution (Institution)
*/
// @Route("/opms/institution", "DELETE")
// @Api(Description="Institution (Institution)")
// @ApiResponse(Description="Institution (Institution) Delete Single: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Institution (Institution) Delete Single: Institution was not provided.", StatusCode=400)
export class InstitutionDeleteSingle implements IReturn<InstitutionSingleDeleteResponse>, IDelete
{
    public institution: Institution;

    public constructor(init?: Partial<InstitutionDeleteSingle>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionSingleDeleteResponse(); }
    public getTypeName() { return 'InstitutionDeleteSingle'; }
}

/**
* Form Type (FormType)
*/
// @Route("/opms/form-type/lookups/{Id}", "GET")
// @Api(Description="Form Type (FormType)")
// @ApiResponse(Description="Form Type (FormType) Get Lookups: Request not provided.", StatusCode=400)
export class FormTypeGetLookupsById implements IReturn<FormTypeLookupCollectionResponse>, IFormTypeGetLookupsById, IGet
{
    public id?: number;

    public constructor(init?: Partial<FormTypeGetLookupsById>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeLookupCollectionResponse(); }
    public getTypeName() { return 'FormTypeGetLookupsById'; }
}

/**
* Form Type (FormType)
*/
// @Route("/opms/form-type/lookups/by-code/{FormTypeCode}", "GET")
// @Api(Description="Form Type (FormType)")
// @ApiResponse(Description="Form Type (FormType) Get Lookups: Request not provided.", StatusCode=400)
export class FormTypeGetLookupsByCode implements IReturn<FormTypeLookupCollectionResponse>, IFormTypeGetLookupsByCode, IGet
{
    public formTypeCode: string;

    public constructor(init?: Partial<FormTypeGetLookupsByCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeLookupCollectionResponse(); }
    public getTypeName() { return 'FormTypeGetLookupsByCode'; }
}

/**
* FormType (FormType)
*/
// @Route("/opms/form-type/create", "GET")
// @Api(Description="FormType (FormType)")
// @ApiResponse(Description="Form Type (FormType) Get Single New: Request not provided.", StatusCode=400)
export class FormTypeGetSingleNew implements IReturn<FormTypeSingleResponse>, IFormTypeGetSingleNew, IGet
{

    public constructor(init?: Partial<FormTypeGetSingleNew>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeSingleResponse(); }
    public getTypeName() { return 'FormTypeGetSingleNew'; }
}

/**
* Form Type (FormType)
*/
// @Route("/opms/form-type/{Id}", "GET")
// @Api(Description="Form Type (FormType)")
// @ApiResponse(Description="Form Type (FormType) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type (FormType) Get Single By ID: Form Type Id was not provided.", StatusCode=400)
export class FormTypeGetSingleById implements IReturn<FormTypeSingleResponse>, IFormTypeGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<FormTypeGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeSingleResponse(); }
    public getTypeName() { return 'FormTypeGetSingleById'; }
}

/**
* Form Type (FormType)
*/
// @Route("/opms/form-type/by-code/{Code}", "GET")
// @Api(Description="Form Type (FormType)")
// @ApiResponse(Description="Form Type (FormType) Get Single By Code: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type (FormType) Get Single By Code: Form Type Code was not provided.", StatusCode=400)
export class FormTypeGetSingleByCode implements IReturn<FormTypeSingleResponse>, IFormTypeGetSingleByCode, IGet
{
    public formTypeCode: string;

    public constructor(init?: Partial<FormTypeGetSingleByCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeSingleResponse(); }
    public getTypeName() { return 'FormTypeGetSingleByCode'; }
}

/**
* Form Type (FormType)
*/
// @Route("/opms/form-types", "GET")
// @Api(Description="Form Type (FormType)")
export class FormTypeGetCollection implements IReturn<FormTypeCollectionResponse>, IFormTypeGetCollection, IGet
{

    public constructor(init?: Partial<FormTypeGetCollection>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeCollectionResponse(); }
    public getTypeName() { return 'FormTypeGetCollection'; }
}

/**
* Form Type (FormType)
*/
// @Route("/opms/form-type", "POST")
// @Api(Description="Form Type (FormType)")
// @ApiResponse(Description="Form Type (FormType) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type (FormType) Post Insert: Form Type was not provided.", StatusCode=400)
export class FormTypePostInsert implements IReturn<FormTypeSingleResponse>, IPost
{
    public formType: FormType;

    public constructor(init?: Partial<FormTypePostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeSingleResponse(); }
    public getTypeName() { return 'FormTypePostInsert'; }
}

/**
* Form Type (FormType)
*/
// @Route("/opms/form-type/{Id}", "PUT")
// @Api(Description="Form Type (FormType)")
// @ApiResponse(Description="Form Type (FormType) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type (FormType) Put Update: Form Type ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type (FormType) Put Update: Form Type was not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type (FormType) Put Update: Form Type ID does not match location.", StatusCode=400)
export class FormTypePutUpdate implements IReturn<FormTypeSingleResponse>, IPut
{
    public id?: number;
    public formType: FormType;

    public constructor(init?: Partial<FormTypePutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeSingleResponse(); }
    public getTypeName() { return 'FormTypePutUpdate'; }
}

/**
* Form Type (FormType)
*/
// @Route("/opms/form-type/{Id}", "DELETE")
// @Api(Description="Form Type (FormType)")
// @ApiResponse(Description="Form Type (FormType) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type (FormType) Delete Single By ID: Form Type Id was not provided.", StatusCode=400)
export class FormTypeDeleteSingleById implements IReturn<FormTypeSingleDeleteResponse>, IFormTypeDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<FormTypeDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeSingleDeleteResponse(); }
    public getTypeName() { return 'FormTypeDeleteSingleById'; }
}

/**
* Form Type (FormType)
*/
// @Route("/opms/formType/by-code/{FormTypeCode}", "DELETE")
// @Api(Description="Form Type (FormType)")
// @ApiResponse(Description="Form Type (FormType) Delete Single By Code: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type (FormType) Delete Single By Code: Form Type Code was not provided.", StatusCode=400)
export class FormTypeDeleteSingleByCode implements IReturn<FormTypeSingleDeleteResponse>, IFormTypeDeleteSingleByCode, IDelete
{
    public formTypeCode: string;

    public constructor(init?: Partial<FormTypeDeleteSingleByCode>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeSingleDeleteResponse(); }
    public getTypeName() { return 'FormTypeDeleteSingleByCode'; }
}

/**
* Form Type (FormType)
*/
// @Route("/opms/form-type", "DELETE")
// @Api(Description="Form Type (FormType)")
// @ApiResponse(Description="Form Type (FormType) Delete Single: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type (FormType) Delete Single: Form Type was not provided.", StatusCode=400)
export class FormTypeDeleteSingle implements IReturn<FormTypeSingleDeleteResponse>, IDelete
{
    public formType: FormType;

    public constructor(init?: Partial<FormTypeDeleteSingle>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypeSingleDeleteResponse(); }
    public getTypeName() { return 'FormTypeDeleteSingle'; }
}

/**
* Form Type Property (FormTypeProperty)
*/
// @Route("/opms/form-type-property/{Id}", "GET")
// @Api(Description="Form Type Property (FormTypeProperty)")
// @ApiResponse(Description="Form Type Property (FormTypeProperty) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property (FormTypeProperty) Get Single By ID: Form Type Property Id was not provided.", StatusCode=400)
export class FormTypePropertyGetSingleById implements IReturn<FormTypePropertySingleResponse>, IFormTypePropertyGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<FormTypePropertyGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypePropertySingleResponse(); }
    public getTypeName() { return 'FormTypePropertyGetSingleById'; }
}

/**
* Form Type Property (FormTypeProperty)
*/
// @Route("/opms/form-type-property/by-form-type/{FormTypeId}", "GET")
// @Api(Description="Form Type Property (FormTypeProperty)")
export class FormTypePropertyGetCollectionByFormTypeId implements IReturn<FormTypePropertyCollectionResponse>, IFormTypePropertyGetCollectionByFormTypeId, IGet
{
    public formTypeId?: number;

    public constructor(init?: Partial<FormTypePropertyGetCollectionByFormTypeId>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypePropertyCollectionResponse(); }
    public getTypeName() { return 'FormTypePropertyGetCollectionByFormTypeId'; }
}

/**
* Form Type Property (FormTypeProperty)
*/
// @Route("/opms/form-type-property", "POST")
// @Api(Description="Form Type Property (FormTypeProperty)")
// @ApiResponse(Description="Form Type Property (FormTypeProperty) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property (FormTypeProperty) Post Insert: Form Type Property was not provided.", StatusCode=400)
export class FormTypePropertyPostInsert implements IReturn<FormTypePropertySingleResponse>, IPost
{
    public formTypeProperty: FormTypeProperty;

    public constructor(init?: Partial<FormTypePropertyPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypePropertySingleResponse(); }
    public getTypeName() { return 'FormTypePropertyPostInsert'; }
}

/**
* Form Type Property (FormTypeProperty)
*/
// @Route("/opms/form-type-property/{Id}", "PUT")
// @Api(Description="Form Type Property (FormTypeProperty)")
// @ApiResponse(Description="Form Type Property (FormTypeProperty) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property (FormTypeProperty) Put Update: Form Type Property ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property (FormTypeProperty) Put Update: Form Type Property was not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property (FormTypeProperty) Put Update: Form Type Property ID does not match location.", StatusCode=400)
export class FormTypePropertyPutUpdate implements IReturn<FormTypePropertySingleResponse>, IPut
{
    public id?: number;
    public formTypeProperty: FormTypeProperty;

    public constructor(init?: Partial<FormTypePropertyPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypePropertySingleResponse(); }
    public getTypeName() { return 'FormTypePropertyPutUpdate'; }
}

/**
* Form Type Property (FormTypeProperty)
*/
// @Route("/opms/form-type-property/{Id}", "DELETE")
// @Api(Description="Form Type Property (FormTypeProperty)")
// @ApiResponse(Description="Form Type Property (FormTypeProperty) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property (FormTypeProperty) Delete Single By ID: Form Type Property Id was not provided.", StatusCode=400)
export class FormTypePropertyDeleteSingleById implements IReturn<FormTypePropertySingleDeleteResponse>, IFormTypePropertyDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<FormTypePropertyDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypePropertySingleDeleteResponse(); }
    public getTypeName() { return 'FormTypePropertyDeleteSingleById'; }
}

/**
* Form Type Property Error Message (FormTypePropertyErrorMessage)
*/
// @Route("/opms/form-type-property-error-message/{Id}", "GET")
// @Api(Description="Form Type Property Error Message (FormTypePropertyErrorMessage)")
// @ApiResponse(Description="Form Type Property Error Message (FormTypePropertyErrorMessage) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property Error Message (FormTypePropertyErrorMessage) Get Single By ID: Form Type Property Error Message Id was not provided.", StatusCode=400)
export class FormTypePropertyErrorMessageGetSingleById implements IReturn<FormTypePropertyErrorMessageSingleResponse>, IFormTypePropertyErrorMessageGetSingleById, IGet
{
    public id?: number;

    public constructor(init?: Partial<FormTypePropertyErrorMessageGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypePropertyErrorMessageSingleResponse(); }
    public getTypeName() { return 'FormTypePropertyErrorMessageGetSingleById'; }
}

/**
* Form Type Property Error Message (FormTypePropertyErrorMessage)
*/
// @Route("/opms/form-type-property-error-message/by-form-type-property/{FormTypePropertyId}", "GET")
// @Api(Description="Form Type Property Error Message (FormTypePropertyErrorMessage)")
export class FormTypePropertyErrorMessageGetCollectionByFormTypePropertyId implements IReturn<FormTypePropertyErrorMessageCollectionResponse>, IFormTypePropertyErrorMessageGetCollectionByFormTypePropertyId, IGet
{
    public formTypePropertyId?: number;

    public constructor(init?: Partial<FormTypePropertyErrorMessageGetCollectionByFormTypePropertyId>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypePropertyErrorMessageCollectionResponse(); }
    public getTypeName() { return 'FormTypePropertyErrorMessageGetCollectionByFormTypePropertyId'; }
}

/**
* Form Type Property Error Message (FormTypePropertyErrorMessage)
*/
// @Route("/opms/form-type-property-error-message", "POST")
// @Api(Description="Form Type Property Error Message (FormTypePropertyErrorMessage)")
// @ApiResponse(Description="Form Type Property Error Message (FormTypePropertyErrorMessage) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property Error Message (FormTypePropertyErrorMessage) Post Insert: Form Type Property Error Message was not provided.", StatusCode=400)
export class FormTypePropertyErrorMessagePostInsert implements IReturn<FormTypePropertyErrorMessageSingleResponse>, IPost
{
    public formTypePropertyErrorMessage: FormTypePropertyErrorMessage;

    public constructor(init?: Partial<FormTypePropertyErrorMessagePostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypePropertyErrorMessageSingleResponse(); }
    public getTypeName() { return 'FormTypePropertyErrorMessagePostInsert'; }
}

/**
* Form Type Property Error Message (FormTypePropertyErrorMessage)
*/
// @Route("/opms/form-type-property-error-message/{Id}", "PUT")
// @Api(Description="Form Type Property Error Message (FormTypePropertyErrorMessage)")
// @ApiResponse(Description="Form Type Property Error Message (FormTypePropertyErrorMessage) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property Error Message (FormTypePropertyErrorMessage) Put Update: Form Type Property Error Message ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property Error Message (FormTypePropertyErrorMessage) Put Update: Form Type Property Error Message was not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property Error Message (FormTypePropertyErrorMessage) Put Update: Form Type Property Error Message ID does not match location.", StatusCode=400)
export class FormTypePropertyErrorMessagePutUpdate implements IReturn<FormTypePropertyErrorMessageSingleResponse>, IPut
{
    public id?: number;
    public formTypePropertyErrorMessage: FormTypePropertyErrorMessage;

    public constructor(init?: Partial<FormTypePropertyErrorMessagePutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypePropertyErrorMessageSingleResponse(); }
    public getTypeName() { return 'FormTypePropertyErrorMessagePutUpdate'; }
}

/**
* Form Type Property Error Message (FormTypePropertyErrorMessage)
*/
// @Route("/opms/form-type-property-error-message/{Id}", "DELETE")
// @Api(Description="Form Type Property Error Message (FormTypePropertyErrorMessage)")
// @ApiResponse(Description="Form Type Property Error Message (FormTypePropertyErrorMessage) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form Type Property Error Message (FormTypePropertyErrorMessage) Delete Single By ID: Form Type Property Error Message Id was not provided.", StatusCode=400)
export class FormTypePropertyErrorMessageDeleteSingleById implements IReturn<FormTypePropertyErrorMessageSingleDeleteResponse>, IFormTypePropertyErrorMessageDeleteSingleById, IDelete
{
    public id?: number;

    public constructor(init?: Partial<FormTypePropertyErrorMessageDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new FormTypePropertyErrorMessageSingleDeleteResponse(); }
    public getTypeName() { return 'FormTypePropertyErrorMessageDeleteSingleById'; }
}

// @Route("/opms/type-mapping", "GET")
export class GetOpmsTypeMapping implements IReturn<GetOpmsTypeMappingResponse>
{

    public constructor(init?: Partial<GetOpmsTypeMapping>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetOpmsTypeMappingResponse(); }
    public getTypeName() { return 'GetOpmsTypeMapping'; }
}

// @Route("/api/file/temp/upload", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class UploadTempFile implements IReturn<UploadTempFileResponse>
{
    public json: boolean;

    public constructor(init?: Partial<UploadTempFile>) { (Object as any).assign(this, init); }
    public createResponse() { return new UploadTempFileResponse(); }
    public getTypeName() { return 'UploadTempFile'; }
}

// @Route("/api/file/temp/info/{Guid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTempFileInfo implements IReturn<GetTempFileInfoResponse>
{
    /**
    * The Guid (name) of the temporary file to retrieve
    */
    // @ApiMember(DataType="string", Description="The Guid (name) of the temporary file to retrieve", IsRequired=true, Name="Guid", ParameterType="path")
    public guid: string;

    public constructor(init?: Partial<GetTempFileInfo>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTempFileInfoResponse(); }
    public getTypeName() { return 'GetTempFileInfo'; }
}

// @Route("/api/file/temp/get/{Guid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTempFile
{
    /**
    * The Guid (name) of the temporary file to retrieve
    */
    // @ApiMember(DataType="string", Description="The Guid (name) of the temporary file to retrieve", IsRequired=true, Name="Guid", ParameterType="path")
    public guid: string;

    public constructor(init?: Partial<GetTempFile>) { (Object as any).assign(this, init); }
}

// @Route("/api/file/temp/download/{Guid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DownloadTempFile
{
    /**
    * The Guid (name) of the temporary file to retrieve
    */
    // @ApiMember(DataType="string", Description="The Guid (name) of the temporary file to retrieve", IsRequired=true, Name="Guid", ParameterType="path")
    public guid: string;

    public constructor(init?: Partial<DownloadTempFile>) { (Object as any).assign(this, init); }
}

// @Route("/source-document/{Id}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetSourceDocumentFile
{
    /**
    * The Id of the source document
    */
    // @ApiMember(DataType="integer", Description="The Id of the source document", Format="int", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetSourceDocumentFile>) { (Object as any).assign(this, init); }
}

// @Route("/source-document/download/{Id}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DownloadSourceDocumentFile
{
    /**
    * The Id of the source document
    */
    // @ApiMember(DataType="integer", Description="The Id of the source document", Format="int", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DownloadSourceDocumentFile>) { (Object as any).assign(this, init); }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/concomitant-medication/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (ConcomitantMedication)")
export class ConcomitantMedicationCreateSingleByContext implements IReturn<ConcomitantMedicationSingleResponse>, IFormGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<ConcomitantMedicationCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationSingleResponse(); }
    public getTypeName() { return 'ConcomitantMedicationCreateSingleByContext'; }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/{Id}", "GET")
// @Api(Description="Form (ConcomitantMedication)")
// @ApiResponse(Description="Form (ConcomitantMedication) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (ConcomitantMedication) Get Single By ID: Form Id was not provided.", StatusCode=400)
export class ConcomitantMedicationGetSingleById implements IReturn<ConcomitantMedicationSingleResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<ConcomitantMedicationGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationSingleResponse(); }
    public getTypeName() { return 'ConcomitantMedicationGetSingleById'; }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/concomitant-medication/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (ConcomitantMedication)")
export class ConcomitantMedicationGetSingleByContext implements IReturn<ConcomitantMedicationSingleResponse>, IFormGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<ConcomitantMedicationGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationSingleResponse(); }
    public getTypeName() { return 'ConcomitantMedicationGetSingleByContext'; }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}", "GET")
// @Route("/opms/concomitant-medication/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}", "GET")
// @Api(Description="Form (ConcomitantMedication)")
export class ConcomitantMedicationGetCollectionByContext implements IReturn<ConcomitantMedicationCollectionResponse>, IFormGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<ConcomitantMedicationGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationCollectionResponse(); }
    public getTypeName() { return 'ConcomitantMedicationGetCollectionByContext'; }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/validation/{Id}", "GET")
// @Api(Description="Form (ConcomitantMedication)")
// @ApiResponse(Description="Form (ConcomitantMedication) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (ConcomitantMedication) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class ConcomitantMedicationGetValidationById implements IReturn<ConcomitantMedicationSingleValidationResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<ConcomitantMedicationGetValidationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationSingleValidationResponse(); }
    public getTypeName() { return 'ConcomitantMedicationGetValidationById'; }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/concomitant-medication/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (ConcomitantMedication)")
// @ApiResponse(Description="Form (ConcomitantMedication) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (ConcomitantMedication) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class ConcomitantMedicationGetValidationByContext implements IReturn<ConcomitantMedicationSingleValidationResponse>, IFormGetValidationByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<ConcomitantMedicationGetValidationByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationSingleValidationResponse(); }
    public getTypeName() { return 'ConcomitantMedicationGetValidationByContext'; }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/concomitant-medication/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (ConcomitantMedication)")
// @ApiResponse(Description="Form (ConcomitantMedication) Post Validate: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (ConcomitantMedication) Post Validate: Form was not provided.", StatusCode=400)
export class ConcomitantMedicationPostValidation implements IReturn<ConcomitantMedicationSingleValidationResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: ConcomitantMedication;

    public constructor(init?: Partial<ConcomitantMedicationPostValidation>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationSingleValidationResponse(); }
    public getTypeName() { return 'ConcomitantMedicationPostValidation'; }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/concomitant-medication/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (ConcomitantMedication)")
// @ApiResponse(Description="Form (ConcomitantMedication) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (ConcomitantMedication) Post Insert: Form was not provided.", StatusCode=400)
export class ConcomitantMedicationPostInsert implements IReturn<ConcomitantMedicationSingleResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: ConcomitantMedication;

    public constructor(init?: Partial<ConcomitantMedicationPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationSingleResponse(); }
    public getTypeName() { return 'ConcomitantMedicationPostInsert'; }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/{Id}", "PUT")
// @Api(Description="Form (ConcomitantMedication)")
// @ApiResponse(Description="Form (ConcomitantMedication) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (ConcomitantMedication) Put Update: Form ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (ConcomitantMedication) Put Update: Form was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (ConcomitantMedication) Put Update: Form ID does not match location.", StatusCode=400)
export class ConcomitantMedicationPutUpdate implements IReturn<ConcomitantMedicationSingleResponse>, IPut
{
    public id?: number;
    public form: ConcomitantMedication;

    public constructor(init?: Partial<ConcomitantMedicationPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationSingleResponse(); }
    public getTypeName() { return 'ConcomitantMedicationPutUpdate'; }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/{Id}", "DELETE")
// @Api(Description="Form (ConcomitantMedication)")
// @ApiResponse(Description="Form (ConcomitantMedication) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (ConcomitantMedication) Delete Single By ID: Form Id was not provided.", StatusCode=400)
export class ConcomitantMedicationDeleteSingleById implements IReturn<ConcomitantMedicationSingleDeleteResponse>, IDelete
{
    public id?: number;

    public constructor(init?: Partial<ConcomitantMedicationDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationSingleDeleteResponse(); }
    public getTypeName() { return 'ConcomitantMedicationDeleteSingleById'; }
}

/**
* Form (ConcomitantMedication)
*/
// @Route("/opms/concomitant-medication/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "DELETE")
// @Route("/opms/concomitant-medication/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "DELETE")
// @Api(Description="Form (ConcomitantMedication)")
export class ConcomitantMedicationDeleteSingleByContext implements IReturn<ConcomitantMedicationSingleDeleteResponse>, IFormDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<ConcomitantMedicationDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConcomitantMedicationSingleDeleteResponse(); }
    public getTypeName() { return 'ConcomitantMedicationDeleteSingleByContext'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/diagnostic-and-pathology-data/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (DiagnosticAndPathologyData)")
export class DiagnosticAndPathologyDataCreateSingleByContext implements IReturn<DiagnosticAndPathologyDataSingleResponse>, IFormGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<DiagnosticAndPathologyDataCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataSingleResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataCreateSingleByContext'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/{Id}", "GET")
// @Api(Description="Form (DiagnosticAndPathologyData)")
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Get Single By ID: Form Id was not provided.", StatusCode=400)
export class DiagnosticAndPathologyDataGetSingleById implements IReturn<DiagnosticAndPathologyDataSingleResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<DiagnosticAndPathologyDataGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataSingleResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataGetSingleById'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/diagnostic-and-pathology-data/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (DiagnosticAndPathologyData)")
export class DiagnosticAndPathologyDataGetSingleByContext implements IReturn<DiagnosticAndPathologyDataSingleResponse>, IFormGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<DiagnosticAndPathologyDataGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataSingleResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataGetSingleByContext'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}", "GET")
// @Route("/opms/diagnostic-and-pathology-data/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}", "GET")
// @Api(Description="Form (DiagnosticAndPathologyData)")
export class DiagnosticAndPathologyDataGetCollectionByContext implements IReturn<DiagnosticAndPathologyDataCollectionResponse>, IFormGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<DiagnosticAndPathologyDataGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataCollectionResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataGetCollectionByContext'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/validation/{Id}", "GET")
// @Api(Description="Form (DiagnosticAndPathologyData)")
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class DiagnosticAndPathologyDataGetValidationById implements IReturn<DiagnosticAndPathologyDataSingleValidationResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<DiagnosticAndPathologyDataGetValidationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataSingleValidationResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataGetValidationById'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/diagnostic-and-pathology-data/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (DiagnosticAndPathologyData)")
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class DiagnosticAndPathologyDataGetValidationByContext implements IReturn<DiagnosticAndPathologyDataSingleValidationResponse>, IFormGetValidationByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<DiagnosticAndPathologyDataGetValidationByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataSingleValidationResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataGetValidationByContext'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/diagnostic-and-pathology-data/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (DiagnosticAndPathologyData)")
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Post Validate: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Post Validate: Form was not provided.", StatusCode=400)
export class DiagnosticAndPathologyDataPostValidation implements IReturn<DiagnosticAndPathologyDataSingleValidationResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: DiagnosticAndPathologyData;

    public constructor(init?: Partial<DiagnosticAndPathologyDataPostValidation>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataSingleValidationResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataPostValidation'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/diagnostic-and-pathology-data/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (DiagnosticAndPathologyData)")
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Post Insert: Form was not provided.", StatusCode=400)
export class DiagnosticAndPathologyDataPostInsert implements IReturn<DiagnosticAndPathologyDataSingleResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: DiagnosticAndPathologyData;

    public constructor(init?: Partial<DiagnosticAndPathologyDataPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataSingleResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataPostInsert'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/{Id}", "PUT")
// @Api(Description="Form (DiagnosticAndPathologyData)")
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Put Update: Form ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Put Update: Form was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Put Update: Form ID does not match location.", StatusCode=400)
export class DiagnosticAndPathologyDataPutUpdate implements IReturn<DiagnosticAndPathologyDataSingleResponse>, IPut
{
    public id?: number;
    public form: DiagnosticAndPathologyData;

    public constructor(init?: Partial<DiagnosticAndPathologyDataPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataSingleResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataPutUpdate'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/{Id}", "DELETE")
// @Api(Description="Form (DiagnosticAndPathologyData)")
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticAndPathologyData) Delete Single By ID: Form Id was not provided.", StatusCode=400)
export class DiagnosticAndPathologyDataDeleteSingleById implements IReturn<DiagnosticAndPathologyDataSingleDeleteResponse>, IDelete
{
    public id?: number;

    public constructor(init?: Partial<DiagnosticAndPathologyDataDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataSingleDeleteResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataDeleteSingleById'; }
}

/**
* Form (DiagnosticAndPathologyData)
*/
// @Route("/opms/diagnostic-and-pathology-data/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "DELETE")
// @Route("/opms/diagnostic-and-pathology-data/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "DELETE")
// @Api(Description="Form (DiagnosticAndPathologyData)")
export class DiagnosticAndPathologyDataDeleteSingleByContext implements IReturn<DiagnosticAndPathologyDataSingleDeleteResponse>, IFormDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<DiagnosticAndPathologyDataDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticAndPathologyDataSingleDeleteResponse(); }
    public getTypeName() { return 'DiagnosticAndPathologyDataDeleteSingleByContext'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
export class DiagnosticImagingAndTumourAssessmentCreateSingleByContext implements IReturn<DiagnosticImagingAndTumourAssessmentSingleResponse>, IFormGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentSingleResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentCreateSingleByContext'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{Id}", "GET")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Get Single By ID: Form Id was not provided.", StatusCode=400)
export class DiagnosticImagingAndTumourAssessmentGetSingleById implements IReturn<DiagnosticImagingAndTumourAssessmentSingleResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentSingleResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentGetSingleById'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
export class DiagnosticImagingAndTumourAssessmentGetSingleByContext implements IReturn<DiagnosticImagingAndTumourAssessmentSingleResponse>, IFormGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentSingleResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentGetSingleByContext'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}", "GET")
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}", "GET")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
export class DiagnosticImagingAndTumourAssessmentGetCollectionByContext implements IReturn<DiagnosticImagingAndTumourAssessmentCollectionResponse>, IFormGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentCollectionResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentGetCollectionByContext'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/validation/{Id}", "GET")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class DiagnosticImagingAndTumourAssessmentGetValidationById implements IReturn<DiagnosticImagingAndTumourAssessmentSingleValidationResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentGetValidationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentSingleValidationResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentGetValidationById'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class DiagnosticImagingAndTumourAssessmentGetValidationByContext implements IReturn<DiagnosticImagingAndTumourAssessmentSingleValidationResponse>, IFormGetValidationByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentGetValidationByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentSingleValidationResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentGetValidationByContext'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Post Validate: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Post Validate: Form was not provided.", StatusCode=400)
export class DiagnosticImagingAndTumourAssessmentPostValidation implements IReturn<DiagnosticImagingAndTumourAssessmentSingleValidationResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: DiagnosticImagingAndTumourAssessment;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentPostValidation>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentSingleValidationResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentPostValidation'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Post Insert: Form was not provided.", StatusCode=400)
export class DiagnosticImagingAndTumourAssessmentPostInsert implements IReturn<DiagnosticImagingAndTumourAssessmentSingleResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: DiagnosticImagingAndTumourAssessment;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentSingleResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentPostInsert'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{Id}", "PUT")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Put Update: Form ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Put Update: Form was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Put Update: Form ID does not match location.", StatusCode=400)
export class DiagnosticImagingAndTumourAssessmentPutUpdate implements IReturn<DiagnosticImagingAndTumourAssessmentSingleResponse>, IPut
{
    public id?: number;
    public form: DiagnosticImagingAndTumourAssessment;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentSingleResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentPutUpdate'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{Id}", "DELETE")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (DiagnosticImagingAndTumourAssessment) Delete Single By ID: Form Id was not provided.", StatusCode=400)
export class DiagnosticImagingAndTumourAssessmentDeleteSingleById implements IReturn<DiagnosticImagingAndTumourAssessmentSingleDeleteResponse>, IDelete
{
    public id?: number;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentSingleDeleteResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentDeleteSingleById'; }
}

/**
* Form (DiagnosticImagingAndTumourAssessment)
*/
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "DELETE")
// @Route("/opms/diagnostic-imaging-and-tumour-assessment/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "DELETE")
// @Api(Description="Form (DiagnosticImagingAndTumourAssessment)")
export class DiagnosticImagingAndTumourAssessmentDeleteSingleByContext implements IReturn<DiagnosticImagingAndTumourAssessmentSingleDeleteResponse>, IFormDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<DiagnosticImagingAndTumourAssessmentDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new DiagnosticImagingAndTumourAssessmentSingleDeleteResponse(); }
    public getTypeName() { return 'DiagnosticImagingAndTumourAssessmentDeleteSingleByContext'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/eligibility-checklist/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (EligibilityChecklist)")
export class EligibilityChecklistCreateSingleByContext implements IReturn<EligibilityChecklistSingleResponse>, IFormGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<EligibilityChecklistCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistSingleResponse(); }
    public getTypeName() { return 'EligibilityChecklistCreateSingleByContext'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/{Id}", "GET")
// @Api(Description="Form (EligibilityChecklist)")
// @ApiResponse(Description="Form (EligibilityChecklist) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (EligibilityChecklist) Get Single By ID: Form Id was not provided.", StatusCode=400)
export class EligibilityChecklistGetSingleById implements IReturn<EligibilityChecklistSingleResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<EligibilityChecklistGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistSingleResponse(); }
    public getTypeName() { return 'EligibilityChecklistGetSingleById'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/eligibility-checklist/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (EligibilityChecklist)")
export class EligibilityChecklistGetSingleByContext implements IReturn<EligibilityChecklistSingleResponse>, IFormGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<EligibilityChecklistGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistSingleResponse(); }
    public getTypeName() { return 'EligibilityChecklistGetSingleByContext'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}", "GET")
// @Route("/opms/eligibility-checklist/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}", "GET")
// @Api(Description="Form (EligibilityChecklist)")
export class EligibilityChecklistGetCollectionByContext implements IReturn<EligibilityChecklistCollectionResponse>, IFormGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<EligibilityChecklistGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistCollectionResponse(); }
    public getTypeName() { return 'EligibilityChecklistGetCollectionByContext'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/validation/{Id}", "GET")
// @Api(Description="Form (EligibilityChecklist)")
// @ApiResponse(Description="Form (EligibilityChecklist) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (EligibilityChecklist) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class EligibilityChecklistGetValidationById implements IReturn<EligibilityChecklistSingleValidationResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<EligibilityChecklistGetValidationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistSingleValidationResponse(); }
    public getTypeName() { return 'EligibilityChecklistGetValidationById'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/eligibility-checklist/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (EligibilityChecklist)")
// @ApiResponse(Description="Form (EligibilityChecklist) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (EligibilityChecklist) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class EligibilityChecklistGetValidationByContext implements IReturn<EligibilityChecklistSingleValidationResponse>, IFormGetValidationByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<EligibilityChecklistGetValidationByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistSingleValidationResponse(); }
    public getTypeName() { return 'EligibilityChecklistGetValidationByContext'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/eligibility-checklist/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (EligibilityChecklist)")
// @ApiResponse(Description="Form (EligibilityChecklist) Post Validate: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (EligibilityChecklist) Post Validate: Form was not provided.", StatusCode=400)
export class EligibilityChecklistPostValidation implements IReturn<EligibilityChecklistSingleValidationResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: EligibilityChecklist;

    public constructor(init?: Partial<EligibilityChecklistPostValidation>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistSingleValidationResponse(); }
    public getTypeName() { return 'EligibilityChecklistPostValidation'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/eligibility-checklist/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (EligibilityChecklist)")
// @ApiResponse(Description="Form (EligibilityChecklist) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (EligibilityChecklist) Post Insert: Form was not provided.", StatusCode=400)
export class EligibilityChecklistPostInsert implements IReturn<EligibilityChecklistSingleResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: EligibilityChecklist;

    public constructor(init?: Partial<EligibilityChecklistPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistSingleResponse(); }
    public getTypeName() { return 'EligibilityChecklistPostInsert'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/{Id}", "PUT")
// @Api(Description="Form (EligibilityChecklist)")
// @ApiResponse(Description="Form (EligibilityChecklist) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (EligibilityChecklist) Put Update: Form ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (EligibilityChecklist) Put Update: Form was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (EligibilityChecklist) Put Update: Form ID does not match location.", StatusCode=400)
export class EligibilityChecklistPutUpdate implements IReturn<EligibilityChecklistSingleResponse>, IPut
{
    public id?: number;
    public form: EligibilityChecklist;

    public constructor(init?: Partial<EligibilityChecklistPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistSingleResponse(); }
    public getTypeName() { return 'EligibilityChecklistPutUpdate'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/{Id}", "DELETE")
// @Api(Description="Form (EligibilityChecklist)")
// @ApiResponse(Description="Form (EligibilityChecklist) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (EligibilityChecklist) Delete Single By ID: Form Id was not provided.", StatusCode=400)
export class EligibilityChecklistDeleteSingleById implements IReturn<EligibilityChecklistSingleDeleteResponse>, IDelete
{
    public id?: number;

    public constructor(init?: Partial<EligibilityChecklistDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistSingleDeleteResponse(); }
    public getTypeName() { return 'EligibilityChecklistDeleteSingleById'; }
}

/**
* Form (EligibilityChecklist)
*/
// @Route("/opms/eligibility-checklist/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "DELETE")
// @Route("/opms/eligibility-checklist/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "DELETE")
// @Api(Description="Form (EligibilityChecklist)")
export class EligibilityChecklistDeleteSingleByContext implements IReturn<EligibilityChecklistSingleDeleteResponse>, IFormDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<EligibilityChecklistDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new EligibilityChecklistSingleDeleteResponse(); }
    public getTypeName() { return 'EligibilityChecklistDeleteSingleByContext'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/general/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (General)")
export class GeneralCreateSingleByContext implements IReturn<GeneralSingleResponse>, IFormGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<GeneralCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralSingleResponse(); }
    public getTypeName() { return 'GeneralCreateSingleByContext'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/{Id}", "GET")
// @Api(Description="Form (General)")
// @ApiResponse(Description="Form (General) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (General) Get Single By ID: Form Id was not provided.", StatusCode=400)
export class GeneralGetSingleById implements IReturn<GeneralSingleResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GeneralGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralSingleResponse(); }
    public getTypeName() { return 'GeneralGetSingleById'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/general/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (General)")
export class GeneralGetSingleByContext implements IReturn<GeneralSingleResponse>, IFormGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<GeneralGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralSingleResponse(); }
    public getTypeName() { return 'GeneralGetSingleByContext'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}", "GET")
// @Route("/opms/general/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}", "GET")
// @Api(Description="Form (General)")
export class GeneralGetCollectionByContext implements IReturn<GeneralCollectionResponse>, IFormGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<GeneralGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralCollectionResponse(); }
    public getTypeName() { return 'GeneralGetCollectionByContext'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/validation/{Id}", "GET")
// @Api(Description="Form (General)")
// @ApiResponse(Description="Form (General) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (General) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class GeneralGetValidationById implements IReturn<GeneralSingleValidationResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GeneralGetValidationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralSingleValidationResponse(); }
    public getTypeName() { return 'GeneralGetValidationById'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/general/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (General)")
// @ApiResponse(Description="Form (General) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (General) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class GeneralGetValidationByContext implements IReturn<GeneralSingleValidationResponse>, IFormGetValidationByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<GeneralGetValidationByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralSingleValidationResponse(); }
    public getTypeName() { return 'GeneralGetValidationByContext'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/general/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (General)")
// @ApiResponse(Description="Form (General) Post Validate: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (General) Post Validate: Form was not provided.", StatusCode=400)
export class GeneralPostValidation implements IReturn<GeneralSingleValidationResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: General;

    public constructor(init?: Partial<GeneralPostValidation>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralSingleValidationResponse(); }
    public getTypeName() { return 'GeneralPostValidation'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/general/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (General)")
// @ApiResponse(Description="Form (General) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (General) Post Insert: Form was not provided.", StatusCode=400)
export class GeneralPostInsert implements IReturn<GeneralSingleResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: General;

    public constructor(init?: Partial<GeneralPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralSingleResponse(); }
    public getTypeName() { return 'GeneralPostInsert'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/{Id}", "PUT")
// @Api(Description="Form (General)")
// @ApiResponse(Description="Form (General) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (General) Put Update: Form ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (General) Put Update: Form was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (General) Put Update: Form ID does not match location.", StatusCode=400)
export class GeneralPutUpdate implements IReturn<GeneralSingleResponse>, IPut
{
    public id?: number;
    public form: General;

    public constructor(init?: Partial<GeneralPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralSingleResponse(); }
    public getTypeName() { return 'GeneralPutUpdate'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/{Id}", "DELETE")
// @Api(Description="Form (General)")
// @ApiResponse(Description="Form (General) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (General) Delete Single By ID: Form Id was not provided.", StatusCode=400)
export class GeneralDeleteSingleById implements IReturn<GeneralSingleDeleteResponse>, IDelete
{
    public id?: number;

    public constructor(init?: Partial<GeneralDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralSingleDeleteResponse(); }
    public getTypeName() { return 'GeneralDeleteSingleById'; }
}

/**
* Form (General)
*/
// @Route("/opms/general/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "DELETE")
// @Route("/opms/general/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "DELETE")
// @Api(Description="Form (General)")
export class GeneralDeleteSingleByContext implements IReturn<GeneralSingleDeleteResponse>, IFormDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<GeneralDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new GeneralSingleDeleteResponse(); }
    public getTypeName() { return 'GeneralDeleteSingleByContext'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/haematology-and-biochemistry/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (HaematologyAndBiochemistry)")
export class HaematologyAndBiochemistryCreateSingleByContext implements IReturn<HaematologyAndBiochemistrySingleResponse>, IFormGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<HaematologyAndBiochemistryCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistrySingleResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryCreateSingleByContext'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/{Id}", "GET")
// @Api(Description="Form (HaematologyAndBiochemistry)")
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Get Single By ID: Form Id was not provided.", StatusCode=400)
export class HaematologyAndBiochemistryGetSingleById implements IReturn<HaematologyAndBiochemistrySingleResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<HaematologyAndBiochemistryGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistrySingleResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryGetSingleById'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/haematology-and-biochemistry/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (HaematologyAndBiochemistry)")
export class HaematologyAndBiochemistryGetSingleByContext implements IReturn<HaematologyAndBiochemistrySingleResponse>, IFormGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<HaematologyAndBiochemistryGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistrySingleResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryGetSingleByContext'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}", "GET")
// @Route("/opms/haematology-and-biochemistry/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}", "GET")
// @Api(Description="Form (HaematologyAndBiochemistry)")
export class HaematologyAndBiochemistryGetCollectionByContext implements IReturn<HaematologyAndBiochemistryCollectionResponse>, IFormGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<HaematologyAndBiochemistryGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistryCollectionResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryGetCollectionByContext'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/validation/{Id}", "GET")
// @Api(Description="Form (HaematologyAndBiochemistry)")
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class HaematologyAndBiochemistryGetValidationById implements IReturn<HaematologyAndBiochemistrySingleValidationResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<HaematologyAndBiochemistryGetValidationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistrySingleValidationResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryGetValidationById'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/haematology-and-biochemistry/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (HaematologyAndBiochemistry)")
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class HaematologyAndBiochemistryGetValidationByContext implements IReturn<HaematologyAndBiochemistrySingleValidationResponse>, IFormGetValidationByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<HaematologyAndBiochemistryGetValidationByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistrySingleValidationResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryGetValidationByContext'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/haematology-and-biochemistry/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (HaematologyAndBiochemistry)")
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Post Validate: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Post Validate: Form was not provided.", StatusCode=400)
export class HaematologyAndBiochemistryPostValidation implements IReturn<HaematologyAndBiochemistrySingleValidationResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: HaematologyAndBiochemistry;

    public constructor(init?: Partial<HaematologyAndBiochemistryPostValidation>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistrySingleValidationResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryPostValidation'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/haematology-and-biochemistry/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (HaematologyAndBiochemistry)")
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Post Insert: Form was not provided.", StatusCode=400)
export class HaematologyAndBiochemistryPostInsert implements IReturn<HaematologyAndBiochemistrySingleResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: HaematologyAndBiochemistry;

    public constructor(init?: Partial<HaematologyAndBiochemistryPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistrySingleResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryPostInsert'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/{Id}", "PUT")
// @Api(Description="Form (HaematologyAndBiochemistry)")
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Put Update: Form ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Put Update: Form was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Put Update: Form ID does not match location.", StatusCode=400)
export class HaematologyAndBiochemistryPutUpdate implements IReturn<HaematologyAndBiochemistrySingleResponse>, IPut
{
    public id?: number;
    public form: HaematologyAndBiochemistry;

    public constructor(init?: Partial<HaematologyAndBiochemistryPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistrySingleResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryPutUpdate'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/{Id}", "DELETE")
// @Api(Description="Form (HaematologyAndBiochemistry)")
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (HaematologyAndBiochemistry) Delete Single By ID: Form Id was not provided.", StatusCode=400)
export class HaematologyAndBiochemistryDeleteSingleById implements IReturn<HaematologyAndBiochemistrySingleDeleteResponse>, IDelete
{
    public id?: number;

    public constructor(init?: Partial<HaematologyAndBiochemistryDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistrySingleDeleteResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryDeleteSingleById'; }
}

/**
* Form (HaematologyAndBiochemistry)
*/
// @Route("/opms/haematology-and-biochemistry/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "DELETE")
// @Route("/opms/haematology-and-biochemistry/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "DELETE")
// @Api(Description="Form (HaematologyAndBiochemistry)")
export class HaematologyAndBiochemistryDeleteSingleByContext implements IReturn<HaematologyAndBiochemistrySingleDeleteResponse>, IFormDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<HaematologyAndBiochemistryDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new HaematologyAndBiochemistrySingleDeleteResponse(); }
    public getTypeName() { return 'HaematologyAndBiochemistryDeleteSingleByContext'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/medical-condition/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (MedicalCondition)")
export class MedicalConditionCreateSingleByContext implements IReturn<MedicalConditionSingleResponse>, IFormGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<MedicalConditionCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionSingleResponse(); }
    public getTypeName() { return 'MedicalConditionCreateSingleByContext'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/{Id}", "GET")
// @Api(Description="Form (MedicalCondition)")
// @ApiResponse(Description="Form (MedicalCondition) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalCondition) Get Single By ID: Form Id was not provided.", StatusCode=400)
export class MedicalConditionGetSingleById implements IReturn<MedicalConditionSingleResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<MedicalConditionGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionSingleResponse(); }
    public getTypeName() { return 'MedicalConditionGetSingleById'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (MedicalCondition)")
export class MedicalConditionGetSingleByContext implements IReturn<MedicalConditionSingleResponse>, IFormGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<MedicalConditionGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionSingleResponse(); }
    public getTypeName() { return 'MedicalConditionGetSingleByContext'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}", "GET")
// @Route("/opms/medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}", "GET")
// @Api(Description="Form (MedicalCondition)")
export class MedicalConditionGetCollectionByContext implements IReturn<MedicalConditionCollectionResponse>, IFormGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<MedicalConditionGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionCollectionResponse(); }
    public getTypeName() { return 'MedicalConditionGetCollectionByContext'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/validation/{Id}", "GET")
// @Api(Description="Form (MedicalCondition)")
// @ApiResponse(Description="Form (MedicalCondition) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalCondition) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class MedicalConditionGetValidationById implements IReturn<MedicalConditionSingleValidationResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<MedicalConditionGetValidationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionSingleValidationResponse(); }
    public getTypeName() { return 'MedicalConditionGetValidationById'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/medical-condition/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (MedicalCondition)")
// @ApiResponse(Description="Form (MedicalCondition) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalCondition) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class MedicalConditionGetValidationByContext implements IReturn<MedicalConditionSingleValidationResponse>, IFormGetValidationByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<MedicalConditionGetValidationByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionSingleValidationResponse(); }
    public getTypeName() { return 'MedicalConditionGetValidationByContext'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/medical-condition/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (MedicalCondition)")
// @ApiResponse(Description="Form (MedicalCondition) Post Validate: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalCondition) Post Validate: Form was not provided.", StatusCode=400)
export class MedicalConditionPostValidation implements IReturn<MedicalConditionSingleValidationResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: MedicalCondition;

    public constructor(init?: Partial<MedicalConditionPostValidation>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionSingleValidationResponse(); }
    public getTypeName() { return 'MedicalConditionPostValidation'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (MedicalCondition)")
// @ApiResponse(Description="Form (MedicalCondition) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalCondition) Post Insert: Form was not provided.", StatusCode=400)
export class MedicalConditionPostInsert implements IReturn<MedicalConditionSingleResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: MedicalCondition;

    public constructor(init?: Partial<MedicalConditionPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionSingleResponse(); }
    public getTypeName() { return 'MedicalConditionPostInsert'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/{Id}", "PUT")
// @Api(Description="Form (MedicalCondition)")
// @ApiResponse(Description="Form (MedicalCondition) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalCondition) Put Update: Form ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalCondition) Put Update: Form was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalCondition) Put Update: Form ID does not match location.", StatusCode=400)
export class MedicalConditionPutUpdate implements IReturn<MedicalConditionSingleResponse>, IPut
{
    public id?: number;
    public form: MedicalCondition;

    public constructor(init?: Partial<MedicalConditionPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionSingleResponse(); }
    public getTypeName() { return 'MedicalConditionPutUpdate'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/{Id}", "DELETE")
// @Api(Description="Form (MedicalCondition)")
// @ApiResponse(Description="Form (MedicalCondition) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalCondition) Delete Single By ID: Form Id was not provided.", StatusCode=400)
export class MedicalConditionDeleteSingleById implements IReturn<MedicalConditionSingleDeleteResponse>, IDelete
{
    public id?: number;

    public constructor(init?: Partial<MedicalConditionDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionSingleDeleteResponse(); }
    public getTypeName() { return 'MedicalConditionDeleteSingleById'; }
}

/**
* Form (MedicalCondition)
*/
// @Route("/opms/medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "DELETE")
// @Route("/opms/medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "DELETE")
// @Api(Description="Form (MedicalCondition)")
export class MedicalConditionDeleteSingleByContext implements IReturn<MedicalConditionSingleDeleteResponse>, IFormDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<MedicalConditionDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalConditionSingleDeleteResponse(); }
    public getTypeName() { return 'MedicalConditionDeleteSingleByContext'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/medical-history-and-concomitant-medications/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
export class MedicalHistoryAndConcomitantMedicationsCreateSingleByContext implements IReturn<MedicalHistoryAndConcomitantMedicationsSingleResponse>, IFormGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsSingleResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsCreateSingleByContext'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/{Id}", "GET")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Get Single By ID: Form Id was not provided.", StatusCode=400)
export class MedicalHistoryAndConcomitantMedicationsGetSingleById implements IReturn<MedicalHistoryAndConcomitantMedicationsSingleResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsSingleResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsGetSingleById'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/medical-history-and-concomitant-medications/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
export class MedicalHistoryAndConcomitantMedicationsGetSingleByContext implements IReturn<MedicalHistoryAndConcomitantMedicationsSingleResponse>, IFormGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsSingleResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsGetSingleByContext'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}", "GET")
// @Route("/opms/medical-history-and-concomitant-medications/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}", "GET")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
export class MedicalHistoryAndConcomitantMedicationsGetCollectionByContext implements IReturn<MedicalHistoryAndConcomitantMedicationsCollectionResponse>, IFormGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsCollectionResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsGetCollectionByContext'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/validation/{Id}", "GET")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class MedicalHistoryAndConcomitantMedicationsGetValidationById implements IReturn<MedicalHistoryAndConcomitantMedicationsSingleValidationResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsGetValidationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsSingleValidationResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsGetValidationById'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/medical-history-and-concomitant-medications/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class MedicalHistoryAndConcomitantMedicationsGetValidationByContext implements IReturn<MedicalHistoryAndConcomitantMedicationsSingleValidationResponse>, IFormGetValidationByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsGetValidationByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsSingleValidationResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsGetValidationByContext'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/medical-history-and-concomitant-medications/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Post Validate: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Post Validate: Form was not provided.", StatusCode=400)
export class MedicalHistoryAndConcomitantMedicationsPostValidation implements IReturn<MedicalHistoryAndConcomitantMedicationsSingleValidationResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: MedicalHistoryAndConcomitantMedications;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsPostValidation>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsSingleValidationResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsPostValidation'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/medical-history-and-concomitant-medications/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Post Insert: Form was not provided.", StatusCode=400)
export class MedicalHistoryAndConcomitantMedicationsPostInsert implements IReturn<MedicalHistoryAndConcomitantMedicationsSingleResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: MedicalHistoryAndConcomitantMedications;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsSingleResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsPostInsert'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/{Id}", "PUT")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Put Update: Form ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Put Update: Form was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Put Update: Form ID does not match location.", StatusCode=400)
export class MedicalHistoryAndConcomitantMedicationsPutUpdate implements IReturn<MedicalHistoryAndConcomitantMedicationsSingleResponse>, IPut
{
    public id?: number;
    public form: MedicalHistoryAndConcomitantMedications;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsSingleResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsPutUpdate'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/{Id}", "DELETE")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (MedicalHistoryAndConcomitantMedications) Delete Single By ID: Form Id was not provided.", StatusCode=400)
export class MedicalHistoryAndConcomitantMedicationsDeleteSingleById implements IReturn<MedicalHistoryAndConcomitantMedicationsSingleDeleteResponse>, IDelete
{
    public id?: number;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsSingleDeleteResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsDeleteSingleById'; }
}

/**
* Form (MedicalHistoryAndConcomitantMedications)
*/
// @Route("/opms/medical-history-and-concomitant-medications/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "DELETE")
// @Route("/opms/medical-history-and-concomitant-medications/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "DELETE")
// @Api(Description="Form (MedicalHistoryAndConcomitantMedications)")
export class MedicalHistoryAndConcomitantMedicationsDeleteSingleByContext implements IReturn<MedicalHistoryAndConcomitantMedicationsSingleDeleteResponse>, IFormDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<MedicalHistoryAndConcomitantMedicationsDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new MedicalHistoryAndConcomitantMedicationsSingleDeleteResponse(); }
    public getTypeName() { return 'MedicalHistoryAndConcomitantMedicationsDeleteSingleByContext'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/other-medical-condition/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (OtherMedicalCondition)")
export class OtherMedicalConditionCreateSingleByContext implements IReturn<OtherMedicalConditionSingleResponse>, IFormGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<OtherMedicalConditionCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionSingleResponse(); }
    public getTypeName() { return 'OtherMedicalConditionCreateSingleByContext'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/{Id}", "GET")
// @Api(Description="Form (OtherMedicalCondition)")
// @ApiResponse(Description="Form (OtherMedicalCondition) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (OtherMedicalCondition) Get Single By ID: Form Id was not provided.", StatusCode=400)
export class OtherMedicalConditionGetSingleById implements IReturn<OtherMedicalConditionSingleResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<OtherMedicalConditionGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionSingleResponse(); }
    public getTypeName() { return 'OtherMedicalConditionGetSingleById'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/other-medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (OtherMedicalCondition)")
export class OtherMedicalConditionGetSingleByContext implements IReturn<OtherMedicalConditionSingleResponse>, IFormGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<OtherMedicalConditionGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionSingleResponse(); }
    public getTypeName() { return 'OtherMedicalConditionGetSingleByContext'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}", "GET")
// @Route("/opms/other-medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}", "GET")
// @Api(Description="Form (OtherMedicalCondition)")
export class OtherMedicalConditionGetCollectionByContext implements IReturn<OtherMedicalConditionCollectionResponse>, IFormGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<OtherMedicalConditionGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionCollectionResponse(); }
    public getTypeName() { return 'OtherMedicalConditionGetCollectionByContext'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/validation/{Id}", "GET")
// @Api(Description="Form (OtherMedicalCondition)")
// @ApiResponse(Description="Form (OtherMedicalCondition) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (OtherMedicalCondition) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class OtherMedicalConditionGetValidationById implements IReturn<OtherMedicalConditionSingleValidationResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<OtherMedicalConditionGetValidationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionSingleValidationResponse(); }
    public getTypeName() { return 'OtherMedicalConditionGetValidationById'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/other-medical-condition/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (OtherMedicalCondition)")
// @ApiResponse(Description="Form (OtherMedicalCondition) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (OtherMedicalCondition) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class OtherMedicalConditionGetValidationByContext implements IReturn<OtherMedicalConditionSingleValidationResponse>, IFormGetValidationByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<OtherMedicalConditionGetValidationByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionSingleValidationResponse(); }
    public getTypeName() { return 'OtherMedicalConditionGetValidationByContext'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/other-medical-condition/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (OtherMedicalCondition)")
// @ApiResponse(Description="Form (OtherMedicalCondition) Post Validate: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (OtherMedicalCondition) Post Validate: Form was not provided.", StatusCode=400)
export class OtherMedicalConditionPostValidation implements IReturn<OtherMedicalConditionSingleValidationResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: OtherMedicalCondition;

    public constructor(init?: Partial<OtherMedicalConditionPostValidation>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionSingleValidationResponse(); }
    public getTypeName() { return 'OtherMedicalConditionPostValidation'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/other-medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (OtherMedicalCondition)")
// @ApiResponse(Description="Form (OtherMedicalCondition) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (OtherMedicalCondition) Post Insert: Form was not provided.", StatusCode=400)
export class OtherMedicalConditionPostInsert implements IReturn<OtherMedicalConditionSingleResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: OtherMedicalCondition;

    public constructor(init?: Partial<OtherMedicalConditionPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionSingleResponse(); }
    public getTypeName() { return 'OtherMedicalConditionPostInsert'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/{Id}", "PUT")
// @Api(Description="Form (OtherMedicalCondition)")
// @ApiResponse(Description="Form (OtherMedicalCondition) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (OtherMedicalCondition) Put Update: Form ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (OtherMedicalCondition) Put Update: Form was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (OtherMedicalCondition) Put Update: Form ID does not match location.", StatusCode=400)
export class OtherMedicalConditionPutUpdate implements IReturn<OtherMedicalConditionSingleResponse>, IPut
{
    public id?: number;
    public form: OtherMedicalCondition;

    public constructor(init?: Partial<OtherMedicalConditionPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionSingleResponse(); }
    public getTypeName() { return 'OtherMedicalConditionPutUpdate'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/{Id}", "DELETE")
// @Api(Description="Form (OtherMedicalCondition)")
// @ApiResponse(Description="Form (OtherMedicalCondition) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (OtherMedicalCondition) Delete Single By ID: Form Id was not provided.", StatusCode=400)
export class OtherMedicalConditionDeleteSingleById implements IReturn<OtherMedicalConditionSingleDeleteResponse>, IDelete
{
    public id?: number;

    public constructor(init?: Partial<OtherMedicalConditionDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionSingleDeleteResponse(); }
    public getTypeName() { return 'OtherMedicalConditionDeleteSingleById'; }
}

/**
* Form (OtherMedicalCondition)
*/
// @Route("/opms/other-medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "DELETE")
// @Route("/opms/other-medical-condition/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "DELETE")
// @Api(Description="Form (OtherMedicalCondition)")
export class OtherMedicalConditionDeleteSingleByContext implements IReturn<OtherMedicalConditionSingleDeleteResponse>, IFormDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<OtherMedicalConditionDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new OtherMedicalConditionSingleDeleteResponse(); }
    public getTypeName() { return 'OtherMedicalConditionDeleteSingleByContext'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/preregistration/create/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (Preregistration)")
export class PreregistrationCreateSingleByContext implements IReturn<PreregistrationSingleResponse>, IFormGetSingleNewByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<PreregistrationCreateSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationSingleResponse(); }
    public getTypeName() { return 'PreregistrationCreateSingleByContext'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/{Id}", "GET")
// @Api(Description="Form (Preregistration)")
// @ApiResponse(Description="Form (Preregistration) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (Preregistration) Get Single By ID: Form Id was not provided.", StatusCode=400)
export class PreregistrationGetSingleById implements IReturn<PreregistrationSingleResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<PreregistrationGetSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationSingleResponse(); }
    public getTypeName() { return 'PreregistrationGetSingleById'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/preregistration/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (Preregistration)")
export class PreregistrationGetSingleByContext implements IReturn<PreregistrationSingleResponse>, IFormGetSingleByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public createNonExisting?: boolean;

    public constructor(init?: Partial<PreregistrationGetSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationSingleResponse(); }
    public getTypeName() { return 'PreregistrationGetSingleByContext'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}", "GET")
// @Route("/opms/preregistration/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}", "GET")
// @Api(Description="Form (Preregistration)")
export class PreregistrationGetCollectionByContext implements IReturn<PreregistrationCollectionResponse>, IFormGetCollectionByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<PreregistrationGetCollectionByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationCollectionResponse(); }
    public getTypeName() { return 'PreregistrationGetCollectionByContext'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/validation/{Id}", "GET")
// @Api(Description="Form (Preregistration)")
// @ApiResponse(Description="Form (Preregistration) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (Preregistration) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class PreregistrationGetValidationById implements IReturn<PreregistrationSingleValidationResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<PreregistrationGetValidationById>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationSingleValidationResponse(); }
    public getTypeName() { return 'PreregistrationGetValidationById'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "GET")
// @Route("/opms/preregistration/validation/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "GET")
// @Api(Description="Form (Preregistration)")
// @ApiResponse(Description="Form (Preregistration) Get Validation By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (Preregistration) Get Validation By ID: Form Id was not provided.", StatusCode=400)
export class PreregistrationGetValidationByContext implements IReturn<PreregistrationSingleValidationResponse>, IFormGetValidationByContext, IGet
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<PreregistrationGetValidationByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationSingleValidationResponse(); }
    public getTypeName() { return 'PreregistrationGetValidationByContext'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/preregistration/validate/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (Preregistration)")
// @ApiResponse(Description="Form (Preregistration) Post Validate: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (Preregistration) Post Validate: Form was not provided.", StatusCode=400)
export class PreregistrationPostValidation implements IReturn<PreregistrationSingleValidationResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: Preregistration;

    public constructor(init?: Partial<PreregistrationPostValidation>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationSingleValidationResponse(); }
    public getTypeName() { return 'PreregistrationPostValidation'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "POST")
// @Route("/opms/preregistration/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "POST")
// @Api(Description="Form (Preregistration)")
// @ApiResponse(Description="Form (Preregistration) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (Preregistration) Post Insert: Form was not provided.", StatusCode=400)
export class PreregistrationPostInsert implements IReturn<PreregistrationSingleResponse>, IPost
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;
    public form: Preregistration;

    public constructor(init?: Partial<PreregistrationPostInsert>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationSingleResponse(); }
    public getTypeName() { return 'PreregistrationPostInsert'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/{Id}", "PUT")
// @Api(Description="Form (Preregistration)")
// @ApiResponse(Description="Form (Preregistration) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (Preregistration) Put Update: Form ID was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (Preregistration) Put Update: Form was not provided.", StatusCode=400)
// @ApiResponse(Description="Form (Preregistration) Put Update: Form ID does not match location.", StatusCode=400)
export class PreregistrationPutUpdate implements IReturn<PreregistrationSingleResponse>, IPut
{
    public id?: number;
    public form: Preregistration;

    public constructor(init?: Partial<PreregistrationPutUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationSingleResponse(); }
    public getTypeName() { return 'PreregistrationPutUpdate'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/{Id}", "DELETE")
// @Api(Description="Form (Preregistration)")
// @ApiResponse(Description="Form (Preregistration) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="Form (Preregistration) Delete Single By ID: Form Id was not provided.", StatusCode=400)
export class PreregistrationDeleteSingleById implements IReturn<PreregistrationSingleDeleteResponse>, IDelete
{
    public id?: number;

    public constructor(init?: Partial<PreregistrationDeleteSingleById>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationSingleDeleteResponse(); }
    public getTypeName() { return 'PreregistrationDeleteSingleById'; }
}

/**
* Form (Preregistration)
*/
// @Route("/opms/preregistration/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{ParentFormTypeId}/{ParentFormId}/{FormRepeat}", "DELETE")
// @Route("/opms/preregistration/{PatientId}/{InstitutionId}/{EventId}/{EventTypeId}/{EventRepeat}/{FormRepeat}", "DELETE")
// @Api(Description="Form (Preregistration)")
export class PreregistrationDeleteSingleByContext implements IReturn<PreregistrationSingleDeleteResponse>, IFormDeleteSingleByContext, IDelete
{
    public patientId?: number;
    public institutionId?: number;
    public eventId?: number;
    public eventTypeId?: number;
    public eventRepeat?: number;
    public parentFormTypeId?: number;
    public parentFormId?: number;
    public formRepeat?: number;

    public constructor(init?: Partial<PreregistrationDeleteSingleByContext>) { (Object as any).assign(this, init); }
    public createResponse() { return new PreregistrationSingleDeleteResponse(); }
    public getTypeName() { return 'PreregistrationDeleteSingleByContext'; }
}

export class PostHasOpmsPermissions implements IReturn<HasOpmsPermissionCollectionResponse>
{
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionCode: string;
    public permissions: Permission[];

    public constructor(init?: Partial<PostHasOpmsPermissions>) { (Object as any).assign(this, init); }
    public createResponse() { return new HasOpmsPermissionCollectionResponse(); }
    public getTypeName() { return 'PostHasOpmsPermissions'; }
}

export class GetInstitutionPersonnelNames implements IReturn<InstitutionPersonnelNamesResponse>, IGet
{
    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetInstitutionPersonnelNames>) { (Object as any).assign(this, init); }
    public createResponse() { return new InstitutionPersonnelNamesResponse(); }
    public getTypeName() { return 'GetInstitutionPersonnelNames'; }
}

export class GetTrialPersonnelHasActiveRole implements IReturn<TrialPersonnelActiveRoleResponse>, IGet
{
    public personId: number;
    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetTrialPersonnelHasActiveRole>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrialPersonnelActiveRoleResponse(); }
    public getTypeName() { return 'GetTrialPersonnelHasActiveRole'; }
}

